export default {
  date: {
    formats: {
      short: ''
    }
  },
  buttons: {
    dismiss: 'Dismiss',
    update: 'Update',
    save: 'Save',
    ok: 'OK',
    submit: 'Submit',
    cancel: 'Cancel',
    edit: 'Edit',
    notNow: 'Not Now',
    select: 'Select',
    selectAll: 'Select All',
    connect: 'Connect',
    yes: 'Yes',
    no: 'No',
    send: 'Send',
    done: 'Done',
    loadMore: 'Load More',
    delete: 'Delete',
    show: 'Show',
    sort: 'Move to Reorder',
    close: 'Close',
    process: 'Process',
    copy: 'Copy',
    view: 'View',
    continue: 'Continue',
    setAsDefault: 'Set as Default',
    setAsNotDefault: 'Set as Not Default',
    download: 'Download',
    shareLink: 'Share Link',
    confirm: 'Confirm',
    archive: 'Archive',
    restore: 'Restore',
    apply: 'Apply',
    clear: 'Clear',
    back: 'Back',
    add: 'Add',
    invite: 'Invite',
    create: 'Create',
    reset: 'Reset',
    filters: 'Filters',
    editColumns: 'Edit Columns',
    refund: 'Refund',
    issueRefund: 'Issue Refund',
    export: 'Export',
    doNotSave: 'Don\'t Save',
    upload: 'Upload',
    downloadSample: 'Download Sample',
    clone: 'Clone',
    details: 'Details',
    copyLink: 'Copy Link',
    qrCode: 'QR Code',
    gotIt: 'Got it',
    saveChanges: 'Save Changes',
    clearFilters: 'Clear Filters',
    copyUrl: 'Copy URL',
    change: 'Change',
  },
  select: {
    select: '- Select -',
    none: '- None -',
    search: 'Type to search',
    all: 'All'
  },
  roles: {
    masterAdmin: 'Master Admin',
    tecSupport: 'Technical Support',
    companyAdmin: 'Company Admin',
    divisionAdmin: 'Division Admin',
    communityProjectAdmin: 'Community / Project Admin',
    companyUser: 'Company User',
    salesUser: 'Sales User',
    notificationUser: 'Notification User',
    communityAdmin: 'Community Admin',
    projectAdmin: 'Project Admin'
  },
  webhookEvents: {
    contactCreated: 'Contact Created',
    buildCreated: 'Build Created'
  },
  statuses: {
    unpublished: 'Unpublished',
    published: 'Published',
  },
  projectAvailabilities: {
    underDevelopment: 'Under Development',
    available: 'Available',
    comingSoon: 'Coming Soon',
  },
  projectBuildingAvailabilities: {
    available: 'Available',
    comingSoon: 'Coming Soon',
  },
  floorPlanProviders: {
    ownly: 'Ownly',
    focus360: 'Focus 360'
  },
  lotMapProviders: {
    lotWorks: 'LotWorks',
    focus360: 'Focus 360',
    streetscape: 'Streetscape'
  },
  emailServices: {
    sendGrid: 'SendGrid',
    awsSes: 'AWS SES'
  },
  contractTypes: {
    testing: 'Testing',
    client: 'Client',
    internal: 'Internal'
  },
  contractStages: {
    onboarding: 'Onboarding',
    live: 'Live'
  },
  activityDateGroups: {
    today: 'Today',
    yesterday: 'Yesterday',
    earlierThisWeek: 'Earlier This Week',
    lastWeek: 'Last Week',
    earlierThisMonth: 'Earlier This Month',
    lastMonth: 'Last Month',
    earlierThisYear: 'Earlier This Year',
    lastYear: 'Last Year',
    older: 'Older',
  },
  enums: {
    idDocumentType: {
      nationalIdentityCard: 'ID Card',
      passport: 'Passport',
      bank: 'Bank',
      drivingLicence: 'Driver\'s License',
      driversLicense: 'Driver\'s License',
      voterId: 'Voter ID',
      identityCard: 'Identity Card',
      workPermit: 'Work Permit',
      residencePermit: 'Residence Permit',
      idCard: 'ID Card',
      residencePermitCard: 'Residence Permit Card',
      residentCard: 'Resident Card',
      visa: 'Visa'
    },
    homePriceDisplayMode: {
      totalPriceOnly: 'Display Total Price Only',
      monthlyPaymentAndTotalPrice: 'Display Monthly Payment and Total Price',
      monthlyPaymentOrTotalPrice: 'Display Monthly Payment or Total Price',
      monthlyPaymentOnly: 'Display Monthly Payment Only',
    },
    formMappableFields: {
      firstName: 'First Name',
      lastName: 'Last Name',
      fullName: 'Full Name',
      email: 'Email',
      phone: 'Phone',
      message: 'Message',
      optIn: 'Opt-In',
      isAgent: 'Is Agent'
    },
    currency: {
      usd: 'USD - US Dollar',
      cad: 'CAD - Canadian Dollar'
    },
    floorOptionAvailabilityRule: {
      available: 'Available',
      unavailable: 'Unavailable',
    },
    floorOptionAvailabilityRuleType: {
      communities: 'Communities',
      communityPhases: 'Phases',
    },
    contactStage: {
      lead: 'Lead',
      buyer: 'Buyer',
      closed: 'Closed',
      nonCustomer: 'Non Customer',
    },
    trafficSourceType: {
      direct: 'Direct',
      referral: 'Referral',
      organicSearch: 'Organic Search',
      paidSearch: 'Paid Search',
      socialMedia: 'Social Media',
      email: 'Email',
      other: 'Other'
    },
    searchEngine: {
      google: 'Google',
      brave: 'Brave',
      yahoo: 'Yahoo',
      duckduckgo: 'DuckDuckGo',
      bing: 'Bing'
    },
    socialMedia: {
      facebook: 'Facebook',
      linkedIn: 'LinkedIn',
      instagram: 'Instagram',
      twitter: 'Twitter',
      youtube: 'YouTube'
    },
    idVerificationProvider: {
      onfido: 'Onfido',
      plaid: 'Plaid'
    },
    preApprovalVerificationProvider: {
      homewise: 'Homewise',
      manual: 'Manual'
    },
    bankVerificationProvider: {
      flinks: 'Flinks',
      plaid: 'Plaid',
      plaidIncome: 'Plaid Income',
      inverite: 'Inverite'
    },
    defaultHomePage: {
      myHomes: 'My Homes',
      newHome: 'New Home',
      getVerified: 'Get Verified'
    },
    cookieTrackingScope: {
      domain: 'Per Domain Name',
      hostname: 'Per Host Name',
    },
    customerColumn: {
      status: 'Status',
      buyingPower: 'Buying Power',
      rentalPower: 'Renting Power',
      income: 'Income',
      homeValuation: 'Home Valuation',
      interests: 'Interests',
      priceRange: 'Browsing Price ( Build & Price)',
      preApproval: 'Pre-Approval',
      phone: 'Phone Number',
      region: 'Region',
      assignedTo: 'Assigned to',
      signUpDate: 'Sign-up Date',
      lastActive: 'Last Active'
    },
    customerStatus: {
      accountCreated: 'Account Created',
      idVerified: 'ID Verified',
      financesVerified: 'Income Verified',
      customerVerified: 'Customer Verified',
    },
    customerReservationStatus: {
      offer: 'Reservation Started',
      sign: 'Reservation Form',
      deposit: 'Deposit',
    },
    customerVerificationStatus: {
      idVerification: 'ID Verification',
      incomeVerification: 'Income Verification',
      homeValuationVerification: 'Home Valuation Verification',
    },
    paymentMethod: {
      card: 'Credit Card',
      achDirectDebit: 'ACH'
    },
    salesInviteMethod: {
      email: 'Email',
      sms: 'SMS'
    },
    rentalWorkflowType: {
      idVerification: 'ID Verification',
      payment: 'Payment',
      homeEvaluation: 'Home Evaluation',
      financialVerification: 'Financial Verification',
    },
    verifiedWorkflowType: {
      idVerification: 'ID Verification',
      homeEvaluation: 'Home Evaluation',
      financialVerification: 'Financial Verification',
      preApprovalVerification: 'Pre-Approval Verification'
    },
    teamUserPermission: {
      member: 'Member',
      lead: 'Lead',
      manager: 'Manager',
    },
    interestInteractionType: {
      saved: 'Saved',
      viewed: 'Viewed'
    },
    inventoryAvailability: {
      available: 'Available',
      pending: 'Pending',
      comingSoon: 'Coming Soon',
      notAvailable: 'Not Available',
      sold: 'Sold'
    },
    quickPossessionStatus: {
      unpublished: 'Unpublished',
      published: 'Published',
    },
    quickPossessionColumn: {
      community: 'Community',
      model: 'Model',
      productType: 'Product Type',
      address: 'Address',
      size: 'Size',
      beds: 'Beds',
      baths: 'Baths',
      garages: 'Garages',
      price: 'Price',
      availability: 'Availability',
      status: 'Status',
      interests: 'Interests',
      lastModified: 'Last Modified',
      lastCreated: 'Created At'
    },
    depositStatus: {
      submitted: 'Submitted',
      succeeded: 'Succeeded',
      failed: 'Failed',
      accepted: 'Accepted',
      rejected: 'Rejected'
    },
    refundReasons: {
      dealCompleted: 'Deal Completed',
      dealCanceled: 'Deal Canceled',
      other: 'Other'
    },
    projectBuildAndPriceStartingPoints: {
      model: 'Start from Model Selection',
      unit: 'Start from Unit Selection'
    },
    unitColumn: {
      project: 'Project',
      buildingModel: 'Model',
      suiteNumber: 'Unit Name',
      floor: 'Floor',
      size: 'Size',
      bedrooms: 'Beds',
      bathrooms: 'Baths',
      price: 'Price',
      availability: 'Availability',
      status: 'Status',
      lastModified: 'Last Modified',
      lastCreated: 'Created At'
    },
    unitAvailabilities: {
      available: 'Available',
      pending: 'Pending',
      comingSoon: 'Coming Soon',
      notAvailable: 'Not Available',
      sold: 'Sold'
    },
    unitStatus: {
      unpublished: 'Unpublished',
      published: 'Published',
    },
  },
  weekdays: {
    1: 'Monday',
    2: 'Tuesday',
    3: 'Wednesday',
    4: 'Thursday',
    5: 'Friday',
    6: 'Saturday',
    7: 'Sunday'
  },
  errors: {
    sessionExpired: 'Your session has expired.'
  },
  components: {
    common: {
      listEmpty: {
        index: {
          noData: 'No data to display.'
        }
      },
      reportEmpty: {
        index: {
          noData: 'No data for this report'
        }
      },
      fileUploader: {
        index: {
          dragAndDrop: 'Drag and drop your images here'
        }
      },
      imageUploader: {
        index: {
          clickToUpload: 'Click to upload',
          dragAndDrop: ' or drag and drop',
          helpText: 'SVG, PNG, JPG or GIF (max. 800x400px)'
        }
      },
      imagesUploader: {
        uploadButton: {
          index: {
            errors: {
              notSelected: 'Unable to select the image. Please try again.',
            }
          },
          utils: {
            title: 'Select Image',
            takePhoto: 'Take Photo',
            chooseFromGallery: 'Choose from Gallery',
          }
        }
      },
      designer: {
        panels: {
          editPanel: {
            index: {
              actions: 'Actions',
              edit: 'Edit',
              delete: 'Delete'
            }
          }
        },
        tooltip: {
          index: {
            noUnitAssigned: 'No Unit assigned'
          }
        }
      },
      copyLink: {
        index: {
          copyToClipboard: 'Copy to clipboard',
          copied: 'Copied!'
        }
      },
      searchBar: {
        index: {
          placeholder: 'Search by %{fields}'
        }
      },
      filterDropdown: {
        index: {
          all: 'All'
        }
      },
      addItemDropdown: {
        index: {
          add: 'Add'
        }
      },
      confirmClone: {
        index: {
          clone: 'Clone'
        }
      },
      emailInput: {
        index: {
          email: 'Email'
        }
      },
      verifyCodeInput: {
        index: {
          form: {
            code: 'Enter code'
          },
          buttons: {
            resend: 'Resend'
          },
          noReceived: 'Didn\'t receive the code?',
          resending: 'Resending'
        }
      },
      dateFilter: {
        index: {
          last7Days: 'Last 7 days: ',
        }
      },
      timeAgo: {
        index: {
          yesterday: 'Yesterday'
        }
      },
      showMoreContent: {
        seeMoreButton: {
          index: {
            seeMore: 'See More',
            seeLess: 'See Less'
          }
        }
      },
      loadMoreButton: {
        index: {
          loadMore: 'Load More',
          loadingMore: 'Loading more...',
        }
      },
      imageCropper: {
        index: {
          zoom: 'Zoom',
        }
      }
    },
    global: {
      inviteButton: {
        index: {
          title: 'Invite'
        }
      },
      newBadge: {
        index: {
          title: 'New'
        }
      },
      dealStatusBadge: {
        index: {
          active: 'Active Deal',
          completed: 'Completed',
          manuallyCompleted: 'Manually Completed',
        }
      },
      communitiesProjectsBadges: {
        index: {
          all: 'All',
          none: 'None',
          showMore: '+%{hiddenCount} more',
          popoverTitle: 'All Communities / Projects (%{itemsCount})'
        }
      },
      integrationsBreadcrumbs: {
        index: {
          integrations: 'Integrations'
        }
      },
      salesRepDropdown: {
        index: {
          salesTeams: 'Sales Teams',
          salesReps: 'Sales Representatives'
        }
      },
      customer: {
        customerTypeLabel: {
          index: {
            fullyVerified: 'Fully verified',
            preApproved: 'Pre-approved',
            idVerified: 'ID verified',
            prospect: 'Prospect'
          }
        },
        customerVerifiedStatusIcon: {
          index: {
            idVerified: 'ID Verified',
            prospect: 'Prospect',
            preApproval: 'Pre Approval Verified',
            fullyVerified: 'Fully Verified'
          }
        },
        customerEmailVerifiedIcon: {
          index: {
            title: 'Email Verified',
          }
        },
        customerPhoneVerifiedIcon: {
          index: {
            title: 'Phone Verified',
          }
        },
        customerProgressPopover: {
          verificationContent: {
            index: {
              title: 'Verification Progress',
            },
            utils: {
              verificationStarted: 'Verification Started',
              idVerification: 'ID Verification',
              financialVerification: 'Income Verification',
              homeValuation: 'Home Valuation',
              preApprovalVerification: 'Pre-Approval Verification',
              notVerified: 'Not Verified yet',
              notStarted: 'Not Started yet'
            }
          },
          reservationContent: {
            index: {
              title: 'Reservation Progress',
            },
            utils: {
              emailSmsVerification: 'Email/SMS Verification',
              notVerified: 'Not Confirmed yet'
            }
          }
        },
        customerFinancialTrendBadge: {
          index: {
            noneDetected: 'Not Available',
            increasing: 'Increasing',
            decreasing: 'Decreasing',
            consistent: 'Consistent'
          }
        },
        customerTimeline: {
          tour: {
            index: {
              scheduled_start: 'Start Date',
              scheduled_end: 'End Date',
              name: 'Community',
              plan: 'Plan',
              homesite: 'Home Site',
              address: 'Address',
              types: {
                scheduled: 'Scheduled a Tour',
                rescheduled: 'Rescheduled a Tour',
                missed: 'Missed a Tour',
                completed: 'Completed a Tour',
                cancelled: 'Cancelled a Tour',
                deleted: 'Deleted a Tour'
              }
            }
          },
          visit: {
            interests: {
              index: {
                title: 'User browsed the following interests'
              }
            },
            utils: {
              ownlyVisit: 'Ownly visit',
              websiteVisit: 'Website visit',
              of: 'of',
              minutes: {
                one: '%{count} minute',
                other: '%{count} minutes',
              },
              seconds: {
                one: '%{count} second',
                other: '%{count} seconds'
              }
            },
            trafficSource: {
              index: {
                title: 'Traffic Source: ',
                utmSource: 'Source: ',
                utmMedium: 'Medium: ',
                utmCampaign: 'Campaign: ',
                utmContent: 'Content: ',
                utmTerm: 'Term: ',
              },
            },
            ownlySource: {
              index: {
                title: 'Following Params are recorded for this visitor'
              }
            },
            referer: {
              index: {
                title: 'Referred by:'
              }
            }
          },
          homewisePostback: {
            index: {
              status: 'Status',
              updatedAt: 'Updated At',
              price: 'Price',
              statuses: {
                open_lead: 'Mortgage Application Submitted',
                pre_approved: 'Mortgage Pre-Approved',
                closed_lost: 'Mortgage Application Closed',
                closed_won: 'Mortgage Application Completed'
              }
            }
          },
          idVerified: {
            index: {
              title: 'ID Verification',
              description: 'ID has been verified'
            }
          },
          message: {
            index: {
              title: 'Message',
              description: 'Message has been sent'
            }
          },
          formSubmission: {
            index: {
              title: 'Form Submission',
              description: 'A new form has been submitted',
              form: 'Form:',
              seeMore: 'See more',
              seeLess: 'See less'
            }
          },
          affordability: {
            index: {
              homeSales: {
                title: 'Buying Power',
                description: 'Buying Power has been completed'
              },
              homeRental: {
                title: 'Renting Power',
                description: 'Renting Power has been completed'
              }
            }
          },
          builtHome: {
            index: {
              title: 'Home Saved',
              description: 'User saved a home to their profile.'
            }
          },
          onfidoCheck: {
            index: {
              title: 'ID Scan'
            }
          },
          offerAccepted: {
            index: {
              title: 'Deal',
              dealCreated: 'Deal created',
              dealSwitched: 'Deal switched from %{prevName} in %{prevCommunityProjectName}%{prevCityText} to %{name} in %{communityProjectName}%{cityText}.',
              atCity: ' at %{cityName}',
            }
          },
          depositSubmitted: {
            index: {
              title: 'Deposit',
              description: 'Deposit has been completed'
            }
          },
          depositReleased: {
            index: {
              title: 'Deposit',
              description: 'Funds are released to customer'
            }
          },
          signSubmitted: {
            index: {
              title: 'Reservation',
              description: 'Reservation form has been signed'
            }
          },
          customerInvited: {
            verified: {
              index: {
                title: 'Invited',
                description: 'Invited by %{inviter} to Verified'
              }
            },
            reserveNow: {
              index: {
                title: 'Invited',
                description: 'Invited by %{inviter} to Reserve'
              }
            }
          },
          refundIssued: {
            index: {
              title: 'Refund',
              description: 'Refund of %{amount} issued to %{customerName} by %{userName}',
              support: 'Ownly Support'
            }
          },
          downloadContent: {
            index: {
              title: 'Downloaded Content'
            }
          },
          emailLinkClicked: {
            index: {
              title: 'Email Clicked',
              userClickedLink: 'User clicked a link in ',
              linkClicked: 'Link clicked: ',
              emailTypes: {
                reservationReminder: 'Reservation Reminder Email',
                savedHome: 'Saved Home Email'
              }
            }
          },
          systemEmailSent: {
            index: {
              title: 'System Email Sent',
              description: 'Subject: %{subject}'
            }
          },
          systemEmailSkipped: {
            index: {
              title: 'System Email Skipped',
              description: 'Subject: %{subject}',
              reason: 'Reason: %{reason}',
              skipReasons: {
                homePending: 'Home is pending',
                homeSold: 'Home has been sold',
                homeNotAvailable: 'Home is not available'
              }
            }
          },
          inboundEmailReceived: {
            index: {
              replyBySalesAgent: 'Reply by Agent',
              replyByCustomer: 'Reply by Customer',
              from: 'From: %{fromName}',
              description: 'Subject: %{subject}'
            },
            relayStatus: {
              index: {
                relaySkipReason: {
                  autoReply: 'Not relayed: detected as an auto-reply',
                  outOfOffice: 'Not relayed: detected as an out-of-office reply',
                  bounce: 'Not relayed: detected as a bounce notification',
                  systemEmail: 'Not relayed: sent by an automated system',
                }
              }
            }
          },
        },
        customerFormSubmissionIndicator: {
          index: {
            description: 'Lead from Form Submission on Website'
          }
        },
        newCustomerIndicator: {
          index: {
            new: 'New'
          }
        },
        customerIsAgentBadge: {
          index: {
            isAgent: 'Realtor',
          }
        },
        customerSocialMediaLoginType: {
          index: {
            signUp: 'Sign Up with %{name}'
          }
        },
      },
      customersBreadcrumbs: {
        index: {
          homeSales: {
            customers: 'Customers'
          },
          homeRental: {
            customers: 'Applicants'
          }
        }
      },
      confirmAlert: {
        index: {
          title: 'Are you sure?',
          messages: {
            delete: 'Are you sure you want to delete this item?',
            archive: 'Are you sure you want to archive this item?',
            restore: 'Are you sure you want to restore this item?'
          },
        },
      },
      viewModesDropdown: {
        index: {
          viewAs: 'View as',
          grid: 'Grid',
          list: 'List'
        }
      },
      floorsManager: {
        index: {
          buttons: {
            add: 'Add Floor'
          }
        },
        floorFormModal: {
          index: {
            newTitle: 'New Floor',
            editTitle: 'Edit Floor',
            name: 'Name',
            image: 'Image',
            size: 'Size',
            bedrooms: 'Bedrooms',
            bathrooms: 'Bathrooms',
            isBelowGrade: 'Below Grade'
          }
        },
        floorGroupFormModal: {
          index: {
            newTitle: 'New Group',
            editTitle: 'Edit Group',
            name: 'Name',
            selection: 'Selection',
            selectionOptions: {
              single: 'Radio Button: Only One option can be selected',
              multiple: 'Option Toggles: Multiple Options can be selected'
            }
          }
        },
        floorOptionFormModal: {
          index: {
            newTitle: 'New Option',
            editTitle: 'Edit Option',
            name: 'Name',
            image: 'Image',
            priceChange: 'Price Change',
            sizeChange: 'Size Change',
            bedsChange: 'Beds Change',
            bathsChange: 'Baths Change',
            garagesChange: 'Garages Change',
            description: 'Description',
            alternateImage: 'Alternate Image',
            alternateOption: 'Alternate Option',
            isDefault: 'Default',
            frontage: 'Frontage',
            max: 'Max',
            min: 'Min',
            externalId: 'External ID',
            applyFloorPlanHighlight: 'Apply highlight color when selected'
          },
          availabilityRuleSettings: {
            index: {
              title: 'Availability Rule',
              description: 'By default, this option will be <code>available</code> for all model communities.',
              onlyFor: 'only for the following',
              availabilityCommunitiesPlaceholder: 'Select communities',
              availabilityCommunityPhasesPlaceholder: 'Select phases',
              empty: 'No Communities',
              buttons: {
                setRule: 'Set Rule',
                removeRule: 'Remove Rule'
              }
            }
          },
          defaultCommunitiesFormGroup: {
            index: {
              defaultCommunities: 'Default for Communities',
              defaultCommunitiesPlaceholder: 'Select communities',
              empty: 'No Communities',
              helpTexts: {
                defaultCommunities: 'Select the communities where this option will appear pre-selected by default.',
              }
            }
          }
        },
        floorOptionImagesModal: {
          index: {
            title: 'Manage Images for %{name}'
          }
        },
        floorOptionPriceRulesModal: {
          index: {
            title: 'Price Rules for %{name}'
          }
        },
        floor: {
          index: {
            sizeSqft: '%{size} sq.ft.',
            belowGrade: 'Below Grade',
            buttons: {
              addGroup: 'Add Group'
            }
          },
          actionsMenu: {
            index: {
              moveUp: 'Move Up',
              moveDown: 'Move Down'
            }
          },
          floorGroup: {
            index: {
              buttons: {
                addOption: 'Add Option'
              }
            }
          },
          floorOption: {
            index: {
              changes: 'Changes:',
              alternatives: 'Alternatives:',
              dependencies: 'Dependencies:',
              images: 'Images',
              priceRules: 'Price Rules',
              availabilityRule: 'Availability Rule',
              isDefault: 'Default',
              communityDefault: 'Community Default',
              yes: 'Yes'
            },
            actionsMenu: {
              index: {
                dependency: 'Dependency',
                images: 'Images',
                priceRules: 'Price Rules'
              }
            }
          }
        },
        floorOptionDependencyModal: {
          index: {
            title: 'Enable This Option When',
            floor: 'Floor',
            allConditions: 'All the conditions must be met',
            oneCondition: 'One of the conditions must be met',
            operators: {
              is: 'is',
              isNot: 'is not'
            },
            defaultSelection: 'Default Selection',
            optional: '(Optional)',
            isAutoSelectedByDefault: 'Auto-select this option when condition is true',
            isAutoSelectedByDefaultDescription: 'When this option is available, it will be automatically selected as the default option.'
          }
        }
      },
      directLinkModal: {
        index: {
          title: 'Share Link',
          previewTitle: 'Preview Link',
          reserveNowCheckbox: 'Reserve Now',
          messages: {
            copied: 'Link has been copied to clipboard.'
          },
          buttons: {
            copy: 'Copy Link'
          }
        }
      },
      home: {
        communityProject: {
          index: {
            city: ' in %{city}'
          }
        },
        validUntil: {
          index: {
            validUntil: 'valid until %{date}'
          }
        },
        offerSteps: {
          offerStep: {
            index: {
              pending: 'Waiting',
              submitted: 'Sent',
              countered: 'Countered',
              accepted: 'Accepted',
              rejected: 'Rejected',
              declined: 'Declined',
              invited: 'Invited'
            }
          },
          signStep: {
            index: {
              pending: 'Waiting',
              accepted: 'Confirmed',
              rejected: 'Problem',
              declined: 'Declined',
              completed: 'Completed'
            }
          },
          depositStep: {
            index: {
              pending: 'Waiting',
              completed: 'Completed',
              accepted: 'Confirmed',
              rejected: 'Problem',
            }
          },
        },
        reserveInvitationBadge: {
          index: {
            title: 'Invited'
          }
        },
        dealModal: {
          navTabs: {
            index: {
              overview: 'Overview',
              timeline: 'Timeline'
            }
          },
          overview: {
            dealInfo: {
              index: {
                status: 'Status',
                assignedTo: 'Assigned to',
                model: 'Model/Unit',
                communityProject: 'Community/Project',
                sellingPrice: 'Selling Price',
                deposit: 'Deposit'
              },
              utils: {
                customerOffer: 'Customer Deal',
                offerAccepted: 'Deal Accepted',
                offerCountered: 'Deal Countered',
                recounterPending: 'Recounter Pending',
                offerRejected: 'Deal Rejected',
                offerDeclined: 'Deal Declined',
              },
            },
            offerSection: {
              acceptOfferCard: {
                index: {
                  title: 'Accept Offer',
                  customerOffered: 'Customer offered',
                  confirmCustomerOffered: 'Confirm customer offer',
                  requiredDepositAmount: 'Required deposit amount',
                  buttons: {
                    accept: 'Accept'
                  },
                  confirmAlert: {
                    message: 'Please confirm you want to accept this offer.'
                  }
                }
              },
              counterOfferCard: {
                index: {
                  title: 'Counter Offer',
                  counterOfferPrice: 'Counter offer',
                  confirmCounterOfferPrice: 'Confirm counter offer',
                  buttons: {
                    counter: 'Counter'
                  }
                }
              },
              rejectOfferCard: {
                index: {
                  title: 'Reject Offer',
                  description: 'Reject the customers offer, the customer can submit another offer.',
                  buttons: {
                    reject: 'Reject'
                  },
                  confirmAlert: {
                    message: 'Please confirm you want to reject this offer.'
                  }
                }
              },
              declineOfferCard: {
                index: {
                  title: 'Decline',
                  description: 'Decline the customer offer.',
                  buttons: {
                    decline: 'Decline'
                  },
                  confirmAlert: {
                    message: 'Please confirm you want to decline this offer.'
                  }
                }
              },
              acceptedOfferCard: {
                index: {
                  requiredDepositAmount: 'Required deposit amount'
                },
                offerDocumentToSign: {
                  index: {
                    documentToSign: 'Document to Sign',
                    editDocumentTemplate: 'Edit document template in DocuSign',
                    uploadingDocumentTemplate: 'Uploading document template to DocuSign...',
                    uploadDocument: 'Upload Document',
                    selectTemplate: 'Select Template from DocuSign',
                    templateId: 'Template',
                    messages: {
                      notUploaded: 'There was an error uploading your document to DocuSign. Please try again.'
                    },
                    buttons: {
                      uploadFile: 'Upload File'
                    }
                  }
                }
              },
            },
            signSection: {
              confirmSignCard: {
                index: {
                  title: 'Confirm Signature',
                  description: 'The customer has signed the deal document. Confirm that you have received the deal document signed from the customer.',
                  downloadSignedDocument: 'Download signed document',
                  noSignedDocument: 'There was a problem getting the signed document.',
                  signConfirmed: 'Signature Confirmed',
                  buttons: {
                    confirm: 'Confirm'
                  },
                  confirmAlert: {
                    message: 'Please confirm you want to accept this signature.'
                  }
                }
              },
              rejectSignCard: {
                index: {
                  title: 'Signature Problem',
                  description: 'There was a problem with the signature. Add a note that will be sent to the user.',
                  signNote: 'Note',
                  buttons: {
                    reject: 'Signature Problem'
                  }
                }
              },
              declinedSignCard: {
                index: {
                  title: 'Signature Declined',
                  description: 'The customer has declined to sign the document.'
                }
              },
            },
            depositSection: {
              confirmDepositCard: {
                index: {
                  title: 'Confirm Deposit',
                  description: 'The customer has supplied to you a deposit. Confirm that you have received the credit card deposit from the customer.',
                  amount: 'Deposit',
                  confirmAmount: 'Confirm Deposit',
                  buttons: {
                    confirm: 'Confirm Deposit'
                  },
                  confirmAlert: {
                    message: 'Please confirm you want to accept this deposit.'
                  }
                }
              },
              depositProblemCard: {
                index: {
                  title: 'Deposit Problem',
                  description: 'There was a problem with the deposit. Add a note that will be sent to the user.',
                  note: 'Note',
                  buttons: {
                    reject: 'Deposit Problem'
                  }
                }
              },
              stripeStatus: {
                stripePaymentMethod: {
                  index: {
                    paymentMethod: 'Payment Method',
                  }
                },
                stripePaymentStatus: {
                  index: {
                    paymentStatus: 'Payment Status',
                    completed: 'Completed',
                    failed: 'Failed',
                    paymentError: 'Payment Error'
                  }
                },
                stripePayoutStatus: {
                  index: {
                    payoutStatus: 'Payout Status',
                    completed: 'Completed',
                    failed: 'Failed',
                    payoutError: 'Payout Error'
                  }
                }
              },
              RefundDepositSection: {
                index: {
                  refundedAmount: 'Refunded Amount',
                  buttons: {
                    refundDeposit: 'Refund Deposit'
                  }
                }
              }
            },
            moreOptionsSection: {
              index: {
                title: 'More options',
              },
              markAsCompleteToggle: {
                index: {
                  title: 'Mark as Complete',
                  description: 'Mark this deal as complete to allow the buyer start a new reservation.',
                  errors: {
                    notMarked: 'Failed to mark the offer as completed. Please try again.'
                  }
                }
              }
            }
          }
        },
        size: {
          index: {
            sqft: 'sq ft'
          }
        },
      },
      quickPossessionForm: {
        index: {
          community: 'Community',
          elevation: 'Elevation',
          model: 'Model',
          package: 'Package',
          palette: 'Palette',
          floorplan: 'Floor Plans',
          specifications: 'Optional Upgrades',
          availability: 'Availability',
          status: 'Status',
          description: 'Description',
          address: 'Address',
          url: 'URL',
          lotId: 'Lot ID',
          squareFootage: 'Square Footage',
          image: 'Main Image',
          enablePossessionDate: 'Enable Possession Date',
          possessionDate: 'Possession Date',
          price: 'Price',
          beds: 'Beds',
          baths: 'Baths',
          garages: 'Garages',
          images: 'Additional Images',
          discountedPrice: 'Discounted Price',
          placeholders: {
            url: 'https://',
            description: 'e.g. Welcome to this spacious and stylish 3-bedroom, 2-bathroom home boasting impressive features and modern amenities. Nestled in a tranquil neighbourhood, this property offers an ideal blend...',
            beds: '# of Beds',
            baths: '# of Baths',
            garages: '# of Garages',
            requiredDepositAmount: 'Deposit Amount'
          },
          floorImages: 'Floor Plan Images',
          overrideFloors: 'Override Floor Plans',
          requiredDepositAmount: 'Required Deposit Amount',
          floorName: 'Floor %{floorNumber}',
          tourUrl: '3D Tour URL',
          openTourUrlInOverlayWindow: 'Open this URL in overlay window (please check X-Frame-Options of this URL)',
          uTourUrl: 'UTour URL',
        },
        modelDropdown: {
          index: {
            label: 'Model',
            newModel: '(New Model)'
          }
        },
        communityDropdown: {
          index: {
            label: 'Community',
            newCommunity: '(New Community)'
          }
        },
        elevationDropdown: {
          index: {
            label: 'Elevation',
          }
        },
        packageDropdown: {
          index: {
            label: 'Package',
          }
        },
        paletteDropdown: {
          index: {
            label: 'Palette',
          }
        },
        specificationsMultiSelect: {
          index: {
            noMoreSpecifications: 'No Optional Upgrades available',
          }
        },
        floorplan: {
          components: {
            editableSwitch: {
              index: {
                title: 'Editable'
              }
            }
          }
        },
        hooks: {
          useSaveQuickPossession: {
            errors: {
              notSaved: 'The quick possession could not be saved. Please try again.',
              imagesNotUploaded: 'Quick Possession saved, but some images failed to upload.'
            }
          }
        }
      },
      homeCard: {
        index: {
          builtOn: 'Built on: ',
          quickPossession: 'Quick Possession',
          deletedByUserAt: 'Deleted by user on: ',
          totalOffers: 'Total deals: %{total}'
        }
      },
      sellersManagement: {
        addSellerDropdown: {
          index: {
            teams: 'Sales Teams',
            salesReps: 'Sales Representatives',
            teamUsersCount: {
              zero: 'No sales representatives',
              one: '1 sales representative',
              other: '%{count} representatives'
            },
            buttons: {
              add: 'Add Sales Representative / Team'
            }
          }
        },
        sellersList: {
          index: {
            salesReps: 'Sales Representatives',
            salesTeams: 'Sales Teams'
          },
          sellerItem: {
            index: {
              teamUsersCount: {
                zero: 'No sales representatives',
                one: '1 sales representative',
                other: '%{count} sales representatives'
              },
            }
          }
        }
      },
      QRCodeModal: {
        index: {
          title: 'QR Code',
          message: 'Scan QR Code to open the link.',
          text: '%{itemName} Share Link',
          buttons: {
            downloadQr: 'Download QR Code'
          }
        }
      },
      profileForm: {
        index: {
          image: 'Profile Image',
          firstName: 'First Name',
          lastName: 'Last Name',
          jobTitle: 'Job Title',
          email: 'Email',
          phone: 'Phone',
          password: 'Password',
          changePassword: 'Change Password',
          buttons: {
            addPhone: 'Phone'
          },
        },
        imageCropperModal: {
          index: {
            title: 'Crop Image',
            description: 'Drag the photo to reposition it, and use the slider to zoom. The circle shows how others will see your profile picture.',
            buttons: {
              crop: 'Crop',
            }
          }
        }
      },
      socialShare: {
        index: {
          text: '%{itemName} Share Link',
        }
      },
      modifications: {
        index: {
          prevValues: 'Previous Values',
          newValues: 'New Values',
          updatedBy: 'Updated By',
          modificationDate: 'Modification Date',
          ipAddress: 'IP Address',
        }
      },
      priceRules: {
        priceRuleList: {
          index: {
            communityPhase: 'Community / Phase',
            price: 'Base Price',
            minLotPrice: 'Min Lot Price',
            defaultSelection: 'Default Selection',
            externalId: 'External ID',
            isSpecHomeOnly: 'Spec Home Only',
            isDefaultElevationImageForCommunity: 'Default Thumbnail',
            loading: 'Loading price rules...'
          },
          listItem: {
            index: {
              defaultSelections: {
                overrideParent: 'Override Parent',
                sameAsParent: 'Same as Parent'
              }
            }
          }
        },
        addPriceRuleButton: {
          index: {
            title: 'Add Price Rule'
          }
        },
        priceRuleFormModal: {
          index: {
            newTitle: 'New Price Rule',
            editTitle: 'Edit Price Rule',
            communityAndPhaseId: 'Community / Phase',
            price: 'Price',
            minLotPrice: 'Min Lot Price',
            externalId: 'External ID',
            defaultSelection: 'Default Selection',
            priceRuleDefaultSelections: {
              sameAsParent: 'Same as Parent',
              overrideParent: 'Override Parent'
            },
            isSpecHomeOnly: 'This Model is only used for Spec Homes',
            isDefaultElevationImageForCommunity: 'Make this the Default Thumbnail for this Community.'
          }
        }
      },
      imagesManager: {
        listItem: {
          index: {
            isDefault: 'Default',
            buttons: {
              markAsDefault: 'Mark as default'
            }
          }
        }
      },
      filters: {
        companyFilter: {
          index: {
            all: 'All Companies',
            company: 'Company'
          }
        },
        communityFilter: {
          index: {
            title: 'Community'
          }
        },
        modelFilter: {
          index: {
            title: 'Model'
          }
        },
        divisionFilter: {
          index: {
            select: 'All Divisions'
          }
        },
        communityProjectFilter: {
          index: {
            select: 'All Communities/Projects'
          }
        }
      },
      salesInvitationModal: {
        invitationWizard: {
          invitationType: {
            index: {
              title: 'Invite your customers',
              description: 'Select a product you would like to invite customers to.',
              buttons: {
                verified: 'Verified',
                reserveNow: 'ReserveNow'
              },
              descriptions: {
                verified: 'Invite a Customer to verify their ID and finances',
                reserveNow: 'Invite a Customer to place a deposit on a home'
              }
            }
          },
          customerSelectionType: {
            index: {
              homeSales: {
                title: 'Invite customers to Ownly',
                description: 'Select whether you would like to select an existing customer or invite a new one',
                buttons: {
                  newCustomer: 'New Customer',
                  existingCustomer: 'Existing Customer'
                }
              },
              homeRental: {
                title: 'Invite applicants to Ownly',
                description: 'Select whether you would like to select an existing applicant or invite a new one',
                buttons: {
                  newCustomer: 'New Applicant',
                  existingCustomer: 'Existing Applicant'
                }
              }
            }
          },
          newCustomer: {
            index: {
              homeSales: {
                title: 'Invite a New Customer',
                description: 'Create a new customer to invite to Ownly',
              },
              homeRental: {
                title: 'Invite a New Applicant',
                description: 'Create a new applicant to invite to Ownly',
              },
              firstName: 'First Name',
              lastName: 'Last Name *',
              email: 'Email Address *',
              phone: 'Phone Number'
            },
            existingCustomerModal: {
              index: {
                homeSales: {
                  title: 'This customer already exists',
                  description: 'Looks like you already have this person in your customer list. Would you like to invite them?',
                },
                homeRental: {
                  title: 'This applicant already exists',
                  description: 'Looks like you already have this person in your applicant list. Would you like to invite them?',
                }
              }
            }
          },
          existingCustomer: {
            index: {
              homeSales: {
                title: 'Invite Existing Customers',
                searchBarPlaceholder: 'Search for all customers',
                selectedCustomers: {
                  one: '<b>1</b> customer selected',
                  other: '<b>%{count}</b> customers selected'
                }
              },
              homeRental: {
                title: 'Invite Existing Applicants',
                searchBarPlaceholder: 'Search for all applicants',
                selectedCustomers: {
                  one: '<b>1</b> applicant selected',
                  other: '<b>%{count}</b> applicants selected'
                }
              }
            },
            listView: {
              index: {
                homeSales: {
                  customer: 'Customer',
                },
                homeRental: {
                  customer: 'Applicant',
                },
                signUpDate: 'Sign-up date'
              },
              listItem: {
                selectLink: {
                  index: {
                    select: 'Select',
                    selected: 'Selected'
                  }
                }
              }
            }
          },
          invitationList: {
            index: {
              homeSales: {
                title: 'Invite New Customers'
              },
              homeRental: {
                title: 'Invite New Applicants'
              }
            },
            listView: {
              index: {
                homeSales: {
                  customer: 'Customer'
                },
                homeRental: {
                  customer: 'Applicant'
                }
              },
            },
          },
          invitationSent: {
            index: {
              title: 'Invite Sent',
              homeSales: {
                description: 'The customers you’ve added will receive an invite to %{invitationTypeName}.',
                buttons: {
                  viewCustomers: 'View Customers'
                }
              },
              homeRental: {
                description: 'The applicants you’ve added will receive an invite to %{invitationTypeName}.',
                buttons: {
                  viewCustomers: 'View Applicants'
                }
              }
            }
          },
          components: {
            copyInviteLinkButton: {
              index: {
                title: 'Copy Invite Link',
                messages: {
                  copied: 'Link has been copied.'
                },
              }
            },
            inviteByDropdown: {
              index: {
                title: 'Invite by',
              }
            },
            invitationListItem: {
              inviteByButton: {
                index: {
                  title: 'Invite by'
                }
              }
            }
          },
          homeSelectionType: {
            index: {
              description: 'Select from your current inventory or add a new home',
              buttons: {
                newHome: 'Create a New Home',
                existingHome: 'Select From Inventory'
              },
              homeSales: {
                title: 'Invite customers to ReserveNow',
              },
              homeRental: {
                title: 'Invite applicants to ReserveNow',
              }
            }
          },
          newHome: {
            index: {
              title: 'Create a New Home',
              description: 'By filling in the details below you will create a published home'
            }
          },
          existingHome: {
            index: {
              title: 'Select a Home From Your Current Inventory',
              searchBarPlaceholder: 'Search',
              listView: {
                listItem: {
                  index: {
                    community: 'Community',
                    project: 'Project',
                    address: 'Address'
                  }
                }
              },
              gridView: {
                listItem: {
                  index: {
                    community: 'Community',
                    project: 'Project'
                  }
                }
              },
              sortDropdown: {
                index: {
                  newest: 'Newest',
                  oldest: 'Oldest',
                  priceAscending: 'Price Ascending',
                  priceDescending: 'Price Descending',
                  alphabetical: 'Alphabetical'
                }
              }
            }
          },
          confirmInvitation: {
            index: {
              verified: {
                title: 'Please Confirm'
              },
              reserveNow: {
                title: 'Confirm The Invite of Customer to Model'
              },
              buttons: {
                sendInvite: 'Send Invite',
                inviteToSite: 'Invite to Site',
                inviteToLandingPage: 'Invite to Landing Page'
              }
            }
          },
          utils: {
            invitationType: {
              verified: 'Verified',
              reserveNow: 'ReserveNow'
            }
          }
        },
      },
      verificationDirectLinkModal: {
        index: {
          title: 'Get Verified Link',
          name: 'Get Verified',
          messages: {
            copied: 'Link has been copied to clipboard!',
            success: 'Verification Invitations sent successfully!'
          },
          buttons: {
            copy: 'Copy Link',
            sendInBackground: 'Send Invitation for verification'
          }
        }
      },
      viewModesButton: {
        index: {
          grid: 'Grid',
          list: 'List'
        }
      },
      addressAutocomplete: {
        index: {
          address: 'Address'
        }
      },
      columnsPickerModal: {
        index: {
          title: 'Edit Columns',
          description: 'Choose which columns you see',
          availableColumnsTitle: 'Select the columns you would like to be active',
          availableColumnsDescription: 'Check them off to add them to the order above',
          editColumnOrder: 'Edit Column Order',
          selectColumns: 'Select Columns'
        }
      },
      mortgageProvidersManagement: {
        addMortgageProviderDropdown: {
          index: {
            buttons: {
              add: 'Add Mortgage Provider'
            }
          }
        }
      },
      deposit: {
        depositRefundFormModal: {
          index: {
            title: 'Are you sure?',
            description: 'By issuing a refund you will not be able to reverse this action.',
            amount: 'Refund Amount',
            reason: 'Reason for Refund',
            confirmAlert: {
              message: 'Do you want to mark the home as sold?',
              buttons: {
                markAsSold: 'Mark as Sold'
              }
            }
          }
        }
      },
      reservationDocumentManagement: {
        index: {
          overrideReservationDocument: 'Override Reservation Document',
          messages: {
            saved: 'Reservation Document settings has been successfully saved.',
          }
        }
      },
      reservationDocumentSettings: {
        index: {
          uploadDocument: 'Upload Document',
          selectTemplate: 'Select Template from DocuSign',
          templateName: 'Template Name',
          emailSubject: 'Email Subject',
          documentToSign: 'Document to Sign',
          templateId: 'Template',
          placeholders: {
            name: 'Team Name',
            description: 'Description',
          },
          buttons: {
            uploadFile: 'Upload File',
            editTemplate: 'Edit document template in DocuSign',
          },
        },
        hooks: {
          useReservationDocument: {
            defaults: {
              templateName: 'Ownly template',
              emailSubject: 'signature completed'
            },
          }
        }
      },
      invitableHomeCard: {
        index: {
          quickPossession: 'Quick Possession'
        }
      },
      salesLinks: {
        index: {
          profile: {
            title: 'Share Profile Link',
            shareText: '%{userName} Share Profile Link'
          },
          inventory: {
            title: 'Share Inventory Link',
            shareText: '%{userName} Share Inventory Link'
          },
          getVerified: {
            title: 'Share Verified Link',
            shareText: '%{userName} Share Verified Link'
          }
        },
        shareLinkCard: {
          appleWalletButton: {
            index: {
              title: 'Add to Apple Wallet',
              errors: {
                notAdded: 'Sorry, there was a problem adding the pass to Google Wallet. Please try again or contact us.'
              }
            }
          },
          googleWalletButton: {
            index: {
              title: 'Add to Google Wallet',
              errors: {
                notAdded: 'Sorry, there was a problem adding the pass to Apple Wallet. Please try again or contact us.'
              }
            },
          }
        }
      },
      emailNotificationsButton: {
        index: {
          title: {
            zero: 'Email Recipients',
            one: '1 Email Recipient',
            other: '%{count} Email Recipients'
          },
          viewEmailRecipients: 'View Email Recipients',
          deliveryStatus: {
            processed: 'Processed',
            dropped: 'Dropped',
            deferred: 'Deferred',
            bounced: 'Bounced',
            delivered: 'Delivered',
            open: 'Opened',
          },
          error: 'Error',
        }
      },
      listingFeaturedToggle: {
        index: {
          title: 'Featured Listing',
          description: 'Featured listings appear in a special section',
        }
      },
      depositPaymentSettings: {
        index: {
          currency: 'Currency',
          enableImmediatePayout: 'Enable Immediate Payout',
          paymentMethods: 'Payment Methods',
          enableRefunds: 'Enable Refunds',
          enableHoldFunds: 'Enable Hold and Release Funds',
          holdExpirationHours: 'Hold Expiration',
          fixedDepositAmount: 'Fixed Deposit Amount',
          helpTexts: {
            holdExpirationHours: 'Minimum: 48 hours, Maximum: 168 hours',
            fixedDepositAmount: 'Set the amount buyers will pay online for reserving the home.'
          },
        }
      },
      inventoryDeals: {
        index: {
          listEmpty: {
            title: 'No deals yet',
            description: 'There are no deals for this listing yet.',
          }
        },
        listView: {
          listItem: {
            listItem: {
              index: {
                backText: 'Inventory Deals'
              }
            }
          }
        },
        tableView: {
          tableHeader: {
            index: {
              customer: 'Customer',
              dealPrice: 'Deal Price',
              dealState: 'Deal State',
              homeSales: {
                financialAmount: 'Buying Power'
              },
              homeRental: {
                financialAmount: 'Renting Power'
              },
              realtor: 'Realtor',
              lastActive: 'Last Active',
            }
          }
        }
      },
      salesHours: {
        salesHoursForm: {
          index: {
            closed: 'Closed',
          },
          timeRange: {
            index: {
              to: 'to',
              errors: {
                invalidTimeRange: 'Invalid time range',
              }
            }
          },
          addTimeRangeButton: {
            index: {
              title: '+ Add another time range',
            }
          },
          copyToOpenDaysButton: {
            index: {
              title: 'Copy to all open days',
            }
          }
        }
      },
      insights: {
        statComparisonPeriod: {
          index: {
            vs: 'vs'
          }
        },
        insightsFiltersModal: {
          index: {
            title: 'Filters',
            description: 'Apply filters'
          },
          divisionFilter: {
            index: {
              title: 'Division'
            }
          },
          communityProjectFilter: {
            index: {
              title: 'Community / Project'
            }
          }
        },
        reportIntervalDropdown: {
          index: {
            daily: 'Daily',
            weekly: 'Weekly',
          }
        }
      }
    },
    ui: {
      strongPasswordInput: {
        criteriaPopover: {
          index: {
            title: 'Password criteria:',
            startWithALetter: 'Start with a letter',
            oneUpperCaseLetter: 'One upper-case letter',
            oneLowerCaseLetter: 'One lower-case letter',
            oneSpecialCharacter: 'One special character (!,@,#,%)',
            oneNumber: 'One number',
            atLeastEight: 'At least 8 characters'
          }
        }
      },
      locationSelector: {
        index: {
          country: 'Country',
          state: 'Province / State',
          city: 'City'
        }
      }
    },
    auth: {
      login: {
        index: {
        },
        passwordSection: {
          index: {
            title: 'Log in to your account',
            description: 'Welcome back! Please enter your details.',
            email: 'Email',
            password: 'Password',
            forgotPassword: 'Forgot Password?',
            placeholders: {
              email: 'Enter your email',
              password: 'Enter your password'
            },
            showPassword: 'Show Password',
            hidePassword: 'Hide Password',
            buttons: {
              login: 'Sign In'
            },
            salesApp: {
              title: 'Log in to Sales App',
              description: 'Please enter your details.'
            },
            loginUsingEmailLink: 'Use an email link instead'
          }
        },
        magicLinkSection: {
          index: {
            title: 'Log in to Sales App',
            description: 'We\'ll email you a link that signs you in instantly, no password needed.',
            email: 'Email',
            placeholders: {
              email: 'Enter your email',
            },
            buttons: {
              sendLink: 'Send Sign-In Link',
            },
            useOtp: 'Use a one-time code instead'
          }
        },
        otpSection: {
          index: {
            title: 'Log in to Sales App',
            description: 'Enter your email and we\'ll send a 6-digit code to sign in.',
            email: 'Email',
            placeholders: {
              email: 'Enter your email',
            },
            buttons: {
              sendLink: 'Send Code',
            },
          }
        },
        magicLinkSentSection: {
          index: {
            title: 'Check your Email',
            description: 'If an account with access exists for this email, we\'ve sent a sign-in link. Please check your inbox.',
            buttons: {
              openEmail: 'Open Email'
            },
            backToLogin: 'Back to Login',
          }
        }
      },
      sendCode: {
        index: {
          title: 'Two-factor authentication',
          description: 'We need to verify your identity.',
          instructions: 'Choose how to receive your authentication code.',
          mediums: {
            sms: 'Text Message',
            email: 'Email'
          },
          buttons: {
            send: 'Send Code'
          }
        }
      },
      verifyCode: {
        index: {
          title: 'Enter Verification Code',
          smsDescription: 'A text message with a 6-digit verification code was just sent to your phone.',
          emailDescription: 'A message with a 6-digit verification code was just sent to your email.',
          form: {
            code: 'Enter Code'
          },
          buttons: {
            resend: 'Resend'
          },
          noReceived: 'Didn\'t receive the code?',
          messages: {
            invalidCode: 'Your code entered is invalid or expired.',
            resent: 'Verification Code resent.'
          },
          resending: 'Resending'
        }
      },
      verifyOtp: {
        index: {
          title: 'Enter Your Code',
          description: 'If an account exists for <b>%{loginEmail}</b>, we\'ve sent a 6-digit code.',
          form: {
            code: 'Enter Code'
          },
          buttons: {
            resend: 'Resend'
          },
          noReceived: 'Didn\'t receive the code?',
          messages: {
            invalidCode: 'Your code entered is invalid or expired.',
            resent: 'Code resent.'
          },
          resending: 'Resending'
        }
      },
      forgotPassword: {
        index: {
          title: 'Forgot Password',
          email: 'Email',

          messages: {
            blank: 'Email can\'t be blank',
            submitted: 'Thanks! If there\'s an account associated with this email, we\'ll send the password reset instructions immediately.'
          },

          buttons: {
            confirm: 'Confirm'
          }
        }
      },
      resetPasswordLinkSent: {
        index: {
          title: 'Email has been sent!',
          emailDescription: 'A message with a link for reset your password was just sent to your email.',
          pleaseCheckSpamFolder: 'Please check your spam folder if you do not receive an email within 5 minutes',
          notReceivedLink: 'Didn\'t receive the link?',
          resendLink: 'Resend',
          messages: {
            submitted: 'Thanks! If there\'s an account associated with this email, we\'ll send the password reset instructions immediately.'
          },
        }
      },
      resetPassword: {
        index: {
          title: 'Reset your password',
          password: 'New Password',
          confirmPassword: 'Confirm New Password',
          blankError: 'The passwords cannot be blank',
          dontMatchError: 'The passwords don\'t match',
          messages: {
            invalidResetToken: 'Your reset password link is invalid or expired.',
            invalidFirstLoginToken: 'Your link to complete your registration is invalid or has expired.',
            error: 'There was an error processing your request',
            success: 'Your password has been reset',
          },
          buttons: {
            reset: 'Reset'
          }
        },
      },
      signUp: {
        index: {
          title: 'Sign Up',
          messages: {
            invalidToken: 'Your invitation link is invalid or expired.',
            error: {
              default: 'There was an error processing your request',
              password: 'The passwords don\'t match'
            },
            success: 'Your password has been reset'
          }
        },
        registrationForm: {
          index: {
            firstName: 'First Name',
            lastName: 'Last Name',
            phone: 'Phone',
            password: 'Password',
            confirmPassword: 'Password confirmation',
            buttons: {
              register: 'Register'
            }
          }
        },
        successRegistration: {
          index: {
            title: 'Successful registration!',
            description: 'Please wait while you are redirect.'
          }
        },
        invalidInvitation: {
          index: {
            title: 'Invalid or Expired Invitation',
            description: 'Please wait while you are redirect.'
          }
        }
      },
      loginCallback: {
        index: {
          title: 'Signing in using %{provider}.',
          description: 'Please wait while you are redirected.',
          messages: {
            error: 'There was an error processing your request. Please try again.'
          }
        }
      },
      consent: {
        index: {
          loggedInAs: 'You are logged in as:',
          allowAccess: 'Allow Zapier to access your Ownly Account?',
          willAllow: 'This will allow Zapier to:',
          readProfile: 'Read your profile',
          readHomes: 'Read Homes',
          readLeads: 'Read Leads'
        }
      },
      link: {
        index: {
          title: 'You\'ll need the app to get in',
          description: 'This link opens the Sales App directly. Install it once and it\'ll be ready after this one.',
          step1: 'Install the <b class="text-primary">Ownly Sales App</b> from the store.',
          step2: 'Go back to the <b class="text-primary">original email in your inbox</b> and tap that same link again.',
          step3: 'The app opens and signs you in automatically. No password needed.',
          errors: {
            invalidToken: 'This sign-in link is invalid, has expired, or you do not have access.'
          }
        }
      },
    },
    admin: {
      overview: {
        index: {
          title: 'Overview',
          description: 'Your executive summary of buyer engagement and business performance.',
          noDivisions: 'No division assigned.'
        },
        keyInsights: {
          index: {
            title: 'Key Insights',
            info: 'Plain-language observations generated from this period\'s reporting data.',
          },
          utils: {
            ownlyEngagementRate: {
              positive: 'Ownly Engagement Rate increased to <b>%{value}</b>, up <b>%{delta} pp</b> from last period.',
              negative: 'Ownly Engagement Rate decreased to <b>%{value}</b>, down <b>%{delta} pp</b> from last period.',
              neutral: 'Ownly Engagement Rate remained flat at <b>%{value}</b>, unchanged from last period.',
            },
            returningOwnlyVisitors: {
              positive: 'Returning Ownly Visitors increased <b>%{value}</b>, showing stronger buyer intent.',
              negative: 'Returning Ownly Visitors decreased <b>%{value}</b>, suggesting weaker buyer intent.',
              neutral: 'Returning Ownly Visitors remained unchanged, indicating stable buyer intent.',
            },
            bpCompletionRate: {
              positive: 'B+P completion rate increased to <b>%{value}</b>, up <b>%{delta} pp</b> from last period.',
              negative: 'B+P completion rate decreased to <b>%{value}</b>, down <b>%{delta} pp</b> from last period.',
              neutral: 'B+P completion rate remained flat at <b>%{value}</b>, unchanged from last period.',
            },
            avgBuildValue: {
              positive: 'Average build value increased <b>%{value}</b> compared to last period.',
              negative: 'Average build value decreased <b>%{value}</b> compared to last period.',
              neutral: 'Average build value remained unchanged compared to last period.',
            },
            reservationStarted: {
              positive: 'Reservations started are up <b>%{value}</b> with a <b>%{completionRate}</b> completion rate.',
              negative: 'Reservations started are down <b>%{value}</b> with a <b>%{completionRate}</b> completion rate.',
              neutral: 'Reservations started remained unchanged with a <b>%{completionRate}</b> completion rate.',
            },
            totalDepositValue: {
              positive: 'Total deposit value increased <b>%{value}</b> compared to last period.',
              negative: 'Total deposit value decreased <b>%{value}</b> compared to last period.',
              neutral: 'Total deposit value remained unchanged compared to last period.',
            },
          }
        },
        trafficByCommunityProject: {
          index: {
            title: 'Top Communities / Projects by Ownly Visitors',
            info: 'Communities / Projects ranked by unique Ownly visitors in the selected period.',
            buttons: {
              viewAll: 'View All Communities / Projects'
            }
          },
          allCommunitiesProjectsModal: {
            index: {
              title: 'Top Communities / Projects by Ownly Visitors',
              description: 'All %{count} communities / projects · %{dateRange} · same columns and metrics as the report'
            }
          }
        },
        trafficByModel: {
          index: {
            title: 'Traffic By Models',
            last3Months: 'Most viewed models in last 3 months',
            model: 'Model',
            visitors: 'Visitors'
          }
        },
        trafficByDevice: {
          index: {
            title: 'Our Visitors',
            description: 'Different devices used to visit',
            mobile: 'Mobile',
            desktop: 'Desktop',
            tablet: 'Tablet',
            deviceType: 'Device Type',
            visitors: 'Visitors'
          }
        },
        topTrafficSources: {
          index: {
            title: 'Top Traffic Sources by Ownly Engagement',
            info: 'Sources ranked by the share of website visitors who entered Ownly.',
            description: '% of website visitors who entered Ownly',
            buttons: {
              viewAll: 'View All Sources'
            }
          },
        },
        secondaryMetricsCard: {
          index: {
            totalDepositValue: {
              title: 'Total Deposit Value',
            },
            avgTimeToDeposit: {
              title: 'Avg. Time To Deposit',
              days: 'days'
            },
            outsideSalesHoursReservations: {
              title: 'Outside Sales Hours Reservations',
            },
            avgBuildValue: {
              title: 'Average Build Value',
            },
            avgOptionsSelected: {
              title: 'Average Options Selected',
            },
            medianTimeToComplete: {
              title: 'Median Time To Complete',
              days: 'days'
            }
          }
        },
        productPerformanceCard: {
          index: {
            title: 'Performance by Product',
            info: 'Headline outcomes for each enabled Ownly product.',
            ownlyEngagement: {
              title: 'Ownly Engagement',
              visitors: 'Visitors',
              builds: 'Builds',
              completionRate: 'Completion Rate',
            },
            reservations: {
              title: 'Reservations',
              started: 'Started',
              completed: 'Completed',
              completionRate: 'Completion Rate',
            },
            verifications: {
              title: 'Verification',
              verifiedBuyers: 'Verified Buyers',
              buyingPower: 'Buying Power',
              rate: 'ID + BP Rate',
            },
            sales: {
              title: 'Sales',
              profileViews: 'Profile Views',
              directInvitations: 'Direct Invitations',
              conversionRate: 'Conversion Rate',
            },
          },
          productMetricsCard: {
            index: {
              viewDetails: 'Product Performance Details'
            }
          }
        },
        trafficFunnelCard: {
          index: {
            title: 'Ownly Traffic Funnel',
            info: 'One funnel for Ownly Traffic. When Include Website Traffic is on, website traffic is shown as numbers within the funnel report rather than as a separate funnel.',
            description: 'stage width scaled to visitor volume',
            includeWebsiteTraffic: 'Include Website Traffic',
            websiteTraffic: {
              title: 'Website Traffic',
              websiteVisitors: {
                one: 'website visitor',
                other: 'website visitors'
              },
            },
            enteredOwnly: {
              title: 'Entered Ownly',
              websiteVisitors: 'of website visitors',
            },
            ownlyVisitors: 'Ownly Visitors',
            returned: 'returned',
            returningOwnlyVisitors: 'Returning Ownly Visitors',
            becameLeads: 'became leads',
            ofAllOwnlyVisitors: 'of all Ownly visitors',
            leadsGenerated: 'Leads Generated',
          },
          websiteTrafficSection: {
            index: {
              websiteTraffic: 'Website Traffic:',
              websiteVisitors: {
                one: 'website visitor',
                other: 'website visitors'
              },
              enteredOwnly: 'Entered Ownly',
              ofWebsiteVisitors: 'of website visitors',
            }
          }
        },
        engagementOverTime: {
          index: {
            title: 'Engagement Over Time',
            dailyInfo: 'Daily Ownly engagement across the selected date range.',
            weeklyInfo: 'Weekly Ownly engagement across the selected date range.',
            ownlyVisitors: 'Ownly Visitors',
            returningOwnlyVisitors: 'Returning Ownly Visitors',
            newLeads: 'Leads Generated',
          }
        },
        mostPopularSelections: {
          index: {
            title: 'Most Popular Selections',
            timesSelected: 'Times Selected',
            selection: 'Selection'
          }
        },
        leadLocation: {
          index: {
            title: 'Lead Location'
          }
        },
        topElevations: {
          index: {
            title: 'Top Elevations',
            selections: 'Selections'
          }
        },
        trafficSource: {
          index: {
            title: 'Traffic Source',
            totalLegend: 'Total %{trafficSourceName}: %{count}'
          }
        },
        overviewMetrics: {
          index: {
            newLeads: 'Leads Generated',
            reservationsStarted: 'Reservations Started',
            depositsCollected: 'Deposits Collected',
            conversionRate: 'Conversion Rate (Leads → Res. Started)',
            buildsStarted: 'Builds Started',
            buildsCompleted: 'Builds Completed',
            bpCompletionRate: 'B+P Completion Rate (Started → Completed)',
          }
        },
        visitorTraffic: {
          index: {
            title: 'Visitor Traffic',
            ownlyVisitors: 'Visitors (Ownly)',
            ownlyReturningVisitors: 'Returning Visitors (Ownly)',
            webtrackerVisitors: 'Visitors (Website)',
            webtrackerReturningVisitors: 'Returning Visitors (Website)',
            totalPerCategory: 'Total %{category}: %{count}',
            date: 'Date'
          }
        },
        leadGeneration: {
          index: {
            title: 'Lead Generation',
            ownlyLeadsCaptured: 'Ownly',
            webtrackerLeadsCaptured: 'Website',
            totalPerCategory: 'Total %{category}: %{count}',
            date: 'Date'
          }
        },
        recentDeals: {
          index: {
            title: 'Recent Deals'
          },
          listView: {
            index: {
              customer: 'Customer',
              dealState: 'Deal State',
              dealPrice: 'Deal Price',
              modelUnit: 'Model/Unit',
              communityProject: 'Community/Project',
              lastActive: 'Last Active'
            }
          }
        }
      },
      communities: {
        form: {
          index: {
            newTitle: 'New Community',
            editTitle: 'Edit Community',
            name: 'Name',
            divisionId: 'Division',
            cityId: 'City',
            subRegion: 'Sub-Region',
            address: 'Address',
            description: 'Description',
            province: 'Province / State',
            websiteUrl: 'Website URL',
            image: 'Image',
            status: 'Status',
            enableNavigation: 'Enable Navigation',
            enableMakeOffer: 'Enable Make a Deal',
            enableInventoryInsights: 'Enable Inventory Insights',
            hubSpotValue: 'HubSpot Value',
            clone: {
              title: 'Are you sure to clone %{communityName} Community?',
              message: 'Only images and Community assets are copied.'
            }
          },
          lotMapSettings: {
            index: {
              enableLotMapIntegration: 'Enable Lot Map Integration',
              provider: 'Lot Map Provider',
              mapUrl: 'Lot Map URL',
              communityId: 'Partner Community ID',
              displaySpecHomes: 'Display Spec Homes',
              propertyId: 'Property ID',
              builderId: 'Builder ID',
              mapKeys: 'Map Keys',
              mapKeysPlaceholder: 'Type a map key and press enter',
              hideLotPrice: 'Hide Lot Price',
              lotWorksCommunityId: 'Lot Map Community ID'
            }
          },
          mailingLists: {
            index: {
              mailingLists: 'Mailing Lists',
              empty: 'No Mailing Lists Available'
            }
          },
          salesRepresentative: {
            index: {
              title: 'Sales Contact',
              salesContactName: 'Sales Contact Name',
              salesAddress: 'Sales Address'
            }
          }
        },
        list: {
          index: {
            title: 'Communities',
            queryPlaceholder: 'Search by name',
            tabs: {
              all: 'All',
              published: 'Published',
              unpublished: 'Unpublished'
            },
            buttons: {
              add: 'Community'
            }
          },
          listView: {
            index: {
              name: 'Name',
              city: 'City',
              state: 'Province/State',
              division: 'Division',
              modelsCount: 'Number of models',
              publishedListingsCount: 'Number of published listings',
              status: 'Status',
              createdBy: 'Created By',
              lastModifiedBy: 'Last Modified By'
            }
          },
          sorting: {
            index: {
              sort: 'Sort:',
              asc: 'A - Z',
              desc: 'Z - A'
            }
          }
        },
        show: {
          summary: {
            details: {
              index: {
                division: 'Division',
                city: 'City',
                province: 'Province / State',
                subRegion: 'Sub-Region',
                address: 'Address',
                description: 'Description',
                websiteUrl: 'Website URL',
                displaySampleMapOptions: {
                  yes: 'Yes',
                  no: 'No'
                },
                status: 'Status',
                communityId: 'Community ID',
                createdBy: 'Created By',
                lastModifiedBy: 'Last Modified By',
                salesContactName: 'Sales Contact Name',
                salesAddress: 'Sales Address',
                externalId: 'External ID'
              },
              lotMapSettings: {
                index: {
                  title: 'Lot Map Settings',
                  provider: 'Provider',
                  lotWorks: {
                    mapUrl: 'Lot Map URL',
                    communityId: 'Lot Map Community ID',
                    displaySpecHomes: 'Display Spec Homes',
                    displaySpecHomesOptions: {
                      yes: 'Yes',
                      no: 'No'
                    }
                  },
                  focus360: {
                    communityId: 'Partner Community ID'
                  },
                  streetscape: {
                    propertyId: 'Property ID',
                    builderId: 'Builder ID',
                    mapKeys: 'Map Keys',
                    hideLotPrice: 'Hide Lot Price',
                    displaySpecHomes: 'Display Spec Homes'
                  }
                }
              }
            }
          },
          sections: {
            index: {
              tabs: {
                overview: 'Overview',
                productTypes: 'Product Types',
                models: 'Models',
                phases: 'Phases',
                images: 'Images',
                salesRepresentatives: 'Sales Representatives / Teams',
                modifications: 'Modifications',
                mortgageProviders: 'Mortgage Providers',
                reservationDocument: 'Reservation Document',
                salesHours: 'Sales Hours',
              }
            },
            productTypes: {
              index: {
                buttons: {
                  add: 'Add Product Type',
                  salesRep: 'Sales Rep',
                  productTypeSettings: 'Product Type Settings'
                }
              },
              salesRepFormModal: {
                index: {
                  title: 'Sales Representative',
                  salesImage: 'Sales Image',
                  salesPhone: 'Sales Phone',
                  salesEmail: 'Sales Email',
                  salesContactName: 'Sales Contact Name',
                  salesAddress: 'Address',
                  salesCity: 'City',
                  salesProvince: 'Province / state',
                  errorMessages: {
                    salesPhone: 'Please enter a valid sales phone number'
                  }
                }
              },
              settingsModal: {
                index: {
                  title: 'Product Type Settings: %{productTypeName}',
                  minLotPrice: 'Minimum Lot Price',
                  lotMapParams: 'Lot Map Parameters',
                  lotMapParamsPlaceholder: 'Type a param name and press enter',
                  standardizedLotWorksProductType: 'Lotworks Standardized Product Type',
                  enableLotMap: 'Enable Lot Map'
                }
              },
              salesRepresentativesModal: {
                index: {
                  title: 'Sales Representatives / Teams'
                }
              }
            },
            models: {
              index: {
                buttons: {
                  add: 'Add Model'
                }
              }
            },
            phases: {
              form: {
                index: {
                  newTitle: 'New Phase',
                  editTitle: 'Edit Phase',
                  phase: 'Phase',
                  architecturalPrice: 'Architectural Price'
                }
              },
              list: {
                index: {
                  phase: 'Phase',
                  architecturalPrice: 'Architectural Price',
                  buttons: {
                    add: 'Phase',
                    delete: 'Delete',
                    edit: 'Edit'
                  }
                }
              }
            },
            overview: {
              inventoryInsights: {
                index: {
                  publishedListings: 'Published Listings',
                  reservations: 'Reservations',
                }
              }
            },
            salesHours: {
              index: {
                timezone: 'Time zone',
                helpTexts: {
                  timezone: 'The hours below apply to this time zone.',
                },
                messages: {
                  saved: 'Sales Hours saved!'
                }
              }
            }
          },
          components: {
            shareLinkModal: {
              index: {
                title: 'Share Link',
                inventoryLink: 'Inventory Link',
                messages: {
                  copied: 'Link has been copied to clipboard.'
                },
              }
            }
          }
        }
      },
      models: {
        form: {
          index: {
            newTitle: 'New Model',
            editTitle: 'Edit Model',
            tourUrl: '3D Tour URL',
            quickPossessionUrl: 'Quick Possession Url',
            productTypeId: 'Product Type',
            name: 'Name',
            description: 'Description',
            beds: 'Beds',
            baths: 'Baths',
            garages: 'Garages',
            sizeSqft: 'Size (sq.ft.)',
            basePrice: 'Base Price',
            image: 'Image',
            status: 'Status',
            openTourUrlInOverlayWindow: 'Open this URL in overlay window (please check X-Frame-Options of this URL)',
            uTourUrl: 'UTour URL',
            useOwnlyQuickPossessions: 'Use Ownly Quick Possession URLs',
            addQuickPossessionUrl: 'Add Quick Possession URL',
            quickPossessionUrls: 'Quick Possession URLs',
            externalId: 'External ID',
          }
        },
        list: {
          index: {
            title: 'Models',
            buttons: {
              add: 'Model'
            }
          },
          gridView: {
            listItem: {
              index: {
                from: 'From %{price}',
                sizeSqft: '%{size} sq.ft.',
                includes: 'Includes lot, house & GST',
                notIncludesTaxes: 'NOT INCLUDING TAXES'
              }
            },
            communitiesTooltip: {
              communitiesList: {
                index: {
                  title: 'Communities'
                }
              }
            }
          },
          listView: {
            index: {
              name: 'Name',
              size: 'Size',
              bedrooms: 'Bedrooms',
              bathrooms: 'Bathrooms',
              garages: 'Garages',
              price: 'Base Price',
              status: 'Status',
              createdBy: 'Created By',
              lastModifiedBy: 'Last Modified By'
            }
          },
          communityFilter: {
            index: {
              community: 'Community:',
              all: 'All'
            }
          },
          productTypeFilter: {
            index: {
              productType: 'Product Type:',
              all: 'All'
            }
          }
        },
        show: {
          index: {
            buttons: {
              preview: 'Get Preview Link',
              clone: 'Clone'
            },
            tabs: {
              details: 'Details',
              floors: 'Floors',
              elevations: 'Elevations',
              packages: 'Packages',
              specifications: 'Optional Upgrades',
              palettes: 'Palettes',
              images: 'Images',
              lotWorks: 'LotWorks',
              phases: 'Phases',
              priceRules: 'Price Rules',
              modifications: 'Modifications'
            },
            clone: {
              title: 'Are you sure to clone %{modelName} Model?',
              message: 'Only images and Model assets are copied. Price Rules will not be copied to avoid dependencies.'
            }
          },
          details: {
            index: {
              productType: 'Product Type',
              description: 'Description',
              sizeSqft: 'Size (sq.ft.)',
              basePrice: 'Base Price',
              totalPrice: 'Total Price',
              tourUrl: '3D Tour URL',
              quickPossessionUrl: 'Quick Possession URL',
              status: 'Status',
              uTourUrl: 'UTour URL',
              salesSimplicityId: 'Sales Simplicity ID',
              modelId: 'Model ID',
              priceMessage: 'NOT INCLUDING TAXES',
              createdBy: 'Created By',
              lastModifiedBy: 'Last Modified By',
              externalId: 'External ID',
            }
          },
          floors: {
            index: {
              floorPlanProvider: 'Floor Plan Provider'
            },
            focus360Settings: {
              index: {
                floorPlanCode: 'Floor Plan Code',
                messages: {
                  saved: 'Focus 360 settings saved.'
                }
              }
            }
          },
          elevations: {
            index: {
              buttons: {
                add: 'Elevation'
              }
            },
            formModal: {
              index: {
                newTitle: 'New Elevation',
                editTitle: 'Edit Elevation',
                name: 'Name',
                description: 'Description',
                image: 'Image',
                isDefault: 'Default',
              }
            },
            listItem: {
              index: {
                isDefault: 'Default',
                description: 'Description',
              }
            }
          },
          specifications: {
            index: {
              buttons: {
                add: 'Optional Upgrade'
              }
            },
            formModal: {
              index: {
                newTitle: 'New Optional Upgrade',
                editTitle: 'Edit Optional Upgrade',
                name: 'Name'
              }
            }
          },
          packages: {
            listItem: {
              index: {
                default: 'Default',
                buttons: {
                  addCommunity: 'Add Community'
                }
              }
            },
            addDropDown: {
              index: {
                title: 'Add Package'
              }
            },
          },
          palettes: {
            index: {
              selectPalettes: 'Select Palettes',
              empty: 'No Palettes Available'
            },
            addDropDown: {
              index: {
                title: 'Add Palette'
              }
            },
          },
          directLinkModal: {
            index: {
              title: 'Share Link',
              previewTitle: 'Preview Link',
              selectCommunity: 'Select Community',
              noCommunities: 'No Communities Available',
              reserveNowCheckbox: 'Reserve Now',
              messages: {
                copied: 'Link has been copied to clipboard.'
              },
              buttons: {
                copy: 'Copy Link',
              }
            }
          },
          lotWorks: {
            index: {
              frontage: 'Frontage',
              buildpocket: 'Buildpocket',
              min: 'Min',
              max: 'Max',
              minLotPrice: 'Min Lot Price',
              messages: {
                saved: 'LotWorks settings saved.'
              }
            },
            lotIdsSection: {
              index: {
                title: 'Lot ID Filter',
                description: 'Add lot IDs from the LotWorks CSV export to filter the map',
                placeholders: {
                  lotId: 'Enter Lot ID from CSV',
                },
              }
            }
          },
          images: {
            index: {
              isDefault: 'Default'
            }
          }
        }
      },
      mortgageRate: {
        index: {
          title: 'Mortgage'
        },
        navTabs: {
          index: {
            mortgageRate: 'Mortgage Rate',
            mortgageProviders: 'Mortgage Providers'
          }
        }
      },
      palettes: {
        list: {
          index: {
            title: 'Palettes',
            buttons: {
              add: 'Palette'
            }
          },
          listItem: {
            index: {
              from: 'From %{price}'
            }
          }
        },
        form: {
          index: {
            newTitle: 'New Palette',
            editTitle: 'Edit Palette',
            name: 'Name',
            basePrice: 'Base Price',
            description: 'Description'
          }
        },
        show: {
          summary: {
            details: {
              index: {
                basePrice: 'Base Price',
                description: 'Description',
                createdBy: 'Created By',
                lastModifiedBy: 'Last Modified By'
              }
            },
          },
          sections: {
            index: {
              tabs: {
                images: 'Images',
                modifications: 'Modifications'
              }
            },
          }
        }
      },
      cities: {
        list: {
          index: {
            title: 'Cities',
            buttons: {
              add: 'City'
            }
          }
        },
        form: {
          index: {
            newTitle: 'New City',
            editTitle: 'Edit City',
            name: 'Name',
            state: 'Province / State',
            description: 'Description',
            longDescription: 'Long Description'
          }
        },
        show: {
          index: {
            tabs: {
              overview: 'Overview',
              images: 'Images',
              modifications: 'Modifications',
              reservationDocument: 'Reservation Document'
            }
          },
          overview: {
            index: {
              state: 'Province / State',
              description: 'Description',
              longDescription: 'Long Description',
              createdBy: 'Created By',
              lastModifiedBy: 'Last Modified By'
            }
          },
        }
      },
      teams: {
        components: {
          formModal: {
            index: {
              newTitle: 'Create a Team',
              editTitle: 'Edit Team',
              form: {
                name: 'Team Name',
                description: 'Description',
              },
              placeholders: {
                name: 'Team Name',
                description: 'Description',
              }
            }
          },
        },
        list: {
          index: {
            title: 'Teams',
            name: 'Name',
            company: 'Company',
            usersCount: 'Team Members',
            createdAt: 'Created At',
            buttons: {
              add: 'Create Team'
            }
          },
          listItem: {
            index: {
              usersCount: {
                zero: 'No Members',
                one: '1 Team Member',
                other: '%{count} Team Members'
              }
            },
            actionsMenu: {
              index: {
                getVerifiedLink: 'Get Verified Link'
              }
            }
          }
        },
        show: {
          index: {
            buttons: {
              getVerifiedLink: 'Get Verified Link',
            }
          },
          navTabs: {
            index: {
              overview: 'Overview',
              users: 'Members'
            }
          },
          overview: {
            index: {
              description: 'Description',
              company: 'Company'
            }
          },
          users: {
            index: {
              buttons: {
                add: 'Add Member'
              }
            },
            list: {
              index: {
                user: 'Member',
                permission: 'Permission Level'
              }
            },
            formModal: {
              index: {
                newTitle: 'Add Member',
                editTitle: 'Edit Member',
                userId: 'User',
                permission: 'Permission Level'
              }
            }
          }
        }
      },
      packages: {
        list: {
          index: {
            title: 'Packages',
            from: 'From %{price}',
            buttons: {
              add: 'Package'
            }
          }
        },
        form: {
          index: {
            newTitle: 'New Package',
            editTitle: 'Edit Package',
            name: 'Name',
            description: 'Details',
            image: 'Image',
            basePrice: 'Base Price'
          }
        },
        show: {
          index: {
            tabs: {
              overview: 'Overview',
              modifications: 'Modifications'
            }
          },
          overview: {
            index: {
              basePrice: 'Base Price',
              description: 'Description',
              createdBy: 'Created By',
              lastModifiedBy: 'Last Modified By'
            }
          }
        }
      },
      companies: {
        list: {
          index: {
            title: 'Companies',
            archiveMessage: 'Do you want to archive this company?',
            archivedCompanies: 'Archived Companies',
            searchBarPlaceholder: 'Search companies by name...',
            buttons: {
              add: 'Company'
            },
            errors: {
              deleteCurrentCompany: 'The current company cannot be deleted.'
            }
          }
        },
        archived: {
          index: {
            title: 'Archived Companies',
            companies: 'Companies',
            restoreMessage: 'Do you want to restore this company?',
            buttons: {
              add: 'Company'
            },
            errors: {
              restoreCurrentCompany: 'The current company cannot be restored.'
            }
          }
        },
        table: {
          index: {
            name: 'Name',
            monthlyAmount: 'Monthly Amount',
            renewalDate: 'Renewal Date',
            createdAt: 'Created At',
            archivedAt: 'Archived At',
            type: 'Type',
            stage: 'Stage',
          }
        },
        settings: {
          index: {
            title: 'Company Settings',
            messages: {
              saved: 'Company settings has been saved!',
              notSaved: 'Company settings hasn\'t been saved. Please fix the errors.'
            }
          },
          navTabs: {
            index: {
              companyAndBranding: 'Company & Branding',
              siteAndUX: 'Site & UX',
              salesConfig: 'Sales Config',
              workflow: 'Workflow',
              communications: 'Communications',
              advancedSettings: 'Advanced Settings',
              contract: 'Manage Contract',
              customNotifications: 'Custom Notifications',
              onlineSavings: 'Online Savings'
            }
          },
          tabsContent: {
            companyAndBranding: {
              index: {
                companyName: 'Company Name',
                country: 'Country',
                state: 'State / Province',
                city: 'City',
                companyLogo: 'Company logo',
                favicon: 'Favicon (optional)',
                bannerImage: 'Company Banner',
                primaryColor: 'Primary Color',
                textColor: 'Text Color',
                accentColor: 'Accent Color (Buttons)',
                floorPlanHighlightColor: 'Floor Plan Highlight Color',
                defaultHomePage: 'Default Home Page',
                enableCORSForJavaScriptSDK: 'Enable CORS for Javascript SDK',
                cookieTrackingScope: 'Cookie & Analytics Scope',
                domains: 'Domains',
                excludeIpAddresses: 'Exclude IP addresses ',
                timezone: 'Timezone',
                helpTexts: {
                  companyName: 'This will be displayed on your Ownly URL’s.',
                  country: 'Select your country',
                  state: 'Select your state or province',
                  city: 'Select your city',
                  companyLogo: 'Update your company logo.<br/>This will be used in the header.',
                  favicon: 'Update your favicon.',
                  bannerImage: 'Upload a banner that will be shown on all public sales rep profiles for your company.<br/><span class="font-weight-500">Recommended size: 345×200px.</span>',
                  domains: 'The domain entered will be used to load the company content, as well as white list the domain.',
                  excludeIpAddresses: 'Enter in IP addresses you don’t want to include in your reports. Separate IP addresses by a comma.<br/>Your IP address is: %{ipAddress}'
                },
                buttons: {
                  addDomain: 'Add Domain'
                }
              },
              domainField: {
                index: {
                  placeholders: {
                    domain: 'https://'
                  }
                }
              }
            },
            siteAndUX: {
              index: {
                defaultHomePage: 'Default home Page',
                termsAndConditionsUrl: 'Terms & Conditions URL',
                enableCommunicationToggle: 'Enable Communication Toggle',
                enableAppendCityProvince: 'Append City and Province for Listing Address (Single Family)',
                startingFromForModel: 'Use “Starting From $” for Model',
                startingFromForCommunity: 'Use “Starting From $” for Communities',
                enableStartingFromPriceForSfhInventory: 'Use “From $” for SFH Inventory',
                enableStartingFromPriceForMfhInventory: 'Use “From $” for MFH Inventory',
                overrideQPSizeWithModelSize: 'Override Quick Possession Size with Model Size',
                enableExitPageReminder: 'Enable Exit Page Reminder',
                enableInitialLeadCapture: 'Enable Initial Lead Capture',
                enableNewHomeBuilds: 'Enable New Home Builds',
                enableLegacyUI: 'Enable Legacy UI ',
                introPageMessage: 'Intro Page Message',
                completionTitle: 'Completion Title',
                completionMessage: 'Completion Message',
                saveButtonText: 'Save Button Text',
                modelText: 'Model Text',
                verificationText: 'Verification Text',
                reserveNowButtonText: 'ReserveNow Button Text',
                completionTitleForQP: 'Completion Title for Quick Possession',
                completionMessageForQP: 'Completion Message for Quick Possession',
                reserveNowQPButtonText: 'ReserveNow QP Button Text',
                textForSaveQPButton: 'Text for Save Quick Possession Button',
                quickPossessionText: 'Quick Possession Text',
                singleFamilyPriceNote: 'Price Note - Single Family',
                multiFamilyPriceNote: 'Price Note - Multi Family',
                lotPremiumLabel: 'Lot Premium Label',
                quickViewButtonText: 'Quick View Button Text',
                showInterestedPeopleCount: 'Show number of interested people on homes',
                helpTexts: {
                  defaultHomePage: 'The url entered will be used for users to redirect to your site via your logo.',
                  enableCommunicationToggle: 'This is required by CASTL only in Canada.',
                  enableAppendCityProvince: 'This is to append the City and Province for differentiation.',
                  startingFromForModel: 'This enables minimum price for a model.',
                  startingFromForCommunity: 'This enables minimum price for a community.',
                  enableStartingFromPriceForSfhInventory: 'This enables from pre-fix before Price.',
                  enableStartingFromPriceForMfhInventory: 'This enables from pre-fix before Price for Units.',
                  overrideQPSizeWithModelSize: 'Models will override quick possession size (sqft).',
                  enableExitPageReminder: 'This enables pop up as a reminder to save before leaving Build & Price.',
                  enableInitialLeadCapture: 'Capture leads before users continue with Build & Price.',
                  enableNewHomeBuilds: 'This will be active for Build & Price only.',
                  enableLegacyUI: 'This feature is Build & Price specific.',
                  introPageMessage: 'This feature is Build & Price specific.',
                  completionTitle: 'This feature is Build & Price specific.',
                  completionMessage: 'This feature is Build & Price specific.',
                  saveButtonText: 'This feature is Build & Price specific.',
                  modelText: 'This feature is Build & Price specific.',
                  verificationText: 'This feature is Build & Price specific.',
                  reserveNowButtonText: 'This is enabled for ReserveNow.',
                  completionTitleForQP: 'This is enabled for Quick Possession.',
                  completionMessageForQP: 'This is enabled for Quick Possession.',
                  reserveNowQPButtonText: 'This is enabled for Quick Possession.',
                  textForSaveQPButton: 'This is enabled for Quick Possession.',
                  quickPossessionText: 'This is enabled for Quick Possession.',
                  singleFamilyPriceNote: 'By default the Price Note value is \'Incl lot, house, GST\'',
                  multiFamilyPriceNote: 'By default the Price Note value is \'Including GST\'',
                  lotPremiumLabel: 'By default the Lot Premium label is \'Lot Premium\'',
                  quickViewButtonText: 'Text for CTA Button on the Inventory Landing Page',
                  showInterestedPeopleCount: 'Displays the number of people interested in a home when more than one customer has saved it'
                },
                placeholders: {
                  quickViewButtonText: 'View Details'
                }
              },
              marketingConsentSettings: {
                index: {
                  marketingConsentEnableCheckbox: 'Enable Legal Consent Checkbox',
                  marketingConsentRequired: 'Legal Consent is Required',
                  marketingConsentDefaultChecked: 'Default Consent Checkbox as Checked',
                  marketingConsentText: 'Legal Consent Text'
                }
              }
            },
            salesConfig: {
              index: {
                companyType: 'Company Type',
                companyTypes: {
                  homeSales: 'Home Sales',
                  homeRentals: 'Home Rentals'
                },
                enableSingleFamilyHome: 'Enable Single Family Home',
                enableMultiFamilyHome: 'Enable Multi-Family Home',
                mortgageRate: 'Mortgage Rate',
                downPayment: 'Down Payment',
                loanTerm: 'Loan Term',
                years: '%{years} Years',
                interestRate: 'Interest Rate',
                enableValidUntil: 'Enable Valid Until Feature',
                validUntilDate: 'Valid Until Date',
                helpTexts: {
                  companyType: 'Select how you want to use Ownly.',
                  mortgageRate: 'Enable mortgage rates & down deposits.',
                  interestRate: 'Set the interest rate for the loan.',
                  enableValidUntil: 'This enables an expiry date for prices in Ownly.',
                  validUntilDate: 'Choose the time frame that your price will be honoured.',
                  buyingPowerInfo: '* Changes in this setting have an impact on the calculation of buying power as well.'
                }
              }
            },
            workflow: {
              index: {
                enableReserveNow: 'Enable ReserveNow',
                enableVerified: 'Enable Verified',
                enablePriceNegotiation: 'Enable Price Negotiation',
                enableReports: 'Enable Reports',
                enableEmbedded: 'Enable Embedded Experience',
                embeddedBaseUrl: 'Base URL',
                enableIdVerification: 'Enable ID Verification',
                idVerificationProvider: 'ID Verification Provider',
                enablePreApprovalVerification: 'Enable Pre-Approval Verification',
                enableHomewise: 'Enable Homewise',
                enableDemoModeForHomewise: 'Enable Demo Mode for Homewise',
                bankVerificationProvider: 'Financial Verification Provider',
                phoneNumberMandatory: 'Make Phone Number Mandatory',
                enableLotSelectionFirst: 'Enable Lot Selection First',
                allowSaveHomeWithoutVerification: 'Allow ‘Save Home’ Without Email Verification',
                helpTexts: {
                  enableLotSelectionFirst: 'Select to make lot selection prior to model selection in Build & Price.',
                  allowSaveHomeWithoutVerification: 'When enabled, users can save a home with just an email address, no verification code required. By default, this is disabled.'
                },
                placeholders: {
                  embeddedBaseUrl: 'https://'
                }
              },
              workflows: {
                navTabs: {
                  index: {
                    reserveNowWorkflow: 'ReserveNow Workflow',
                    verifiedWorkflow: 'Verified Workflow'
                  }
                },
                components: {
                  configFile: {
                    index: {
                      title: 'Config File',
                      errors: {
                        notSaved: 'Invalid config file.'
                      }
                    }
                  }
                }
              }
            },
            communications: {
              index: {
                emailServiceProvider: 'Email Service Provider',
                sendersEmailAddress: 'Senders Email Address',
                sendersPhoneNumber: 'Senders Phone Number',
                twoWayEmailMessaging: 'Two-Way Email Messaging',
                replySubdomain: 'Reply Subdomain',
                helpTexts: {
                  sendersEmailAddress: 'This address will be used for sending out emails through Ownly.',
                  sendersPhoneNumber: 'This phone number will be used for sending out SMS through Ownly.',
                  twoWayEmailMessaging: 'Allow leads to reply to emails and have their responses appear in their Ownly activity timeline.',
                  replySubdomain: 'Configure your inbound email subdomain to enable two-way email messaging.',
                },
                placeholders: {
                  replySubdomain: 'e.g. reply.domain.com',
                }
              },
              disclaimersSection: {
                index: {
                  title: 'Build & Price Disclaimers',
                  sections: {
                    city: 'Intro Page',
                    communityProject: 'Intro Community / Project Page ',
                    lotMap: 'LotMap Page',
                    productType: 'Model Product Type',
                    modelDetails: 'Model Details Pages',
                    monthlyPaymentDisclaimer: 'Monthly Payment Disclaimer',
                    floorplans: 'Floorplans Page',
                    elevations: 'Elevations Page',
                    palettes: 'Palettes Page',
                    packages: 'Packages Page',
                    depositAmount: 'Deposit Amount Disclaimer',
                    summary: 'Summary Tab',
                    exportPagePdf: 'Export Page/ PDF',
                    sfPriceDisclaimer: 'Price Disclaimer - Single Family',
                    mfPriceDisclaimer: 'Price Disclaimer - Multi-Family',
                    qpDepositInPlace: 'Quick Possession with Deposit',
                    interestRate: 'Interest Rate',
                    reservationStartDisclaimer: 'Reservation Start Disclaimer',
                    reservationCompletionScreen: 'Reservation Completion Screen'
                  }
                },
                reservationCompletionScreenDisclaimer: {
                  index: {
                    title: 'Reservation Completion Screen',
                    reservationCompletionScreen: {
                      header: 'Header',
                      title: 'Title',
                      description: 'Description'
                    }
                  }
                },
                reservationStartDisclaimer: {
                  index: {
                    title: 'Reservation Start Disclaimer',
                    disclaimerPosition: 'Disclaimer Position',
                    disclaimerPositions: {
                      top: 'Top',
                      bottom: 'Bottom'
                    }
                  }
                }
              },
              emailMessagesSection: {
                index: {
                  title: 'Custom Email Messages',
                  sections: {
                    savedHomeReservationReminderQP: 'Saved Home Reservation Reminder (Quick Possession)',
                    savedHomeReservationReminderUnit: 'Saved Home Reservation Reminder (Unit)'
                  }
                }
              }
            },
            advancedSettings: {
              index: {
                demoModeReserveNow: 'Demo Mode ReserveNow',
                demoModeVerified: 'Demo Mode Verified',
                enableDemoSampleData: 'Demo Sample Data',
                enableAirMilesForReserveNow: 'Enable Airmiles in Reservation',
                enableAirMilesForVerified: 'Enable Airmiles in Verified',
                contactStages: 'Contact Stages',
                contactStagesDescription: 'Click and drag to reorder the stages.',
                selectedStages: 'Selected Stages',
                unselectedStages: 'Unselected Stages',
                defaultStage: 'Default Stage',
                homePriceDisplayMode: 'Display Price Variant',
                utourBuilderId: 'UTour Builder ID',
                enableHomeSavedReservationReminder: 'Enable reminders for buyers who saved a home but didn’t start reservation',
                enableIncompleteReservationReminder: 'Enable reminders for buyers who started but didn’t complete reservation',
                enableVerificationReminder: 'Enable verification reminders',
                helpTexts: {
                  enableDemoSampleData: 'This Data is filled for demo purposes.',
                  enableHomeSavedReservationReminder: 'When enabled, buyers who saved a home to their favorites but haven’t started the reservation process will be reminded to take the next step.',
                  enableIncompleteReservationReminder: 'When enabled, buyers who began a reservation but did not finish it will automatically receive a gentle reminder to complete their reservation and secure their home.',
                  enableVerificationReminder: 'Send automated reminders prompting customers to complete identity verification.'
                }
              },
              leadNotifications: {
                index: {
                  leadNotification: 'Lead Notification',
                  emptySalesReps: 'There\'s no sales representatives',
                  helpTexts: {
                    leadNotification: 'Select sales representatives'
                  }
                }
              },
              exportSettings: {
                index: {
                  exportCustomers: 'Allow to Export Customers',
                  confirmAlert: {
                    message: 'Are you sure to allow this company to export customers?'
                  }
                }
              },
              reportSettings: {
                index: {
                  enableReports: 'Enable Reports',
                  financialReports: 'Financial Reports',
                  financialHighlights: 'Financial Highlights',
                  marketingReport: 'Marketing Report'
                }
              },
              reservationDropOffNotifications: {
                index: {
                  enableReservationDropOffNotification: 'Enable Reservation Drop-off Notification',
                  reservationDropOffNotification: 'Reservation Drop-off Notification',
                  emptySalesReps: 'There\'s no sales representatives',
                  helpTexts: {
                    reservationDropOffNotification: 'Select sales representatives'
                  }
                }
              },
              autoArchiveInventory: {
                index: {
                  enableAutoArchiveInventory: 'Automatically Archive Inactive Inventory',
                  autoArchiveInventoryDays: 'Number of Inactive Days Before Auto-Archive'
                }
              },
            },
            contract: {
              index: {
                startDate: 'Contract Start Date',
                renewalDate: 'Renewal Date',
                monthlyAmount: 'Monthly Amount',
                type: 'Type',
                stage: 'Stage',
              }
            },
            customNotifications: {
              emailNotificationsSection: {
                index: {
                  title: 'Email Notifications',
                  description: 'If no text is entered, the default email template will be used.',
                  emailNotification: {
                    subject: 'Subject',
                    title: 'Title',
                    description: 'Description'
                  },
                  notificationTypes: {
                    signCompletedCustomer: 'Signature Completed',
                    depositCompletedCustomer: 'Deposit Completed',
                    reservationReminderCustomer: 'Reservation Reminder'
                  }
                }
              },
              smsNotificationsSection: {
                index: {
                  title: 'SMS Notifications',
                  description: 'If no text is entered, the default SMS template will be used.',
                  smsNotification: {
                    message: 'Message'
                  },
                  notificationTypes: {
                    signCompletedCustomer: 'Signature Completed',
                    depositCompletedCustomer: 'Deposit Completed'
                  }
                }
              }
            },
            onlineSavings: {
              index: {
                enabled: 'Enable Online Savings',
                value: 'Savings Value',
                showHeadline: 'Show Incentive Headline on Inventory Landing Page',
                showBanner: 'Show Incentive Banner on Listing Page',
                showProfileBanner: 'Show Incentive Banner on the Sales Profile Page',
                profileBannerText: 'Incentive Banner Text for the Sales Profile Page',
                helpTexts: {
                  enabled: 'Turn this on to offer an online-exclusive discount for your listings on Ownly.',
                  flatDiscount: 'Enter the dollar amount you want to reduce from the listing price.',
                  percentageDiscount: 'Enter the percentage to reduce from the listing price.',
                  showHeadline: 'Display a promotional headline on the Inventory landing page informing buyers that an online incentive is available.',
                  showBanner: 'Display an incentive banner on each applicable listing to highlight the savings available when purchasing online.'
                }
              }
            }
          },
          components: {
            saveChangesModal: {
              index: {
                title: 'Are you sure?',
                description: 'You\'ve made some changes to the company settings. Would you like to save them before leaving?'
              }
            },
            settingsSearch: {
              index: {
                searchBar: {
                  placeholder: 'Search Settings'
                }
              }
            }
          }
        }
      },
      users: {
        components: {
          shareLinkModal: {
            index: {
              title: 'Share Link',
              messages: {
                copied: 'Link has been copied to clipboard.'
              },
              buttons: {
                copy: 'Copy Link'
              },
              linkType: 'Link Type',
              linkTypes: {
                inventoryLink: 'Inventory Link',
                profileLink: 'Profile Link',
                verifiedLink: 'Verified Link',
              },
              itemNames: {
                inventoryLink: 'Inventory',
                profileLink: 'Profile',
                verifiedLink: 'Verified',
              }
            }
          },
          customLinkList: {
            index: {
              empty: 'No custom links added yet.'
            },
            formModal: {
              index: {
                newTitle: 'Add Custom Link',
                editTitle: 'Edit Custom Link',
                form: {
                  title: 'Title',
                  url: 'URL'
                },
                placeholders: {
                  url: 'https://'
                },
                errors: {
                  invalidUrl: 'Must be a URL address'
                }
              }
            },
          },
          salesProfileButtonSettings: {
            index: {
              showSaveContactButton: 'Show Save Contact Button',
              showViewListingsButton: 'Show View Listings Button',
              showEmailButton: 'Show Email Button',
              showCallButton: 'Show Call Button',
              showLinkedInButton: 'Show LinkedIn Button',
              inventoryCommunitiesProjects: 'Inventory to Display',
            },
            inventoryForm: {
              index: {
                title: 'Inventory to Display',
                emptyCommunitiesProjects: 'There are no communities or projects',
              }
            },
            inventoryList: {
              index: {
                title: 'Inventory to Display',
              }
            }
          },
          notificationSettings: {
            index: {
              notificationTypes: {
                reservationStarted: {
                  title: 'Reservation Started',
                  description: 'Triggered when a customer begins a reservation',
                },
                signatureCompleted: {
                  title: 'Signature Completed',
                  description: 'Customer has signed their reservation agreement'
                },
                depositCompleted: {
                  title: 'Deposit Completed',
                  description: 'Deposit payment has been received',
                },
                reservationCompleted: {
                  title: 'Reservation Completed',
                  description: 'Full reservation process is finished',
                },
                reservationDropOff: {
                  title: 'Reservation Drop-off',
                  description: 'Customer abandoned a reservation in progress'
                },
                idVerified: {
                  title: 'ID Verified',
                  description: 'Customer\'s identity has been verified',
                },
                homeValuation: {
                  title: 'Home Valuation',
                  description: 'A home valuation request was submitted',
                },
                buyingPower: {
                  title: 'Buying Power',
                  description: 'Customer buying power assessment completed',
                },
                customerSignedUp: {
                  title: 'Customer Signed Up',
                  description: 'A new customer registered on the platform'
                },
              }
            }
          },
          basicInfoForm: {
            index: {
              firstName: 'First Name',
              lastName: 'Last Name',
              jobTitle: 'Job Title',
              image: 'Profile Image',
              linkedInUrl: 'LinkedIn URL',
              email: 'Email',
              phone: 'Phone',
              cityId: 'City',
              buttons: {
                addPhone: 'Phone',
              },
              helpTexts: {
                email: 'An invitation will be sent to this address once the user is created.'
              },
              placeholders: {
                linkedInUrl: 'https://linkedin.com/in/username',
              },
            }
          },
          selectableCommunityProjectList: {
            index: {
              empty: 'There are no communities or projects'
            }
          },
          photoUploader: {
            index: {
              description: 'JPG or PNG · max 2MB · optional',
              buttons: {
                upload: 'Upload Photo'
              }
            }
          }
        },
        new: {
          index: {
            title: 'Create New User'
          },
          wizardNavigation: {
            index: {
              title: 'Setup Steps',
              basicInfo: {
                title: 'Basic Info',
                description: 'Name, contact and photo',
              },
              roleAndAccess: {
                title: 'Role & Access',
                description: 'Company, role, division, communities',
              },
              notifications: {
                title: 'Notifications',
                description: 'Alert settings for this user',
              },
              salesProfile: {
                title: 'Sales Profile',
                description: 'Public profile button settings',
              },
              reviewAndCreate: {
                title: 'Review & Create',
                description: 'Confirm everything looks right',
              }
            },
            cancelButton: {
              index: {
                title: 'Cancel and go back'
              }
            }
          },
          wizardContent: {
            basicInfo: {
              index: {
                stepNumber: 'Step 1 of 5',
                title: 'Basic Information',
                description: 'Start with who this person is. You can always update these details later.',
                buttons: {
                  next: 'Next: Role & Access'
                },
              },
            },
            roleAndAccess: {
              index: {
                stepNumber: 'Step 2 of 5',
                title: 'Role & Access',
                description: 'Define what this user can do and which communities/projects they belong to. This cannot be left blank.',
                alert: 'A user without a role and community assignment will not be able to access the platform correctly. These settings define their entire permission scope.',
                buttons: {
                  next: 'Next: Notifications'
                },
              },
              companyCard: {
                index: {
                  title: 'Company',
                  companyId: 'Company',
                  helpTexts: {
                    companyId: 'Auto-set from your admin account. All users you create will belong to %{companyName}.',
                  }
                }
              },
              roleCard: {
                index: {
                  title: 'Role',
                  description: 'Select the role that best describes what this user will do on the platform.',
                  roleDescriptions: {
                    masterAdmin: 'Full system access across all companies and settings.',
                    tecSupport: 'Technical support access for troubleshooting and assistance.',
                    companyAdmin: 'Visibility and edit access to all aspects of Ownly, including users, inventory, customers, profiles.',
                    divisionAdmin: 'Visibility and edit access to all aspects of Ownly, within the assigned division, including users, inventory, customers, profiles.',
                    communityProjectAdmin: 'Visibility and edit access to all aspects of Ownly, within the assigned community / project, including users, inventory, customers, profiles.',
                    companyUser: 'Standard internal user; read-only access.',
                    salesUser: 'View-only access to all aspects of Ownly, within the assigned community / project, including inventory, customers, profiles.',
                    notificationUser: 'No access to Ownly\'s Admin Portal, but will receive notifications based on assignment of inventory/communities/teams.',
                  }
                }
              },
              divisionCard: {
                index: {
                  title: 'Division Assignment',
                  divisionIds: 'Divisions',
                  emptyDivisions: 'There\'s no divisions',
                }
              },
              communitiesProjectsCard: {
                index: {
                  title: 'Communities/Projects Assignment',
                  description: 'Select which communities/projects this user can access. At least one is required.',
                }
              },
              appAccessCard: {
                index: {
                  title: 'App Access',
                  salesAppAccess: 'Sales App access',
                  salesAppAccessDescription: 'Allow this user to sign in to the Sales App.',
                  isTestAccount: 'Test Account',
                  isTestAccountDescription: 'Use a fixed verification code for Sales App reviewers only.',
                }
              }
            },
            notifications: {
              index: {
                stepNumber: 'Step 3 of 5',
                title: 'Notifications',
                description: 'All 9 notifications are enabled by default. A user with no notifications will miss critical events like reservations and ID verifications.',
                alert: 'Review each notification below. Turn off only what is genuinely not needed for this user. All are on by default to ensure nothing gets missed.',
                buttons: {
                  next: 'Next: Sales Profile'
                },
              },
              notificationEventsCard: {
                index: {
                  title: 'Notification Event',
                  enabled: 'Enabled',
                }
              }
            },
            salesProfile: {
              index: {
                stepNumber: 'Step 4 of 5 - Optional',
                title: 'Sales Profile Design',
                description: 'Configure which buttons appear on this user\'s public profile. All are on by default. You can change this any time after creating the user.',
                buttons: {
                  next: 'Next: Review',
                  skip: 'Skip this step',
                },
              },
              profileButtonsCard: {
                index: {
                  title: 'Profile Buttons',
                  customLinks: 'Custom Links',
                  buttons: {
                    addCustomLink: 'Add Custom Link',
                  }
                }
              }
            },
            reviewAndCreate: {
              index: {
                stepNumber: 'Step 5 of 5',
                title: 'Review & Create',
                description: 'Everything looks good below? Hit Create User and we will send John an invitation email right away.',
                alert: 'All required steps are complete. Click any Edit link below to go back and make changes before creating.',
                buttons: {
                  next: 'Create User'
                },
                sendInviteEmail: {
                  title: 'Send invitation email to %{email} immediately after creating',
                  description: 'Lets the user set their password and log in to the platform.'
                },
                sendWelcomeEmail: {
                  title: 'Send welcome email with personal link and wallet setup',
                  description: 'Shares their Ownly profile link and guides them to add it to Google Wallet and Apple Wallet.'
                },
                messages: {
                  created: 'User created!',
                }
              },
              basicInfoCard: {
                index: {
                  title: 'Basic Information',
                  name: 'Full Name',
                  email: 'Email',
                  jobTitle: 'Job Title',
                  phone: 'Phone',
                  cityId: 'City',
                }
              },
              roleAndAccessCard: {
                index: {
                  title: 'Role & Access',
                  company: 'Company',
                  role: 'Role',
                  divisions: 'Division',
                  communitiesProjects: 'Communities / Projects Assignment',
                  salesAppAccess: 'Sales App Access',
                  isTestAccount: 'Test Account',
                }
              },
              notificationsCard: {
                index: {
                  title: 'Notifications',
                  enabledNotifications: {
                    zero: 'No notifications enabled',
                    one: '1 notification is enabled',
                    other: '%{count} notifications are enabled',
                    all: 'All %{count} notifications are enabled'
                  },
                  reservationEvents: 'Reservation Events',
                  verificationEvents: 'Verification Events',
                  customerEvents: 'Customer Events',
                  enabledCount: '%{enabledCount} of %{total} on',
                  eventGroups: {
                    reservation: 'Reservation Events',
                    verification: 'Verification Events',
                    customer: 'Customer Events',
                  }
                }
              },
              salesProfileCard: {
                index: {
                  title: 'Sales Profile',
                  profileButtons: {
                    zero: 'No profile buttons enabled',
                    one: '1 profile button is enabled',
                    other: '%{count} profile buttons are enabled',
                    all: 'All %{count} profile buttons are enabled'
                  },
                  customLinks: {
                    zero: 'No custom links',
                    one: '1 custom link',
                    other: '%{count} custom links',
                  },
                }
              },
            }
          },
        },
        edit: {
          index: {
            title: 'Edit User',
            description: 'Update %{userName}\'s profile and settings',
            messages: {
              updated: 'User updated!',
            }
          },
          basicInfoCard: {
            index: {
              title: 'Basic Information',
              description: 'Name, email, role and contact details',
              companyId: 'Company',
              role: 'Role',
              divisionIds: 'Divisions',
              communitiesProjects: 'Communities/Projects Assignment',
              communitiesProjectsDesc: 'Select which communities/projects this user can access. These are also the communities/projects shown on their public Inventory Page.',
              salesAppAccess: 'Sales App Access',
              salesAppAccessDescription: 'Allow this user to sign in to the Sales App.',
              isTestAccount: 'Test Account',
              isTestAccountDescription: 'Use a fixed verification code for Sales App reviewers only.',
            }
          },
          teamAssignmentCard: {
            index: {
              title: 'Team Assignment',
              description: 'Assign this user to one or more teams',
              empty: 'There are no teams'
            }
          },
          notificationsCard: {
            index: {
              title: 'Notifications',
              description: 'Configure which events this user is notified about',
              notification: 'Notification',
              enabled: 'Enabled'
            }
          },
          salesProfileCard: {
            index: {
              title: 'Sales Profile Design',
              description: 'Configure the buttons and links shown on this user\'s public profile',
              customLinks: 'Custom Links',
              buttons: {
                addCustomLink: 'Add Custom Link',
              }
            }
          }
        },
        list: {
          index: {
            title: 'Users',
            user: 'User',
            company: 'Company',
            role: 'Role',
            communitiesProjectsAccess: 'Communities/Projects Access',
            emailVerified: 'Email Verified',
            lastActive: 'Last Active',
            buttons: {
              add: 'Create User'
            },
            searchBarPlaceholder: 'Search for users',
          },
          actionsMenu: {
            index: {
              errors: {
                deleteCurrentUser: 'The current logged user cannot be deleted.'
              }
            }
          },
          filtersModal: {
            roleFilter: {
              index: {
                title: 'Role'
              }
            },
            emailVerifiedFilter: {
              index: {
                title: 'Email Verified'
              }
            },
            communitiesProjectsFilter: {
              index: {
                title: 'Communities/Projects Access'
              }
            }
          }
        },
        show: {
          index: {
            users: 'Users',
            sentAt: 'Sent %{date}',
          },
          components: {
            sendEmailDropdown: {
              index: {
                sentAt: 'Sent %{date}',
                sendEmail: 'Send Email',
                welcomeEmail: 'Welcome Email',
                invitationEmail: 'Invitation Email',
              }
            },
            sendInvitationEmailModal: {
              index: {
                title: 'Send Invitation Email',
                description: 'Are you sure you want to send the invitation email to %{userName}?',
                buttons: {
                  send: 'Send Now'
                },
                messages: {
                  sent: 'Welcome Email sent!'
                }
              }
            },
            sendWelcomeEmailModal: {
              index: {
                title: 'Send Welcome Email to %{userName}?',
                description: 'This will send %{salutationName} his personal Ownly profile link along with instructions on how to add it to Google Wallet and Apple Wallet. He can use the link to share his inventory with buyers anytime.',
                buttons: {
                  send: 'Send Now'
                },
                emailWillInclude: 'Email will include:',
                profileLink: 'Profile Link',
                googleWallet: 'Google Wallet button',
                appleWallet: 'Apple Wallet button',
                trainingLink: 'Link to Ownly training',
                messages: {
                  sent: 'Welcome Email sent!'
                }
              }
            }
          },
          userHero: {
            index: {
              active: 'Active',
            }
          },
          basicInfo: {
            index: {
              title: 'Basic Information',
              id: 'User ID',
              firstName: 'First Name',
              lastName: 'Last Name',
              idSlug: 'ID / Slug',
              jobTitle: 'Job Title',
              linkedInUrl: 'LinkedIn URL',
              email: 'Email',
              phone: 'Phone',
              company: 'Company',
              divisions: 'Divisions',
              communitiesProjects: 'Assigned Communities/Projects',
              city: 'City',
              createdAt: 'Created At',
              invitationSent: 'Invitation Sent',
              salesAppAccessEnabled: 'Sales App Access',
              isTestAccount: 'Test Account',
            }
          },
          notifications: {
            index: {
              title: 'Notifications',
              notification: 'Notification',
              errors: {
                notSaved: 'Notifications not saved. Please try again.'
              }
            }
          },
          salesProfileDesign: {
            index: {
              title: 'Sales Profile Design',
              errors: {
                notSaved: 'Sales profile settings not saved. Please fix the errors.'
              }
            },
            customLinks: {
              index: {
                title: 'Custom Links',
                buttons: {
                  add: 'Add'
                }
              }
            }
          }
        }
      },
      integrations: {
        index: {
          title: 'Integrations',
          buttons: {
            customCode: 'Custom Code',
            hubSpot: 'HubSpot',
            exportData: 'Export Data',
            importData: 'Import Data',
            zapier: 'Zapier',
            googleSitemap: 'Google Sitemap',
            embedWidget: 'Embedded Shopping Cart',
            socialMedia: 'Social Media Login',
            externalDataSources: 'External Data Sources',
            webhooks: 'Webhooks',
            paymentMethods: 'Payment Methods',
            docuSign: 'DocuSign',
            sendGrid: 'SendGrid',
            tracking: 'Web Tracking',
            apiDocumentation: 'API Documentation',
            llms: 'LLMs',
            browseAi: 'Browse AI'
          }
        },
        customCode: {
          index: {
            title: 'Custom Code',
            headerScripts: 'Scripts in Header',
            headerScriptsDescription: 'These scripts will be printed in the <head> section',
            footerScripts: 'Scripts in Footer',
            footerScriptsDescription: 'These scripts will be printed above </body> tag'
          }
        },
        hubSpot: {
          index: {
            title: 'HubSpot Settings',
            tabs: {
              generalSettings: 'General Settings',
              fieldsMapping: 'Fields Mapping'
            },
            messages: {
              successfulLogin: 'Success! You can now continue with the configuration process.',
              success: 'Your HubSpot settings has been successfully updated!'
            }
          },
          generalSettings: {
            index: {
              apiKey: 'HubSpot API Key',
              contactListId: 'HubSpot Contact List ID',
              contactListIdHelp: 'You must add List Id to add contacts in your HubSpot lists. Works only for Static Lists.',
              lifecycleStage: 'Lifecycle Stage',
              leadStatus: 'Lead Status',
              leadStatuses: {
                new: 'New',
                open: 'Open',
                inProgress: 'In Progress',
                openDeal: 'Open Deal',
                unqualified: 'Unqualified',
                attemptedToContact: 'Attempted to Contact',
                connected: 'Connected',
                badTiming: 'Bad Timing'
              },
              lifecycleStages: {
                subscriber: 'Subscriber',
                lead: 'Lead',
                marketingQualifiedLead: 'Marketing Qualified Lead',
                salesQualifiedLead: 'Sales Qualified Lead',
                opportunity: 'Opportunity',
                customer: 'Customer',
                evangelist: 'Evangelist',
                other: 'Other'
              }
            }
          },
          fieldsMapping: {
            index: {
              ownlyField: 'Ownly Field',
              hubSpotField: 'HubSpot Custom Field',
              customValue: 'Custom Value',
              casl: 'CASL',
              leadSource: 'Lead Source',
              buildLink: 'Ownly Build Link',
              community: 'Community',
              model: 'Model',
              verifiedStatusField: 'Verified Status',
              reservationStepField: 'Reservation Step',
              project: 'Project',
              unit: 'Unit',
              placeholders: {
                caslCustomValue: 'true'
              },
              messages: {
                caslCustomValue: 'Ensure the value matches the HubSpot configuration. For example, use "True" if required by HubSpot.'
              }
            }
          },
          loginToApp: {
            index: {
              description: 'Please, before continuing, install the Ownly App in your HubSpot account',
              buttons: {
                install: 'Click here to Install'
              }
            }
          }
        },
        exportData: {
          index: {
            title: 'Export Data'
          },
          exportButton: {
            index: {
              fileReady: 'Your Excel file is ready to download.',
              buttons: {
                exportData: 'Export',
                exporting: 'Exporting...',
                download: 'Download Excel'
              }
            }
          }
        },
        importData: {
          index: {
            title: 'Import Data',
          },
          form: {
            index: {
              file: 'File to Import',
              acceptedFiles: 'You must choose an Excel file',
              buttons: {
                startImport: 'Start Import',
                importing: 'Importing...'
              }
            }
          },
          downloadTemplate: {
            index: {
              download: 'Download template',
              here: 'here!'
            }
          },
          details: {
            index: {
              title: 'Import Details',
              cities: 'Cities',
              sfCommunities: 'Communities',
              sfModels: 'Models (Single Family)',
              sfProductTypes: 'Product Types',
              sfCommunityProductTypes: 'Community Product Types',
              sfElevations: 'Elevations',
              sfPackages: 'Packages (Single Family)',
              sfFloors: 'Floors (Single Family)',
              sfFloorplans: 'Floorplans (Single Family)',
              sfOptionalUpgrades: 'Optional Upgrades',
              sfCommunityModels: 'Community Models',
              sfModelPackages: 'Model Packages (Single Family)',
              sfPriceRules: 'Price Rules',
              sfQuickPossessions: 'Quick Possessions',
              mfProjects: 'Projects',
              mfBuildings: 'Buildings',
              mfModels: 'Models (Multi Family)',
              mfBuildingModels: 'Building Models (Multi Family)',
              mfUnits: 'Units',
              mfPackages: 'Packages (Multi Family)',
              mfPalettes: 'Palettes (Multi Family)',
              mfFloors: 'Floors (Multi Family)',
              mfFloorplans: 'Floorplans (Multi Family)',
              mfModelPackages: 'Model Packages (Multi Family)',
              mfModelPalettes: 'Model Palettes (Multi Family)',
              mfOptionTypes: 'Option Types',
              mfUnitOptions: 'Unit Options',
              tabs: {
                importedObjects: 'Imported Objects',
                notImportedObjects: 'Not Imported Objects'
              }
            }
          }
        },
        zapier: {
          index: {
            title: 'Zapier',
            connected: 'Connected on %{connectedDate}',
            disconnected: 'Go to <a href="https://zapier.com" target="_blank">Zapier</a> to connect our Ownly app.',
            buttons: {
              disconnect: 'Disconnect'
            }
          }
        },
        googleSitemap: {
          index: {
            title: 'Google Sitemap',
            sitemapUrl: 'Sitemap URL',
            noDomain: 'Please configure a domain for your company to get a Sitemap URL',
            messages: {
              copied: 'Sitemap URL copied!'
            }
          }
        },
        syncData: {
          index: {
            title: 'Sync Data'
          }
        },
        embedWidget: {
          index: {
            title: 'Embedded Shopping Cart',
            noDomain: 'Please configure a domain for your company to embed widget in your site.',
          },
          navTabs: {
            index: {
              buildHomeSetup: 'Build Home set up',
              settings: 'Settings'
            }
          },
          settings: {
            index: {
              windowWidth: 'Window Width',
              windowWidthDesc: 'Size of slide out window in pixels (Px) or percentage (%). Default size 70%. Min size 480px.',
              savedHomesFloatingButton: {
                enabled: 'Enable Saved Homes Floating Button',
                backgroundColor: 'Background Color',
                icon: 'Icon'
              },
              messages: {
                saved: 'Settings saved!'
              }
            },
            inlineEmbed: {
              index: {
                title: 'Inline Embed - Post-Save Behaviour',
                description: 'When customers complete their selections inside the embedded iframe, choose where the post-save experience opens.',
                inlineMode: {
                  title: 'Inline Mode',
                  description: 'Keep the Build Summary inside the embedded iframe',
                },
                slideOutMode: {
                  title: 'Slide-out Mode',
                  description: 'Open the Build Summary in the slide-out panel',
                }
              }
            }
          },
          buildHomeSetup: {
            navTabs: {
              index: {
                installation: 'Installation',
                buildHome: 'Build Home',
                buildHomeInlineEmbed: 'Build Home Inline Embed',
                saveHome: 'Save Home',
                reserveHome: 'Reserve Home',
                myHomes: 'My Homes',
                quickPossessions: 'Quick Possessions',
                javaScriptSdk: 'JavaScript SDK',
                getVerified: 'Get Verified',
                getRentalVerified: 'Get Rental Verified',
                gatedPopUp: 'Gated Pop-Up',
                iFramePostMessage: 'iFrame PostMessage',
              }
            },
            installation: {
              index: {
                installation: 'Installation',
                installationDesc: 'Insert the following HTML code before the closing <code>&lt;body&gt;</code> tag preferably.',
              }
            },
            buildHome: {
              index: {
                buildHome: 'Build Home',
                buildHomeDesc: 'Add the <code>ownly-build-home</code> class to your element.',
                buildSingleFamilyHome: 'Build Single Family Home',
                buildSingleFamilyHomeDesc: 'For a specific model add <code>data-community-id</code> and <code>data-model-id</code> attributes to your element.<br/>To drill down to the Community, add the <code>data-community-id</code> attribute only.',
                addNewCommunityAndModel: 'Also create or update a new community and model by adding more attributes.',
                addNewModelOption: 'Whenever you add a new model option, increment the index specified in the attribute:<br /><code>data-model-option1-name, data-model-option2-name, data-model-option3-name, [...]</code>',
                buildMultiFamilyHome: 'Build Multi Family Home',
                buildMultiFamilyHomeDesc: 'For a specific unit add <code>data-building-id</code> and <code>data-unit-id</code> attributes to your element.<br/>For a specific model add <code>data-building-id</code> and <code>data-model-id</code> attributes to your element.<br/>To drill down to the Project, add the <code>data-project-id</code> attribute only.',
                addNewProjectAndUnit: 'Also create or update a new project, building, unit, package and palette by adding more attributes.',
                addNewUnitOption: 'Whenever you add a new unit option, increment the index specified in the attribute:<br /><code>data-unit-option1-name, data-unit-option2-name, data-unit-option3-name, [...]</code>',
                example: 'Example:',
                list: {
                  name: 'Name',
                  attribute: 'Attribute',
                  type: 'Type',
                  required: 'Required'
                }
              }
            },
            saveHome: {
              index: {
                saveHome: 'Save Home',
                saveHomeDesc: 'Add the <code>ownly-save-home</code> class to your element.',
                example: 'Example:',
                similarityDesc: 'You can use the same attributes as Build Home. This function allows you to save the home info'
              }
            },
            reserveHome: {
              index: {
                reserveHome: 'Reserve Home',
                reserveHomeDesc: 'Add the <code>ownly-reserve-home</code> class to your element.',
                example: 'Example:',
                similarityDesc: 'You can use the same attributes as Build Home. Once user confirms the listing/home, the user will directly go in to the reserve now flow.'
              }
            },
            myHomes: {
              index: {
                myHomes: 'My Homes',
                myHomesDesc: 'Add the <code>ownly-my-homes</code> class to your element.',
                example: 'Example:'
              }
            },
            quickPossessions: {
              index: {
                quickPossessions: 'Quick Possessions',
                quickPossessionsDesc: 'Add the <code>data-listing-id</code> attribute to link and open shopping cart for a Quick Possession Home.<br/>To get those IDs, go to your quick possession and copy the "Listing Id".',
                buildQuickPossessionHome: 'Build Quick Possession Home',
                showQuickPossessions: 'To show quick possessions matching the community or model, add <code>data-listing-community-id</code> or <code>data-listing-model-id</code> attributes to your element.',
                addNewQuickPossession: 'Also create or update a new quick possession by adding more attributes.',
                addNewModelFloor: 'Whenever you add a new model floor, increment the index specified in the attribute:<br /><code>data-listing-model-floor1-name, data-listing-model-floor2-name, data-listing-model-floor3-name, [...]</code>',
                example: 'Example:',
                list: {
                  name: 'Name',
                  attribute: 'Attribute',
                  type: 'Type',
                  required: 'Required'
                }
              }
            },
            javascriptSdk: {
              index: {
                title: 'JavaScript SDK',
                description: 'JavaScript SDK allows you manage the build and widget programmatically.<br/><br/>We trigger an event named <code>ownly.ready</code> on the global document object when the SDK is ready. We recommend you encapsulate all your actions in the callback of that event:',
                api: 'API',
                apiDescription: 'The <code>api</code> object allows you to add and remove builds.',
                apiAttributes: 'You can pass all available attributes to build the Single Family home, Multi Family Home and Quick Possession.',
                apiRemoveBuild: 'Also, you can remove the build added.',
                apiGetBuildUrl: 'You can retrieve the URL of the build and the reservation URL.',
                widget: 'Widget',
                widgetDescription: 'The <code>widget</code> object allows you to open and close the widget window.',
                example: 'Example',
                getVerifiedBuildHomeAttributes: 'Optionally you can pass all available attributes to build the Single Family home, Multi Family Home and Quick Possession to the <code>Ownly.widget.getVerified()</code> and <code>Ownly.widget.getRentalVerified()</code> calls.',
                gatedPopUp: 'Gated Pop-Up',
                gatedPopUpDescription: 'The <code>gatedPopUp</code> object allows you to open and close the Gated Pop-Up Form.',
              }
            },
            iFramePostMessage: {
              index: {
                title: 'iFrame CTA Integration via PostMessage',
                description: 'Clients can trigger Ownly widget actions by posting messages from within an embedded iFrame to the parent window.',
                implementationTitle: 'Example Implementation',
                implementationDescription: 'Send <code>postMessage</code> events from an embedded iFrame.',
                dataAttributeDescription: 'The attributes in the <code>data</code> field are the same attributes used to build Single Family Homes, Multi-Family Homes, and Quick Possession Homes.',
                eventTypesTitle: 'Event Types',
                eventTypesDescription: 'To trigger different Ownly widget actions, change the <code>type</code> field in the postMessage event:',
                reserveHome: 'Reserves a home',
                saveHome: 'Saves a home',
                buildHome: 'Initiates home-building process',
                getVerified: 'Triggers the verification process'
              }
            },
            getVerified: {
              index: {
                getVerified: 'Get Verified',
                getVerifiedDesc: 'Add the <code>ownly-get-verified</code> class to your element.',
                example: 'Example:',
                otherAttributes: 'Optionally you can add the following attributes:',
                buildHomeAttributes: 'Also, you can pass all available attributes to build the Single Family home, Multi Family Home and Quick Possession.',
                list: {
                  attribute: 'Attribute',
                  type: 'Type',
                  description: 'Description'
                }
              }
            },
            getRentalVerified: {
              index: {
                getVerified: 'Get Rental Verified',
                getVerifiedDesc: 'Add the <code>ownly-rental-verified</code> class to your element.',
                example: 'Example:',
                otherAttributes: 'Optionally you can add the following attributes:',
                buildHomeAttributes: 'Also, you can pass all available attributes to build the Single Family home, Multi Family Home and Quick Possession.',
                list: {
                  attribute: 'Attribute',
                  type: 'Type',
                  description: 'Description'
                }
              }
            },
            gatedPopUp: {
              index: {
                title: 'Gated Pop-Up',
                getVerifiedDesc: 'Add the <code>ownly-gated-content</code> class to your element.',
                example: 'Example:',
                otherAttributes: 'Optionally you can add the following attributes:',
                list: {
                  attribute: 'Attribute',
                  type: 'Type',
                  description: 'Description'
                }
              }
            },
            buildHomeInlineEmbed: {
              index: {
                title: 'Build Home Inline Embed',
                description: 'Use the <b>Build Home Inline Embed</b> to render the Build & Price experience directly inside your page, instead of opening it in a slide-out.',
                usage: 'Usage',
                usageDescription: 'To use the Build Home Inline Embed experience, add a container element with the <b>required class and attributes</b>. The class identifies the element, and the attributes define <b>which community and model</b> should be loaded.',
                mobileBehavior: 'Mobile Behavior',
                mobileBehaviorDescription: 'On mobile devices, the embedded experience <b>is not rendered inline</b>. Instead, the container is automatically transformed into a button that opens the experience in a full-screen slide-out, similar to the default Build Home behavior.',
              }
            }
          }
        },
        socialMedia: {
          index: {
            title: 'Social Media Login',
            tabs: {
              facebook: 'Facebook',
              google: 'Google',
              apple: 'Apple'
            },
            facebook: {
              index: {
                appId: 'App ID',
                appSecret: 'App secret'
              }
            },
            google: {
              index: {
                clientId: 'Client ID',
                clientSecret: 'Client secret'
              }
            },
            apple: {
              index: {
                clientId: 'Client ID',
                clientSecret: 'Client secret'
              }
            }
          }
        },
        webhooks: {
          list: {
            index: {
              title: 'Webhooks',
              hookUrl: 'Endpoint URL',
              events: 'Events',
              enabled: 'Enabled',
              buttons: {
                add: 'Add Webhook'
              }
            }
          },
          formModal: {
            index: {
              newTitle: 'New Webhook',
              editTitle: 'Edit Webhook',
              hookUrl: 'Endpoint URL',
              events: 'Events to listen',
              hookUrlPlaceholder: 'https://',
              enabled: 'Enabled',
              eventHelps: {
                contact: {
                  created: 'Occurs whenever a contact is created.'
                },
                build: {
                  created: 'Occurs whenever a build is created.'
                },
                listing: {
                  created: 'Occurs whenever a new listing is created.',
                  updated: 'Occurs whenever an existing listing is updated.'
                },
                unit: {
                  created: 'Occurs whenever a new unit is created.',
                  updated: 'Occurs whenever an existing unit is updated.'
                }
              }
            }
          },
          webhookDeliveries: {
            index: {
              title: 'Deliveries',
              breadcrumb: {
                webhooks: 'Webhooks',
              }
            },
            list: {
              listItem: {
                status: {
                  index: {
                    delivered: 'Delivered',
                    failed: 'Failed'
                  }
                }
              }
            },
            show: {
              index: {
                response: 'Response',
                request: 'Request',
                errorMessage: 'Error: %{error}'
              }
            }
          }
        },
        paymentMethods: {
          index: {
            title: 'Payment Methods'
          },
          navTabs: {
            index: {
              creditCard: 'Credit Card'
            }
          },
          creditCard: {
            index: {
              description: 'Configure Stripe to accept payments with Credit Card.',
              secretKey: 'Secret Key',
              publishableKey: 'Publishable Key',
              messages: {
                saved: 'Credit Card settings saved.'
              }
            },
            connectionBadge: {
              index: {
                connected: 'Connected',
                notConnected: 'Not Connected'
              }
            }
          }
        },
        llms: {
          index: {
            title: 'LLMs'
          },
          navTabs: {
            index: {
              openAi: 'OpenAI'
            }
          },
          openAi: {
            index: {
              description: 'Configure prompt to power your app with AI-generated insights.',
              customerInsightsPrompt: 'Customer Summary Prompt',
              messages: {
                saved: 'OpenAI settings saved.'
              }
            },
          }
        },
        docuSign: {
          index: {
            title: 'DocuSign'
          },
          navTabs: {
            index: {
              connection: 'Connection',
              settings: 'Settings',
              userGuides: 'User Guides'
            }
          },
          connection: {
            index: {
              connected: 'Connected as',
              buttons: {
                connect: 'Connect',
                disconnect: 'Disconnect',
                reconnect: 'Connect again'
              },
              messages: {
                notConnected: 'An error occurred while connecting to DocuSign. Please try again.',
                disconnected: 'Your account was successfully disconnected.',
                reconnect: 'An error occurred while processing your last request. Please connect your account again.'
              },
              confirmAlert: {
                message: 'Please confirm you want to disconnect your DocuSign account.'
              },
              details: {
                name: 'Name',
                email: 'Email',
                date: 'Date',
                account: 'Account'
              }
            }
          },
          settings: {
            index: {
              reservationFromInventory: 'Reservation from Inventory',
              reservationFromBuildPrice: 'Reservation from Build & Price',
              enableGenericTemplate: 'Enable Generic Template',
              uploadDocument: 'Upload Document',
              selectTemplate: 'Select Template from DocuSign',
              templateId: 'Template',
              templateName: 'Template Name',
              templateNameDefault: 'Ownly template',
              emailSubject: 'Email Subject',
              emailSubjectDefault: 'signature completed',
              documentToSign: 'Document to Sign',
              editDocumentTemplate: 'Edit document template in DocuSign',
              buttons: {
                uploadFile: 'Upload File'
              },
              messages: {
                saved: 'DocuSign settings saved.',
                notSaved: 'There was an error saving the document template to DocuSign. Please try again.',
                locked: 'You are editing this template in Docusign, please close the template in Docusign and try again.'
              }
            }
          },
          userGuides: {
            navTabs: {
              index: {
                documentTemplate: 'Document Template'
              }
            },
            documentTemplate: {
              index: {
                title: 'Steps to edit the document template',
                step1: 'Click Edit document template in DocuSign.',
                step2: 'Click EDIT and then NEXT.',
                step3: 'Locate the Signature field.',
                step4: 'Drag the Signature field to the location on the document where the customer needs to sign.',
                step5: '(Optional) To add custom fields, select the Custom Fields palette.',
                step5Note: 'Note: Custom fields will be automatically populated when the customer signs the document.',
                step6: 'Select SAVE AND CLOSE.',
              }
            }
          }
        },
        sendGrid: {
          index: {
            title: 'SendGrid'
          },
          contactLists: {
            list: {
              index: {
                title: 'Contact Lists',
                sendGrid: 'SendGrid',
                name: 'Name',
                count: 'Count',
                buttons: {
                  add: 'Add List'
                }
              }
            },
            formModal: {
              index: {
                newTitle: 'New Contact List',
                editTitle: 'Edit Contact List',
                id: 'SendGrid Contact List ID',
                name: 'Name'
              }
            },
            contacts: {
              index: {
                title: 'Contacts',
                sendGrid: 'SendGrid',
                contactLists: 'Contact Lists',
                buttons: {
                  add: 'Add Contact'
                }
              },
              list: {
                index: {
                  name: 'Name',
                  email: 'Email',
                  addedDate: 'Added Date',
                  updatedDate: 'Updated Date'
                }
              },
              formModal: {
                index: {
                  newTitle: 'New Contact',
                  editTitle: 'Edit Contact',
                  firstName: 'First Name',
                  lastName: 'Last Name',
                  email: 'Email',
                  phoneNumber: 'Phone Number'
                }
              }
            }
          },
          navTabs: {
            index: {
              generalSettings: 'General Settings',
              mailingList: 'Automation Rules'
            }
          },
          generalSettings: {
            index: {
              apiKey: 'SendGrid API Key',
              messages: {
                saved: 'SendGrid settings saved.'
              },
            },
            webhookSettings: {
              index: {
                title: 'Webhook Status',
                webhookActive: 'Webhook Active',
                url: 'URL:',
                noWebhookConfigured: 'No Webhook Configured',
                description: 'Your SendGrid account is not yet connected to receive email events.',
                buttons: {
                  createWebhook: 'Create Webhook',
                  disableWebhook: 'Disable Webhook',
                },
                messages: {
                  created: 'SendGrid webhook created!',
                  disabled: 'SendGrid webhook disabled!',
                }
              }
            }
          },
          mailingList: {
            index: {
              addedHomeListId: 'SendGrid Contact List ID',
              addedHomeListIdHelp: 'When a user saves a home, we will automatically add the contact to this SendGrid Contact List.',
              messages: {
                saved: 'SendGrid automation rules saved.'
              },
              buttons: {
                manageContactLists: 'Update Contact List'
              }
            }
          }
        },
        tracking: {
          index: {
            title: 'Web Tracking',
          },
          navTabs: {
            index: {
              trackingCode: 'Tracking Code',
              forms: 'Forms',
              pages: 'Pages'
            }
          },
          trackingCode: {
            navTabs: {
              index: {
                installation: 'Installation',
                javaScriptSdk: 'JavaScript SDK'
              }
            },
            installation: {
              index: {
                installation: 'Installation',
                installationDesc: 'Copy and paste this tracking code into every page of your site, just before the <code>&lt;/body&gt;</code> tag.',
                buttons: {
                  emailInstallationCode: 'Email the installation code'
                }
              },
              sendTrackingCodeModal: {
                index: {
                  title: 'Send Tracking Code',
                  email: 'Email Address',
                  buttons: {
                    sendEmail: 'Send Email'
                  }
                }
              }
            },
            javaScriptSdk: {
              index: {
                title: 'JavaScript SDK',
                description: 'JavaScript SDK allows you create page view event and form submission event programmatically.',
                pageTracking: 'Page Tracking',
                pageTrackingDescription: 'To track a page, you need to pass the <code>page URL</code> visited and optionally a <code>page title</code>.',
                formTracking: 'Form Tracking',
                formTrackingDescription: 'To track a form submission, you need to pass the <code>form name</code>, <code>form data</code> and <code>page URL</code>.',
                formDataDescription: `The <code>form data</code> parameter must be an array with all form elements:
                <ul>
                    <li><code>name</code> is the field name.</li>
                    <li><code>type</code> is the field type (text, email, select, radio, checkbox,...).</li>
                    <li><code>value</code> is the field value.</li>
                </ul>`
              }
            }
          },
          forms: {
            list: {
              index: {
                title: 'Forms',
                name: 'Name/URL',
                createdAt: 'Created At',
                isMapped: 'Fields Mapped',
                formSubmissionsCount: 'Submissions Count',
                lastSubmittedAt: 'Last Submitted At'
              },
              listItem: {
                index: {
                  yes: 'Yes',
                  buttons: {
                    mapFields: 'Map Fields'
                  }
                }
              }
            },
            formModal: {
              index: {
                title: 'Fields Mapping',
                name: 'Field Name',
                type: 'Field Type',
                mapped: 'Field Mapped',
                exclude: 'Exclude',
                mapActivityTo: 'Map activity to',
                community: 'Community',
                project: 'Project',
                communityIds: 'Communities',
                modelIds: 'Models',
                projectIds: 'Projects',
                buildingModelIds: 'Models'
              }
            }
          },
          pages: {
            list: {
              index: {
                title: 'Pages',
                urlPattern: 'URL Pattern',
                mapTo: 'Map to',
                communityOrProject: 'Community/Project',
                model: 'Model',
                createdAt: 'Created At',
                visitsCount: 'Visits Count',
                lastVisitedAt: 'Last Visited At',
                buttons: {
                  add: 'Page'
                }
              },
              listItem: {
                index: {
                  community: 'Community',
                  project: 'Project'
                }
              }
            },
            formModal: {
              index: {
                title: 'Tracking Page',
                urlMatchType: 'URL Match Type',
                matchTypeExact: 'Exact Match',
                matchTypeWildcard: 'Wildcard Match',
                url: 'URL',
                urlPattern: 'URL Pattern',
                mapActivityTo: 'Map activity to',
                community: 'Community',
                project: 'Project',
                model: 'Model',
                placeholders: {
                  url: 'https://',
                  urlPattern: '/communities/community-name/*'
                },
                helpTexts: {
                  urlPattern: '<code>*</code> matches a single path segment (e.g. <code>/communities/*</code> → <code>/communities/community-name</code>)<br /><code>**</code> matches any nested path (e.g. <code>/communities/**</code> → <code>/communities/community-name/model-name</code>)'
                }
              }
            }
          }
        },
        browseAi: {
          index: {
            title: 'Browse AI'
          },
          navTabs: {
            index: {
              generalSettings: 'General Settings',
              webhooks: 'Webhooks'
            }
          },
          generalSettings: {
            index: {
              webhookEndpoint: 'Webhook Endpoint',
              enableAutoImport: 'Enable Auto Import',
              robots: 'Robots',
              autoUnpublish: 'Auto Un-publish',
              fieldsMapping: 'Fields Mapping',
              mappingFields: {
                community: 'Community',
                model: 'Model',
                address: 'Address',
                price: 'Price',
                beds: 'Beds',
                baths: 'Baths',
                sqft: 'Sqft',
                imageUrl: 'Image URL',
                listingUrl: 'Listing URL',
                description: 'Description',
                floorPlans: 'Floor Plans',
                floorNameField: 'Floor Name',
                floorImageUrlField: 'Floor Image URL',
              },
              messages: {
                saved: 'Browse AI settings saved.',
                robotsNotRetrieved: 'There was an error retrieving robots from Browse AI.'
              },
              buttons: {
                addFloorPlan: 'Add Floor Plan'
              },
              emptyRobots: 'No Robots Available'
            }
          },
          webhooks: {
            components: {
              webhookPayloadModal: {
                index: {
                  title: 'Webhook Payload',
                }
              }
            },
            list: {
              index: {
                title: 'Webhooks',
                list: {
                  taskId: 'Task ID',
                  robot: 'Robot',
                  originUrl: 'Origin URL',
                  status: 'Status',
                  receivedAt: 'Received At'
                }
              },
              listItem: {
                index: {
                  buttons: {
                    viewPayload: 'View Payload'
                  }
                }
              }
            }
          }
        }
      },
      productTypes: {
        list: {
          index: {
            title: 'Product Types',
            heading: 'Product Types',
            buttons: {
              add: 'Product Type'
            }
          },
          listView: {
            index: {
              name: 'Name',
              createdBy: 'Created By',
              lastModifiedBy: 'Last Modified By'
            }
          },
        },
        form: {
          index: {
            newTitle: 'New Product Type',
            editTitle: 'Edit Product Type',
            name: 'Name',
            image: 'Image',
            lotMapParams: 'Lot Map Params'
          }
        },
        show: {
          index: {
            tabs: {
              overview: 'Overview',
              modifications: 'Modifications'
            }
          },
          overview: {
            index: {
              name: 'Name',
              createdBy: 'Created By',
              lastModifiedBy: 'Last Modified By'
            }
          }
        }
      },
      settings: {
        index: {
          title: 'Settings'
        }
      },
      reports: {
        index: {
          title: 'Reports'
        }
      },
      customers: {
        list: {
          index: {
            homeSales: {
              title: 'Customers',
              deletedCustomers: 'Deleted Customers',
            },
            homeRental: {
              title: 'Applicants',
              deletedCustomers: 'Deleted Applicants',
            },
            buttons: {
              buyNow: 'Buy Now',
              getVerifiedLink: 'Get Verified Link'
            },
            searchBar: {
              placeholder: 'Search for customers'
            }
          },
          listView: {
            listHeader: {
              index: {
                homeSales: {
                  customer: 'Customer',
                },
                homeRental: {
                  customer: 'Applicant',
                },
                reservationProgress: 'Reservation Progress',
                verificationProgress: 'Verification Progress',
                buyingPower: 'Buying Power',
                rentingPower: 'Renting Power',
                browsingPrice: 'Browsing Price',
                signUpDate: 'Sign-up Date',
                lastActive: 'Last Active'
              }
            },
            listItem: {
              customColumnValue: {
                verifiedStatusBadge: {
                  index: {
                    fullyVerified: 'Fully Verified',
                    verified: 'Verified'
                  }
                }
              },
            }
          },
          assignedFilter: {
            index: {
              all: 'All Customers',
              assigned_to_me: 'Assigned to Me'
            }
          },
          columnsPickerModal: {
            index: {
              title: 'Edit Columns',
              description: 'Choose which columns you see',
              availableColumnsTitle: 'Select the columns you would like to be active',
              availableColumnsDescription: 'Check them off to add them to the order above',
              editColumnOrder: 'Edit Column Order',
              selectColumns: 'Select Columns'
            }
          },
          editColumnsButton: {
            index: {
              title: 'Edit Columns'
            }
          },
          filtersModal: {
            index: {
              title: 'Filters',
              description: 'Apply filters'
            },
            interestsFilter: {
              index: {
                title: 'Interests'
              }
            },
            lastActiveFilter: {
              index: {
                title: 'Last Active'
              }
            },
            regionFilter: {
              index: {
                title: 'Region'
              }
            },
            statusFilter: {
              index: {
                title: 'Status'
              }
            },
            reservationProgressFilter: {
              index: {
                title: 'Reservation Progress'
              }
            },
            verificationProgressFilter: {
              index: {
                title: 'Verification Progress'
              }
            },
            signUpDateFilter: {
              index: {
                title: 'Sign-up Date'
              }
            },
            buyingPowerFilter: {
              index: {
                title: 'Buying Power'
              }
            },
            rentingPowerFilter: {
              index: {
                title: 'Renting Power'
              }
            },
            annualIncomeFilter: {
              index: {
                title: 'Annual Income'
              }
            },
            assignedToFilter: {
              index: {
                title: 'Assigned To',
                salesTeams: 'Sales Teams',
                salesRepresentatives: 'Sales Representatives'
              }
            }
          },
          assignedToFilter: {
            index: {
              select: 'Company Wide',
            }
          },
          interestsFilter: {
            index: {
              select: 'All Communities/Projects'
            }
          },
          components: {
            exportModal: {
              index: {
                title: 'Export Customers',
                messages: {
                  exporting: 'Exporting the customer list, please wait...',
                  exported: 'The customer list has been exported successfully!'
                }
              }
            }
          }
        },
        show: {
          index: {
            edit: 'Edit'
          },
          components: {
            detailsButton: {
              index: {
                title: 'Details'
              }
            },
            actionsMenu: {
              index: {
                resetMessage: 'Are you sure to reset verification?'
              }
            },
            backLink: {
              index: {
                deals: 'Deals',
                contracts: 'Contracts'
              }
            },
            customerInsightsModal: {
              index: {
                title: 'Customer Insights',
                generatedOn: 'Generated on %{date}',
                buttons: {
                  regenerateInsight: 'Regenerate insight',
                },
                loadingMessage1: 'Generating your customer insights...',
                loadingMessage2: 'This may take a few moments',
                errors: {
                  notGenerated: 'Failed to generate insights for the customer.'
                }
              }
            },
            customerConfirmIdentityModal: {
              index: {
                title: 'Mark as Verified',
                description: 'Please confirm you reviewed the documents and this user is verified.',
                form: {
                  reason: 'Reason'
                },
                placeholders: {
                  reason: 'Add a brief reason (min. 10 characters)'
                },
                buttons: {
                  markAsVerified: 'Confirm & Mark Verified'
                },
                messages: {
                  success: 'Manual verification completed successfully.'
                }
              }
            }
          },
          overview: {
            personalSection: {
              index: {
                name: 'Name',
                email: 'Email',
                phone: 'Phone Number',
                coBuyer: 'Co-Buyer',
                dateCreated: 'Date Created',
                lastActive: 'Last Active',
                firstEngaged: 'First Engaged',
                airMilesRewardNumber: 'Air Miles Reward Number',
                marketingOptedIn: 'Legal Consent'
              },
            },
            verificationSection: {
              index: {
                buyingPower: 'Verified Buying Power',
                rentingPower: 'Verified Renting Power',
                homeValuation: 'Home Valuation',
                buttons: {
                  view: 'View Property'
                },
              },
              preApproval: {
                index: {
                  title: 'Pre-approval'
                }
              },
              viewReportButton: {
                index: {
                  title: 'View Report'
                }
              },
            },
            buildersSection: {
              index: {
                title: '%{name} is also in'
              }
            },
            salesSection: {
              index: {
                stage: 'Deal Stage',
                salesRep: 'Assigned to',
              },
            },
            hubSpotSection: {
              index: {
                synced: 'Synced',
                buttons: {
                  view: 'View in HubSpot',
                }
              },
            },
            financialReportModal: {
              index: {
                buttons: {
                  downloadPDF: 'Download PDF'
                }
              }
            }
          },
          details: {
            navTabs: {
              index: {
                journey: 'Journey',
                verification: 'Verification',
                deals: 'Deals',
                activity: 'Activity',
                messages: 'Messages',
                documents: 'Documents',
                interests: 'Interests'
              }
            },
            activity: {
              analyticsCard: {
                index: {
                  title: 'Analytics',
                  totalVisits: 'Total Visits',
                  averageVisitTime: 'Average Visit',
                  device: 'Device',
                  os: 'Operating System',
                  browser: 'Browser',
                }
              },
              locationCard: {
                index: {
                  title: 'Location',
                  ip: 'IP Address: %{ip}'
                }
              },
              timeline: {
                index: {
                  title: 'User Activity',
                  description: 'View your users Timeline through Ownly.<br/>Time stamp is based on your local time.'
                },
                generateInsightsButton: {
                  index: {
                    generateInsight: 'Generate Insight',
                    viewInsight: 'View Insight',
                  }
                }
              }
            },
            verification: {
              utils: {
                idVerified: 'ID Verified',
                financesVerified: 'Finances Verified',
                coBuyerAdded: 'Co-Buyer Added',
                additionalInfo: 'Additional Info',
                homeValuation: 'Home Valuation',
                preApproval: 'Pre-approval',
              },
              idVerified: {
                placeholder: {
                  index: {
                    title: 'ID Verified'
                  }
                },
                infoCard: {
                  index: {
                    title: 'ID Verified',
                    verified: 'Verified: %{date}',
                    firstName: 'First Name',
                    lastName: 'Last Name',
                    documentType: 'Document Type',
                    documentNumber: 'Document #',
                    dateOfBirth: 'Date of Birth',
                    expiryDate: 'Expiry Date',
                    address: 'Address',
                    country: 'Country',
                    manualVerificationRequired: 'Manual Verification Required',
                    manuallyVerified: 'Manually Verified',
                    buttons: {
                      viewDocuments: 'View Documents',
                      verifyManually: 'Verify Manually'
                    }
                  }
                }
              },
              financesVerified: {
                placeholder: {
                  index: {
                    title: 'Finances Verified'
                  }
                },
                infoCard: {
                  index: {
                    title: 'Finances Verified',
                    verified: 'Verified: %{date}',
                    employerTrend: 'Employer Trend',
                    employerName: 'Employer Name',
                    debitActivityTrend: 'Debit Activity Trend',
                    creditActivityTrend: 'Credit Activity Trend',
                    overallActivityTrend: 'Overall Activity Trend',
                    overallBalanceTrend: 'Balance Trend',
                    homeRental: {
                      customerFinancialAmount: 'Verified Renting Power',
                      partyFinancialAmount: 'Combined Verified Renting Power'
                    },
                    homeSales: {
                      customerFinancialAmount: 'Verified Buying Power',
                      partyFinancialAmount: 'Combined Verified Buying Power',
                    },
                    buttons: {
                      viewReport: 'View Report'
                    }
                  }
                }
              },
              coBuyerAdded: {
                placeholder: {
                  index: {
                    homeRental: {
                      title: 'Co-applicant Added',
                    },
                    homeSales: {
                      title: 'Co-buyer Added'
                    },
                  }
                },
                infoCard: {
                  index: {
                    homeRental: {
                      title: 'Co-applicant Added',
                      financialAmount: 'Verified Renting Power',
                      buttons: {
                        view: 'View Co-applicant'
                      }
                    },
                    homeSales: {
                      title: 'Co-buyer Added',
                      financialAmount: 'Verified Buying Power',
                      buttons: {
                        view: 'View Co-buyer'
                      }
                    },
                    added: 'Added: %{date}',
                    firstName: 'First Name',
                    lastName: 'Last Name',
                    documentType: 'Document Type',
                    documentNumber: 'Document Number',
                    annualIncome: 'Annual Employer Income',
                    employerName: 'Employer Name',
                    preApproval: 'Pre-approval'
                  }
                }
              },
              additionalInfo: {
                homeValuation: {
                  placeholder: {
                    index: {
                      title: 'Home Valuation'
                    }
                  },
                  infoCard: {
                    index: {
                      title: 'Home Valuation',
                      homeValue: 'Home Value',
                      valuationDate: 'Valuation Date',
                      address: 'Address',
                      ownership: 'Ownership',
                      intendToSell: 'Intend to Sell',
                      approxMortgageBalance: 'Approx. Mortgage Balance',
                      approxHomeEquity: 'Approx. Home Equity',
                      buttons: {
                        viewValuation: 'View Valuation'
                      }
                    }
                  }
                },
                preApproval: {
                  placeholder: {
                    index: {
                      title: 'Pre-approval'
                    }
                  },
                  infoCard: {
                    index: {
                      title: 'Pre-approval Verified',
                      amount: 'Pre-approval Amount',
                      downPayment: 'Down Payment Amount'
                    },
                    downloadButton: {
                      index: {
                        title: 'Download Pre-approval'
                      }
                    }
                  }
                }
              }
            },
            deals: {
              components: {
                listItem: {
                  index: {
                    preApproval: 'Pre Approval',
                    backText: 'Customer Deals'
                  }
                },
                tableHeader: {
                  index: {
                    model: 'Model',
                    dealPrice: 'Deal Price',
                    dealState: 'Deal State',
                    communityProject: 'Community/Project',
                    realtor: 'Realtor',
                    lastActive: 'Last Active'
                  }
                },
              },
              activeDealsSection: {
                index: {
                  title: 'Active Deals',
                }
              },
              completedDealsSection: {
                index: {
                  title: 'Completed Deals',
                  homesCount: {
                    one: '1 home',
                    other: '%{count} homes'
                  },
                }
              },
              previousDealsSection: {
                index: {
                  title: 'Previous Deals',
                  homesCount: {
                    one: '1 home',
                    other: '%{count} homes'
                  },
                },
              }
            },
            messages: {
              index: {
                title: 'Messages',
                description: 'The following are messages you’ve received from this customer.',
              },
              tableView: {
                index: {
                  model: 'Model',
                  message: 'Message',
                  date: 'Date',
                }
              },
              listView: {
                listItem: {
                  index: {
                    backText: 'Customer Messages',
                  }
                }
              }
            },
            documents: {
              listHeader: {
                index: {
                  filename: 'File Name',
                  documentType: 'Document Type',
                  fileSize: 'File Size',
                  dateUploaded: 'Date Uploaded'
                }
              },
              utils: {
                preApproval: 'Pre-approval',
                documentBack: 'Back',
                documentFront: 'Front',
                documentPhoto: '%{documentSide} of %{documentName} (%{customerName}).%{fileType}',
                documentSelfie: 'Selfie Image (%{customerName}).%{fileType}',
                customerPhoto: 'Customer Photo',
                documentReport: 'ID Verification Report (%{customerName}).%{fileType}',
                idVerification: 'Id Verification'
              }
            },
            interests: {
              index: {
                title: 'Interests'
              },
              interestList: {
                listHeader: {
                  index: {
                    type: 'Type',
                    model: 'Model/Unit',
                    listedPrice: 'Listed Price',
                    community: 'Community/Project',
                    lastActive: 'Last Active'
                  }
                },
                listItem: {
                  index: {
                    types: {
                      model: 'Model',
                      unit: 'Unit',
                      quickPossession: 'Quick Possession',
                      lot: 'Lot'
                    }
                  }
                }
              }
            }
          },
          form: {
            index: {
              title: 'Personal Info',
              description: 'Update this customer personal information.',
              name: 'Name',
              email: 'Email Address',
              phoneNumber: 'Phone Number',
              marketingOptedIn: 'Legal Consent',
              isAgent: 'This is an Agent/Realtor',
              errorMessages: {
                phone: 'Please enter a valid phone number',
              }
            }
          },
        },
        financialReport: {
          components: {
            reportHeader: {
              index: {
                reportDate: 'Report Date:',
                email: 'Email:',
                phone: 'Phone:'
              }
            },
            idCard: {
              index: {
                title: 'Identity Document Verification',
                verified: 'Verified',
                unverified: 'Unverified',
                verificationDate: 'Verification Date:',
                firstName: 'First Name:',
                lastName: 'Last Name:',
                dateOfBirth: 'DOB:',
                address: 'Address:',
                idType: 'ID Type:',
                idNumber: 'ID #:',
                idExpiryDate: 'ID Expiry Date:'
              }
            },
            buyingPowerCard: {
              index: {
                title: 'Buying Power',
                between: 'Between',
                withCoBuyer: 'With co-buyer',
                withoutCoBuyer: 'Without co-buyer: '
              }
            },
            rentingPowerCard: {
              index: {
                title: 'Renting Power',
                month: 'A month',
                withCoApplicant: 'With co-applicant',
                withoutCoApplicant: 'Without co-applicant: '
              }
            }
          },
          index: {
            homeSales: {
              title: 'Customer',
            },
            homeRental: {
              title: 'Applicant',
            },
          },
          financialReportFlinks: {
            index: {
              report: 'Report',
              sections: {
                identity: 'Identity',
                employerIncomeBreakdown: 'Employer Income Breakdown',
                nonEmployerIncomeBreakdown: 'Non-Employer Income Breakdown',
                accountAnalysis: 'Account Analysis',
                overallBalance: 'Overall Balance Analysis',
                closingBalance: 'Specific Balance Analysis (Average Closing Balance)',
                specifRiskAnalysis: 'Specific Risk Analysis',
                liabilitiesBreakdown: 'Liabilities Breakdown'
              }
            },
            components: {
              monthlyAmountsChart: {
                index: {
                  month: 'Month'
                }
              },
              monthlyAmountsTable: {
                index: {
                  amount: 'Amount',
                  count: 'Count'
                }
              }
            },
            averageMonthlyRecurring: {
              index: {
                title: 'Average Monthly Recurring',
                deposits: 'Deposits',
                payments: 'Payments',
              }
            },
            accountOutflowCard: {
              index: {
                title: 'Account Outflow (last 6 months)',
                microLoanPayments: 'Micro Loan',
                mortgagePayments: 'Mortgage',
                autoLoanPayments: 'Auto & Transport',
                studentLoanPayments: 'Student Loan',
                otherLoanPayments: 'Other Loans',
                telecomPayments: 'Telecom',
                utilityPayments: 'Utilities',
              }
            },
            employersSection: {
              index: {
                tabs: {
                  overallIncome: 'Overall Income'
                },
                primary: 'Primary',
                secondary: 'Secondary',
                titleY: 'Income Amount (Monthly)'
              },
              employers: {
                employerCard: {
                  index: {
                    primaryName: 'Primary Employer Name',
                    secondaryName: 'Secondary Employer Name',
                    income: 'Employer Income',
                    trend: 'Employer Trend',
                  }
                }
              },
              attributesTable: {
                index: {
                  attribute: 'Attribute',
                  value: 'Value',
                  averageMonthlyDeposit: 'Average Monthly Deposit',
                  frequency: 'Frequency',
                  last2Paydates: 'Last 2 Paydates',
                  estimatedAnnualNet: 'Estimated Annual Net',
                  primary: 'primary',
                  secondary: 'secondary'
                }
              }
            },
            nonEmployerIncomeCard: {
              index: {
                nonEmployerIncome: 'Non-Employer Income',
                governmentIncome: 'Government Income'
              }
            },
            overallGovernmentTable: {
              index: {
                tabs: {
                  overall: 'Overall Gov’t',
                },
                accountAttribute: 'Account Attribute',
                value: 'Value',
                averageDeposit: 'Average Deposit',
                frequency: 'Frequency',
                last2DepositDates: 'Last Two Deposit Dates',
                totalDetected: 'Total Detected'
              }
            },
            accountAnalysisCard: {
              index: {
                activeDaysInAccount: 'Active Days in Account',
                firstDetectedTransaction: 'First Detected Transaction',
                averageMonthlyFreeCashFlow: 'Avg. Mthly Free Cash-Flow',
                averageMonthlyRecurringPayments: 'Avg. Mthly Recurring Payments',
                averageMonthlyRecurringDeposits: 'Avg. Mthly Deposits',
                activeDaysTrend: 'Trend of Active Days',
                debitActivityTrend: 'Debit Activity Trend',
                creditActivityTrend: 'Credit Activity Trend',
                overallActivityTrend: 'Overall Activity Trend'
              }
            },
            overallBalanceCard: {
              index: {
                trend: 'Balance Trend',
                max: 'Maximum Balance',
                min: 'Minimum Balance Detected',
                current: 'Current Balance',
                balance90DaysAgo: 'Balance as of 90 Days Ago',
                daysWithNegativeBalance: 'Days with a Negative Balance'
              }
            },
            closingBalanceCard: {
              index: {
                dayOfIncome: 'Day of Any Income',
                dayOfEmployerIncome: 'Day of Employer Income',
                dayOfGovernmentIncome: 'Day of Gov. Income',
                dayAfterIncome: 'Day After Any Income',
                dayAfterEmployerIncome: 'Day After Employer Income',
                dayAfterGovernmentIncome: 'Day After Gov. Income',
              }
            },
            nsfFeeTable: {
              index: {
                tabs: {
                  nsfFees: 'NSF Fees',
                },
                attributes: 'Attributes',
                value: 'Value',
                nfsTotal: 'Total’s NSF’s',
                nfsOf60Days: 'NSF’s (60 Days)',
                nfsOf6Months: 'NSF’s (6 months)',
                nfsMonthlyAverage: 'Average Monthly NSF’s',
                nfsDaysAfterEmployerIncome: 'NSF’s Day After Employer Income',
                nfsDaysAfterGovernmentIncome: 'NSF’s Day After Government Income',
              }
            },
            liabilitiesBreakdown: {
              index: {
                tabs: {
                  loanPayments: 'Loan Payments'
                },
                micro_loan: 'Micro Loan',
                mortgage: 'Mortgage',
                auto_loan: 'Automotive',
                student_loan: 'Student',
                other_loan: 'Other Loans',
                titleY: 'Total Loan Amount (Monthly)'
              },
              monthlyLoanPaymentsTable: {
                index: {
                  loanType: 'Loan Type',
                  averageMonthlyAmount: 'Avg. Monthly Amount',
                  averageMonthlyLoanPaymentsAmount: 'All Loans',
                  averageMonthlyMicroLoanPaymentsAmount: 'MicroLoans',
                  averageMonthlyMortgagePaymentsAmount: 'Mortgages',
                  averageMonthlyAutomotiveLoanPaymentsAmount: 'Automotive',
                  averageMonthlyStudentLoanPaymentsAmount: 'Student',
                  averageMonthlyOtherLoanPaymentsAmount: 'Other Loans',
                }
              }
            }
          },
          financialReportPlaid: {
            index: {
              report: 'Report',
              sections: {
                identity: 'Identity',
                incomes: 'Incomes',
                loanPayments: 'Loan Payments'
              }
            },
            incomesSection: {
              index: {
                wages: 'Wages',
                dividends: 'Dividends',
                interestEarned: 'Interest Earned',
                retirementPension: 'Retirement Pension',
                otherIncome: 'Other Income',
              }
            },
            loanPaymentsSection: {
              index: {
                carPayment: 'Car Payment',
                personalLoanPayment: 'Personal Loan Payment',
                studentLoanPayment: 'Student Loan Payment',
                creditCardPayment: 'Credit Card Payment',
                otherPayment: 'Other Payment'
              }
            }
          },
          financialReportInverite: {
            index: {
              report: 'Report',
              sections: {
                identity: 'Identity'
              }
            },
          }
        }
      },
      verificationsReport: {
        index: {
          title: 'Verified Report'
        },
        verifications: {
          verifiedAgeDemographicCard: {
            index: {
              title: 'Verified Age Demographic'
            }
          },
          verifiedFunnelCard: {
            index: {
              title: 'Verified Funnel',
              labels: {
                invited: 'Invited',
                idVerified: 'ID Verified',
                homeVerified: 'Home Valuation',
                buyingPower: 'Buying Power'
              }
            }
          },
          verifiedBuyingPowerCard: {
            index: {
              title: 'Verified Buying Power',
              description: 'View your customers affordability',
              percentageOfCustomers: 'Percentage of Customers',
              amount: 'Amount'
            }
          },
          verifiedLeadsLocationCard: {
            index: {
              title: 'Verified Leads Location'
            }
          }
        },
      },
      marketingReport: {
        index: {
          title: 'Marketing report',
        },
        marketing: {
          utmCampaignSection: {
            index: {
              trafficByCampaign: 'Traffic by Campaign',
              leadsByCampaign: 'Leads by Campaign'
            }
          },
          utmSourceSection: {
            index: {
              trafficBySource: 'Traffic by Source',
              leadsBySource: 'Leads by Source'
            }
          },
          utmMediumSection: {
            index: {
              trafficByMedium: 'Traffic by Medium',
              leadsByMedium: 'Leads by Medium'
            }
          },
          utmContentSection: {
            index: {
              trafficByContent: 'Traffic by Content',
              leadsByContent: 'Leads by Content'
            }
          }
        }
      },
      reservationsReport: {
        index: {
          title: 'Reservations Report',
        },
        reservations: {
          reservationsMetrics: {
            index: {
              title: 'Reservations',
              reservationsStarted: 'Reservations Started',
              reservationsCompleted: 'Reservations Completed',
              numberOfReservations: 'Number of Reservations'
            }
          },
          totalReservations: {
            index: {
              title: 'Total Number of Reservations',
              reservations: {
                one: '%{count} Reservation',
                other: '%{count} Reservations',
              }
            }
          },
          totalDepositAmount: {
            index: {
              title: 'Total Deposit Amount'
            }
          },
          reservationsByCommunityProject: {
            index: {
              title: 'Reservations By Community / Project',
              reservations: 'Reservations',
              communityOrProject: 'Community/Project'
            }
          },
          reservationsByModel: {
            index: {
              title: 'Reservations By Model',
              reservations: 'Reservations',
              model: 'Model'
            }
          },
          customerLocation: {
            index: {
              title: 'Customer Location'
            }
          },
          reservationFunnel: {
            index: {
              title: 'Reservation Funnel',
              labels: {
                invited: 'Invited',
                offer: 'Started',
                sign: 'Signed',
                deposit: 'Deposit'
              }
            }
          }
        },
      },
      inventoryInsights: {
        index: {
          title: 'Inventory Insights',
          description: 'Understand available inventory, buyer demand, and conversion performance.',
          inventorySnapshot: {
            title: 'Inventory Snapshot',
            info: 'Inventory movement and pricing for the selected period.'
          }
        },
        components: {
          inventorySnapshotMetric: {
            index: {
              vs: 'vs'
            }
          }
        },
        priceBandChart: {
          index: {
            title: 'Price Band: Inventory vs Buyer Interest',
            info: 'Distribution of available inventory vs the share of buyer engagement across price bands.',
            legends: {
              availableInventory: '% of Available Inventory',
              buyerInterest: '% of Buyer Interest'
            },
            priceRanges: {
              under_400k: '< $400K',
              '400k_500k': '$400K - $500K',
              '500k_600k': '$500K - $600K',
              '600k_700k': '$600K - $700K',
              over_700k: '$700K+'
            },
            listings: 'Listings'
          }
        },
        availableInventory: {
          index: {
            title: 'Available Inventory',
          }
        },
        newInventory: {
          index: {
            title: 'New Inventory',
            listings: {
              one: 'listing',
              other: 'listings',
            }
          }
        },
        inventoryValue: {
          index: {
            title: 'Inventory Value',
          }
        },
        inventoryDemandIndex: {
          index: {
            title: 'Inventory Demand Index',
            info: 'Unique engaged buyers per available listing',
          }
        },
        inventoryEngaged: {
          index: {
            title: 'Inventory Engaged',
          }
        },
        totalReservations: {
          index: {
            title: 'Reservations',
          }
        },
        reservedInventory: {
          index: {
            title: 'Reserved Inventory',
          }
        },
        reservationRate: {
          index: {
            title: 'Reservation Rate',
          }
        },
        keyInsights: {
          index: {
            title: 'Key Insights',
            info: 'Plain-language observations generated from this period\'s inventory data.',
          },
          utils: {
            highestDemandIndex: {
              lowerInventory: '%{highestDemandCommunityProjectName} has the highest Inventory Demand Index <b>(%{highestDemandIndex})</b> despite having %{inventoryDifference}% less available inventory than %{highestInventoryCommunityProjectName}.',
              highestInventory: '%{highestDemandCommunityProjectName} has the highest Inventory Demand Index <b>(%{highestDemandIndex})</b> and the most available inventory.',
              equalInventory: '%{highestDemandCommunityProjectName} has the highest Inventory Demand Index <b>(%{highestDemandIndex})</b>, with the same available inventory as %{highestInventoryCommunityProjectName}.',
              singleInventory: '%{highestDemandCommunityProjectName} has the highest Inventory Demand Index <b>(%{highestDemandIndex})</b> among the selected communities / projects.',
              zeroDemand: 'The Inventory Demand Index is <b>0</b> for the selected period.',
            },
            reservationRate: {
              positive: 'Reservation rate improved to <b>%{value}</b>, up %{delta} pp from last period.',
              negative: 'Reservation rate dropped to <b>%{value}</b>, down %{delta} pp from last period.',
              neutral: 'Reservation rate remained flat at <b>%{value}</b>, unchanged from last period.',
            },
            buyerInterest: {
              belowThreshold: 'Buyer interest is concentrated below <b>$500K</b>, while <b>%{inventoryPercentage}%</b> of inventory is priced above it.',
              atOrAboveThreshold: 'Buyer interest is concentrated at or above <b>$500K</b>, while <b>%{inventoryPercentage}%</b> of inventory is priced below it.',
            },
            unengagedInventory: {
              zero: '<b>All listings</b> received buyer engagement this period.',
              one: '<b>1 listing (%{unengagedValue})</b> received no buyer engagement this period.',
              other: '<b>%{count} listings (%{unengagedValue})</b> received no buyer engagement this period.'
            },
          }
        },
        inventoryEngagement: {
          index: {
            title: 'Inventory Engagement',
            info: 'Share of available listings with at least one engaged buyer in the selected period.',
            engagedListings: 'Engaged Listings',
            unengagedListings: 'Unengaged Listings',
            unengagedInventoryValue: 'Unengaged Inventory Value',
            listings: {
              zero: 'No listings',
              one: '1 listing',
              other: '%{count} listings'
            },
            engaged: 'Engaged',
          }
        },
        demandIndexOverTimeChart: {
          index: {
            title: 'Inventory Demand Index Over Time',
            dailyInfo: 'Daily unique engaged buyers per available listing across the selected date range.',
            weeklyInfo: 'Weekly unique engaged buyers per available listing across the selected date range.',
            demandIndex: 'Demand Index',
          },
        },
        avgInventoryValue: {
          index: {
            title: 'Avg. Inventory Price',
          }
        },
        avgDaysOnMarket: {
          index: {
            title: 'Days on Market (Avg.)',
            days: {
              one: '1 day',
              other: '%{count} days',
            },
            trendUnit: {
              one: ' day',
              other: ' days',
            }
          }
        },
        soldInventory: {
          index: {
            title: 'Sold Inventory',
            listings: {
              one: 'listing',
              other: 'listings',
            }
          }
        },
        demandByCommunityProject: {
          index: {
            title: 'Demand by Community / Project',
            info: 'Available listings, unique engaged buyers, and reservations by community / project. Demand Index = unique engaged buyers per available listing.',
            csvFilename: 'Demand by Community - Project %{date}.csv',
            exportHeaders: {
              communityProject: 'Community / Project',
              available: 'Available',
              buyers: 'Buyers (Unique)',
              demandIndex: 'Demand Index',
              reservations: 'Reservations',
              reservationRate: 'Reservation Rate',
            },
            buttons: {
              viewAll: 'View All Communities / Projects'
            }
          },
          components: {
            listHeader: {
              index: {
                communityProject: 'Community / Project',
                available: 'Available',
                buyers: 'Buyers (Unique)',
                demandIndex: 'Demand Index',
                reservations: 'Reservations',
                reservationRate: 'Reservation Rate',
              }
            },
          },
          allCommunitiesProjectsModal: {
            index: {
              title: 'Demand by Community / Project',
              description: 'All %{count} communities / projects · %{dateRange} · same columns and metrics as the report'
            }
          }
        },
        demandByModel: {
          index: {
            title: 'Top Models by Demand Index',
            info: 'Models ranked by unique engaged buyers per available listing.',
            csvFilename: 'Top Models by Demand Index %{date}.csv',
            exportHeaders: {
              model: 'Model',
              available: 'Available',
              buyers: 'Buyers (Unique)',
              demandIndex: 'Demand Index',
            },
            buttons: {
              viewAll: 'View All Models',
            }
          },
          components: {
            listHeader: {
              index: {
                model: 'Model',
                available: 'Available',
                buyers: 'Buyers (Unique)',
                demandIndex: 'Demand Index',
              }
            }
          },
          allModelsModal: {
            index: {
              title: 'Top Models by Demand Index',
              description: 'All %{count} models · %{dateRange} · same columns and metrics as the report'
            }
          }
        }
      },
      documents: {
        index: {
          title: 'Documents',
          buttons: {
            add: 'Add Files'
          }
        },
        list: {
          index: {
            name: 'Name',
            size: 'Size',
            modifiedDate: 'Modified Date'
          }
        },
        uploader: {
          index: {
            title: 'Uploading files'
          }
        }
      },
      taxRates: {
        index: {
          title: 'Tax Rates',
          buttons: {
            add: 'Tax Rate'
          },
        },
        list: {
          index: {
            name: 'Name',
            rate: 'Rate',
            citiesCommunitiesProjects: 'Cities/Communities/Projects',
            type: 'Type',
            createdBy: 'Created By',
            lastModifiedBy: 'Last Modified By'
          }
        },
        show: {
          index: {
            taxRates: 'Tax Rates',
            tabs: {
              overview: 'Overview',
            },
            edit: 'Edit'
          },
          overview: {
            index: {
              name: 'Name',
              rate: 'Rate',
              type: 'Type',
              cities: 'Cities',
              communitiesProjects: 'Communities/Projects',
              createdBy: 'Created By',
              lastModifiedBy: 'Last Modified By'
            }
          }
        },
        form: {
          index: {
            newTitle: 'New Tax Rate',
            editTitle: 'Edit Tax Rate',
            name: 'Name',
            rate: 'Rate',
            communitiesProjects: 'Communities/Projects',
            cities: 'Cities',
            emptyCities: 'There\'s no cities',
            rateMessage: 'Tax rates are a decimal amount to aid in calculations, (i.e. if the tax rate is 5% then enter 0.05)',
            communityProjectBased: 'Community/Project based',
            cityBased: 'City based',
            buttons: {
              save: 'Save',
              cancel: 'Cancel'
            }
          }
        }
      },
      projects: {
        list: {
          index: {
            title: 'Projects',
            tabs: {
              all: 'All',
              published: 'Published',
              unpublished: 'Unpublished'
            },
            buttons: {
              add: 'Project'
            }
          },
          listView: {
            index: {
              name: 'Name',
              division: 'Division',
              city: 'City',
              state: 'Province/State',
              status: 'Status',
              buildingType: 'Building Type',
              publishedListingsCount: 'Number of Published Listings',
              type: 'Type',
              availability: 'Availability',
              createdBy: 'Created By',
              lastModifiedBy: 'Last Modified By'
            },
            listItem: {
              index: {
                types: {
                  rental: 'Rental',
                  forSale: 'For Sale'
                },
              }
            }
          }
        },
        form: {
          index: {
            newTitle: 'New Project',
            editTitle: 'Edit Project',
            name: 'Name',
            divisionId: 'Division',
            cityId: 'City',
            subRegion: 'Sub-Region',
            address: 'Address',
            province: 'Province / State',
            buildingType: 'Building Type',
            image: 'Image',
            availability: 'Availability',
            status: 'Status',
            type: 'Type',
            enableMakeOffer: 'Enable Make a Deal',
            enableInventoryInsights: 'Enable Inventory Insights',
            types: {
              rental: 'Rental',
              forSale: 'For Sale'
            },
            description: 'Description',
            longDescription: 'Long Description',
            flowForBuildAndPrice: 'Flow for Build and Price',
            startFromModelSelection: 'Start from Model Selection',
            startFromUnitSelection: 'Start from Unit Selection',
            hubSpotValue: 'HubSpot Value',
            websiteUrl: 'Website URL',
            placeholders: {
              websiteUrl: 'https://'
            },
          }
        },
        show: {
          components: {
            directLinkModal: {
              index: {
                title: 'Share Link',
                embeddedExperience: 'Embedded Experience',
                inventoryLink: 'Inventory Link',
                messages: {
                  copied: 'Link has been copied to clipboard.'
                },
                buttons: {
                  copy: 'Copy Link'
                }
              }
            }
          },
          summary: {
            details: {
              index: {
                projectId: 'Project ID',
                division: 'Division',
                city: 'City',
                address: 'Address',
                subRegion: 'Sub-Region',
                province: 'Province / State',
                buildingType: 'Building Type',
                availability: 'Availability',
                type: 'Type',
                types: {
                  rental: 'Rental',
                  for_sale: 'For Sale'
                },
                description: 'Description',
                longDescription: 'Long Description',
                createdBy: 'Created by',
                lastModifiedBy: 'Last Modified By',
                externalId: 'External ID',
                flowForBuildAndPrice: 'Flow for Build and Price',
                websiteUrl: 'Website URL',
                status: 'Status'
              },
            },
          },
          sections: {
            index: {
              tabs: {
                overview: 'Overview',
                packages: 'Packages',
                palettes: 'Palettes',
                salesRepresentatives: 'Sales Representatives / Teams',
                mortgageProviders: 'Mortgage Providers',
                reservationDocument: 'Reservation Document',
                salesHours: 'Sales Hours',
                modifications: 'Modifications'
              }
            },
            overview: {
              inventoryInsights: {
                index: {
                  publishedListings: 'Published Listings',
                  reservations: 'Reservations',
                }
              }
            },
            salesHours: {
              index: {
                timezone: 'Time zone',
                helpTexts: {
                  timezone: 'The hours below apply to this time zone.',
                },
                messages: {
                  saved: 'Sales Hours saved!'
                }
              }
            }
          }
        }
      },
      projectBuildings: {
        list: {
          index: {
            title: 'Buildings',
            buttons: {
              add: 'Building'
            }
          },
          listView: {
            index: {
              name: 'Name',
              project: 'Project',
              availability: 'Availability',
              status: 'Status',
              createdBy: 'Created By',
              lastModifiedBy: 'Last Modified By'
            }
          }
        },
        form: {
          index: {
            newTitle: 'New Building',
            editTitle: 'Edit Building',
            projectId: 'Project',
            name: 'Name',
            description: 'Description',
            availability: 'Availability',
            status: 'Status'
          }
        },
        show: {
          summary: {
            details: {
              index: {
                projectBuildingId: 'Building ID',
                externalId: 'External ID',
                project: 'Project',
                description: 'Description',
                availability: 'Availability',
                status: 'Status',
                createdBy: 'Created By',
                lastModifiedBy: 'Last Modified By'
              }
            }
          },
          sections: {
            index: {
              tabs: {
                models: 'Models',
                floors: 'Floors',
                images: 'Images',
                modifications: 'Modifications'
              }
            },
            models: {
              index: {
                buttons: {
                  add: 'Add Model'
                }
              }
            },
            buildingFloors: {
              index: {
                buttons: {
                  add: 'Add Floor'
                }
              },
              buildingFloorFormModal: {
                index: {
                  newTitle: 'New Floor',
                  editTitle: 'Edit Floor',
                  name: 'Name',
                  description: 'Description',
                  image: 'Image'
                }
              },
              unitsMultiSelect: {
                index: {
                  selectUnits: 'Select Units',
                  empty: 'No Units Available'
                }
              },
              buildingFloor: {
                actionsMenu: {
                  index: {
                    moveUp: 'Move Up',
                    moveDown: 'Move Down'
                  }
                },
              }
            },
          }
        }
      },
      units: {
        components: {
          unitFormModal: {
            index: {
              titleNew: 'Create a New Unit',
              titleEdit: 'Update Unit',
              descriptionNew: 'By filling in the details below you will create a published unit.',
            },
            form: {
              index: {
                buildingModelId: 'Model',
                price: 'Price',
                name: 'Unit Name',
                floor: 'Floor',
                availability: 'Availability',
                floorLocation: 'Floor Location',
                view: 'View',
                image: 'Image',
                tourUrl: '3D Tour URL',
                openTourUrlInOverlayWindow: 'Open this URL in overlay window (please check X-Frame-Options of this URL)',
                uTourUrl: 'UTour URL',
                status: 'Status',
                discountedPrice: 'Discounted Price',
              }
            },
          }
        },
        list: {
          index: {
            title: 'Units',
            searchBarPlaceholder: 'Search by name or ID',
            buttons: {
              add: 'Unit'
            },
            tabs: {
              all: 'All Listings',
              published: 'Published',
              unpublished: 'Unpublished',
              available: 'Available',
              comingSoon: 'Coming Soon',
              sold: 'Sold',
              archived: 'Archived',
            }
          },
          components: {
            filtersModal: {
              index: {
                title: 'Filters',
                description: 'Apply filters'
              },
              projectFilter: {
                index: {
                  title: 'Project'
                }
              },
              buildingModelFilter: {
                index: {
                  title: 'Model'
                }
              },
              bedsFilter: {
                index: {
                  title: 'Beds',
                  beds: '%{count} Beds'
                }
              },
              bathsFilter: {
                index: {
                  title: 'Baths',
                  baths: '%{count} Baths'
                }
              },
              availabilityFilter: {
                index: {
                  title: 'Availability'
                }
              },
              statusFilter: {
                index: {
                  title: 'Status'
                }
              }
            },
            exportModal: {
              index: {
                title: 'Export Units',
                messages: {
                  exporting: 'Exporting the unit list, please wait...',
                  exported: 'The unit list has been exported successfully!'
                }
              }
            },
            bulkSelectionSection: {
              index: {
                selected: '<b>%{count}</b> selected',
                clearSelection: 'Clear Selection'
              }
            },
            bulkUpdateModal: {
              index: {
                title: 'Bulk Update Listings',
                description: 'Update %{count} selected listings',
                availability: 'Availability',
                status: 'Status',
                buttons: {
                  update: 'Update Listings',
                },
                messages: {
                  updated: {
                    one: '%{count} listing successfully updated.',
                    other: '%{count} listings successfully updated.',
                  }
                }
              }
            }
          }
        },
        show: {
          index: {
            units: 'Units',
          },
          navTabs: {
            index: {
              details: 'Details',
              options: 'Options',
              images: 'Images',
              deals: 'Deals',
              modifications: 'Modifications'
            }
          },
          heroSection: {
            index: {
              multiFamily: 'Multi-Family',
              floor: 'Floor %{floor}',
            }
          },
          components: {
            directLinkModal: {
              index: {
                title: 'Share Link',
                reserveNow: 'Reserve Now',
                buttons: {
                  inviteCustomer: 'Invite Customer',
                }
              }
            }
          },
          details: {
            statsCard: {
              index: {
                beds: 'Beds',
                baths: 'Baths',
                squareFootage: 'Sq Ft',
                floor: 'Floor',
              }
            },
            priceCard: {
              index: {
                title: 'Price',
                save: 'Save'
              }
            },
            projectModelCard: {
              index: {
                title: 'Project & Model',
                project: 'Project',
                model: 'Model',
                address: 'Address',
              }
            },
            visibilityCard: {
              index: {
                title: 'Visibility',
                status: 'Status',
                availability: 'Availability',
                featured: 'Featured',
              }
            },
            propertyDetailsCard: {
              index: {
                title: 'Property Details',
                squareFootage: 'Square Footage',
                beds: 'Beds',
                baths: 'Baths',
                floor: 'Floor',
                floorLocation: 'Floor Location',
                view: 'View',
                tourUrl: '3D Tour URL',
                uTourUrl: 'UTour URL',
                unitId: 'Unit ID',
                externalId: 'External ID',
                name: 'Unit Name',
                createdBy: 'Created By',
                lastModifiedBy: 'Last Modified By',
              }
            }
          },
          options: {
            index: {
              listEmpty: {
                title: 'No options yet',
                description: 'Options added to this unit will appear here.',
              },
              buttons: {
                add: 'Add Option'
              }
            },
            optionFormModal: {
              index: {
                title: 'Option Form',
                price: 'Price'
              }
            }
          },
          images: {
            index: {
              errors: {
                notUploaded: 'One or more images failed to upload. Please try again.'
              },
              listEmpty: {
                title: 'No images yet',
                description: 'Images uploaded to this unit will appear here.',
              },
            }
          }
        }
      },
      optionTypes: {
        list: {
          index: {
            heading: 'Option Types',
            title: 'Option Types',
            buttons: {
              add: 'Add Option Type'
            }
          }
        },
        form: {
          index: {
            name: 'Name',
            newTitle: 'New Option Type',
            editTitle: 'Edit Option Type',
            image: 'Image',
            description: 'Description'
          }
        },
        show: {
          index: {
            name: 'Name',
            description: 'Description',
            tabs: {
              overview: 'Overview',
              modifications: 'Modifications'
            }
          },
          overview: {
            index: {
              name: 'Name',
              description: 'Description',
              createdBy: 'Created By',
              lastModifiedBy: 'Last Modified By'
            }
          }
        }
      },
      deposits: {
        list: {
          index: {
            title: 'Deposits',
            searchBar: {
              placeholder: 'Search'
            }
          },
          listView: {
            listHeader: {
              index: {
                date: 'Date',
                customer: 'Customer',
                communityProject: 'Community/Project',
                property: 'Property',
                amount: 'Amount',
                paymentMethod: 'Payment Method',
                status: 'Status'
              }
            },
            listItem: {
              status: {
                index: {
                  partialRefund: 'Partial Refund',
                  refunded: 'Refunded',
                  pending: 'Pending',
                  success: 'Success',
                  failed: 'Failed',
                  rejected: 'Rejected',
                  authorized: 'Funds Authorized',
                  released: 'Released'
                }
              }
            }
          }
        }
      },
      externalDataSources: {
        index: {
          title: 'External Data Sources',
          buttons: {
            salesSimplicity: 'Sales Simplicity',
            marondaHomes: 'Maronda Homes'
          }
        },
        show: {
          index: {
            integrations: 'Integrations',
            externalDataSources: 'External Data Sources',
            config: 'Config',
            dataProviders: {
              salesSimplicity: 'Sales Simplicity',
              marondaHomes: 'Maronda Homes',
            },
            buttons: {
              add: 'Add Config',
              edit: 'Edit Config',
              startSync: 'Start Sync',
              syncing: 'Syncing',
              getBuiltOptionsReport: 'Get Built Options Report',
              startPriceRulesSync: 'Start Price Rules Sync',
              syncingPriceRules: 'Syncing Price Rules'
            }
          }
        },
        form: {
          index: {
            integrations: 'Integrations',
            externalDataSources: 'External Data Sources',
            dataProviders: {
              salesSimplicity: 'Sales Simplicity Config',
              marondaHomes: 'Maronda Homes Config'
            }
          }
        },
        salesSimplicity: {
          details: {
            index: {
              username: 'Username',
              password: 'Password',
              token: 'Token',
            }
          },
        },
        marondaHomes: {
          details: {
            index: {
              apiKey: 'API Key',
              proxy: 'Proxy',
              proxyHost: 'Server',
              proxyPort: 'Port',
              proxyUsername: 'Username',
              proxyPassword: 'Password'
            }
          }
        },
        syncLogs: {
          index: {
            createdProductTypes: 'Created Product Types',
            updatedProductTypes: 'Updated Product Types',
            createdModels: 'Created Models:',
            updatedModels: 'Updated Models:',
            createdCommunities: 'Created Communities:',
            updatedCommunities: 'Updated Communities:',
            createdCommunityModels: 'Created Community Models:',
            updatedCommunityModels: 'Updated Community Models:',
            createdCommunityProductTypes: 'Created Community Product Types:',
            updatedCommunityProductTypes: 'Updated Community Product Types:',
            createdElevations: 'Created Elevations',
            updatedElevations: 'Updated Elevations',
            createdCommunityElevations: 'Created Community Elevations',
            updatedCommunityElevations: 'Updated Community Elevations',
            createdFloorOptions: 'Created Floor Options',
            updatedFloorOptions: 'Updated Floor Options',
            updatedPriceRuleIds: 'Updated Price Rule Ids',
            lastReport: 'Last Report (%{lastSyncDate})',
            errors: 'Errors:',
          }
        },
        builtOptionsReport: {
          index: {
            title: 'Built Options Report',
            titles: {
              firstRange: '5 - 7 Times',
              secondRange: '8 - 10 Times',
              thirdRange: '11 - 20 Times',
              fourthRange: '20 - 50 Times',
              fifthRange: '> 50 Times',
            },
          },
          reportChart: {
            index: {
              labels: {
                timesRepeated: 'Times Repeated'
              }
            }
          }
        }
      },
      buildingModels: {
        list: {
          index: {
            title: 'Models',
            buttons: {
              add: 'Add Model'
            }
          },
          buildingFilter: {
            index: {
              all: 'All',
              building: 'Building'
            }
          },
          gridView: {
            listItem: {
              index: {
                bath: '%{baths} Bath',
                bed: '%{beds} Bed',
                sizeSqft: '%{size} SqFt',
              }
            }
          },
          listView: {
            index: {
              name: 'Name',
              size: 'Size',
              bedrooms: 'Bedrooms',
              bathrooms: 'Bathrooms',
              createdBy: 'Created By',
              lastModifiedBy: 'Last Modified By'
            }
          }
        },
        show: {
          components: {
            navTabs: {
              index: {
                floors: 'Floors',
                images: 'Images',
                packages: 'Packages',
                palettes: 'Palettes',
                modifications: 'Modifications'
              }
            },
            directLinkModal: {
              index: {
                title: 'Share Link',
                previewTitle: 'Preview Link',
                selectProject: 'Select Project',
                selectBuilding: 'Select Building',
                noProjects: 'No Projects Available',
                noBuildings: 'No Buildings Available',
                embeddedExperience: 'Embedded Experience',
                messages: {
                  copied: 'Link has been copied to clipboard.'
                },
                buttons: {
                  copy: 'Copy Link'
                }
              }
            },
          },
          summary: {
            details: {
              index: {
                modelId: 'Model ID',
                externalId: 'External ID',
                project: 'Project',
                size: 'Size (sq.ft.)',
                longDescription: 'Long Description',
                createdBy: 'Created By',
                lastModifiedBy: 'Last Modified By'
              }
            },
          },
          sections: {
            images: {
              index: {
                useImageGallery: 'Use image gallery instead of model image'
              },
              listItem: {
                index: {
                  isDefault: 'Default',
                  buttons: {
                    markAsDefault: 'Mark as default'
                  }
                }
              }
            },
            packages: {
              listItem: {
                index: {
                  default: 'Default',
                  delete: 'Delete',
                  setDefault: 'Set as Default'
                }
              },
              buildingModelPackageFormModal: {
                index: {
                  title: 'Package Settings: %{packageName}',
                  price: 'Price',
                  isDefault: 'Default'
                }
              }
            },
            palettes: {
              listItem: {
                index: {
                  default: 'Default',
                }
              },
              buildingModelPaletteFormModal: {
                index: {
                  title: 'Palette Settings: %{paletteName}',
                  price: 'Price',
                  isDefault: 'Default'
                }
              }
            },
          },
        },
        form: {
          index: {
            newTitle: 'New Model',
            editTitle: 'Edit Model',
            projectId: 'Project',
            name: 'Name',
            longDescription: 'Long Description',
            image: 'Model Image',
            size: 'Size',
            bedrooms: 'Bedrooms',
            bathrooms: 'Bathrooms'
          }
        },
      },
      tours: {
        list: {
          index: {
            title: 'Tours',
            user: 'User',
            date: 'Date',
            type: 'Type',
            company: 'Company',
            types: {
              scheduled: 'Scheduled',
              rescheduled: 'Rescheduled',
              missed: 'Missed',
              completed: 'Completed',
              deleted: 'Deleted',
              cancelled: 'Cancelled'
            }
          }
        }
      },
      quickPossessions: {
        components: {
          quickPossessionFormModal: {
            form: {
              index: {
                titleNew: 'Create a New Home',
                titleEdit: 'Update Home',
                descriptionNew: 'By filling in the details below you will create a published home.',
              }
            },
            confirm: {
              index: {
                title: 'Confirm the creation of this model',
                description: 'You\'re about to add a new home model to your online inventory. This action will make the model visible to potential buyers.',
                buttons: {
                  save: 'Yes, Add Model'
                }
              },
              homeInfo: {
                index: {
                  description: 'Description:'
                }
              }
            }
          },
        },
        list: {
          index: {
            title: 'Inventory',
            searchBarPlaceholder: 'Search for Inventory',
            buttons: {
              add: 'Quick Possession'
            },
            tabs: {
              all: 'All Listings',
              published: 'Published',
              unpublished: 'Unpublished',
              available: 'Available',
              comingSoon: 'Coming Soon',
              sold: 'Sold',
              archived: 'Archived',
            }
          },
          listItem: {
            index: {
              community: 'Community',
              model: 'Model',
              totalPrice: 'Total Price',
              status: 'Status',
              address: 'Address',
              availability: 'Availability'
            }
          },
          components: {
            exportModal: {
              index: {
                title: 'Export Listings',
                messages: {
                  exporting: 'Exporting the listings, please wait...',
                  exported: 'The listings has been exported successfully!'
                }
              }
            },
            filtersModal: {
              index: {
                title: 'Filters',
                description: 'Apply filters'
              },
              communityFilter: {
                index: {
                  title: 'Community'
                }
              },
              modelFilter: {
                index: {
                  title: 'Model'
                }
              },
              productTypeFilter: {
                index: {
                  title: 'Product Type'
                }
              },
              bedsFilter: {
                index: {
                  title: 'Beds'
                },
                lisItem: {
                  index: {
                    beds: '%{count} Beds'
                  }
                }
              },
              bathsFilter: {
                index: {
                  title: 'Baths'
                },
                lisItem: {
                  index: {
                    baths: '%{count} Baths'
                  }
                }
              },
              availabilityFilter: {
                index: {
                  title: 'Availability'
                }
              },
              statusFilter: {
                index: {
                  title: 'Status'
                }
              },
              divisionFilter: {
                index: {
                  title: 'Division'
                }
              }
            },
            bulkSelectionSection: {
              index: {
                selected: '<b>%{count}</b> selected',
                clearSelection: 'Clear Selection'
              }
            },
            bulkUpdateModal: {
              index: {
                title: 'Bulk Update Listings',
                description: 'Update %{count} selected listings',
                availability: 'Availability',
                status: 'Status',
                buttons: {
                  update: 'Update Listings',
                },
                messages: {
                  updated: {
                    one: '%{count} listing successfully updated.',
                    other: '%{count} listings successfully updated.',
                  }
                }
              }
            }
          }
        },
        show: {
          index: {
            title: 'Inventory',
            name: '%{modelName} in %{communityName}',
          },
          navTabs: {
            index: {
              overview: 'Overview',
              images: 'Images',
              deals: 'Deals',
              modifications: 'Modifications'
            }
          },
          heroSection: {
            index: {
              singleFamily: 'Single Family'
            }
          },
          overview: {
            statsCard: {
              index: {
                beds: 'Beds',
                baths: 'Baths',
                garages: 'Garages',
                squareFootage: 'Sq Ft',
              }
            },
            priceCard: {
              index: {
                title: 'Price',
                save: 'Save'
              }
            },
            communityModelCard: {
              index: {
                title: 'Community & Model',
                community: 'Community',
                model: 'Model',
                address: 'Address',
              }
            },
            visibilityCard: {
              index: {
                title: 'Visibility',
                status: 'Status',
                availability: 'Availability',
                featured: 'Featured',
              }
            },
            propertyDetailsCard: {
              index: {
                title: 'Property Details',
                squareFootage: 'Square Footage',
                beds: 'Beds',
                baths: 'Baths',
                garages: 'Garages',
                description: 'Description',
                url: 'URL',
                lotId: 'Lot ID',
                tourUrl: '3D Tour URL',
                uTourUrl: 'UTour URL',
                listingId: 'Listing ID',
                externalId: 'External ID',
                productType: 'Product Type',
                elevation: 'Elevation',
                package: 'Package',
                palette: 'Palette',
              }
            }
          },
          directLinkModal: {
            index: {
              title: 'Share Link',
              name: '%{modelName} in %{communityName}',
              reserveNow: 'Reserve Now',
              embeddedExperience: 'Embedded Experience',
              buttons: {
                inviteCustomer: 'Invite Customer',
              }
            }
          },
          images: {
            index: {
              errors: {
                notUploaded: 'One or more images failed to upload. Please try again.'
              },
              listEmpty: {
                title: 'No images yet',
                description: 'Images uploaded to this listing will appear here.',
              },
            }
          }
        }
      },
      myProfile: {
        show: {
          index: {
            title: 'My Profile',
          },
          navTabs: {
            index: {
              basicInfo: 'Basic Info',
              security: 'Security'
            }
          },
          basicInfo: {
            index: {
              image: 'Profile Image',
              name: 'Name',
              jobTitle: 'Job Title',
              email: 'Email',
              phone: 'Phone',
              company: 'Company',
              role: 'Role',
              divisions: 'Divisions',
              communitiesProjects: 'Communities/Projects'
            }
          },
          security: {
            index: {
              currentPassword: 'Current Password',
              newPassword: 'New Password',
              confirmPassword: 'Confirm Password',
              messages: {
                success: 'Your password has been changed'
              }
            }
          }
        },
        form: {
          index: {
            title: 'Edit My Profile',
            messages: {
              updated: 'Your info has been successfully updated!',
            }
          }
        }
      },
      messages: {
        list: {
          index: {
            title: 'Messages',
            name: 'Name',
            phoneNumber: 'Phone number',
            email: 'Email',
            building: 'Building',
            message: 'Message',
            date: 'Date'
          }
        }
      },
      masterAdminDashboard: {
        index: {
          title: 'Ownly Dashboard'
        },
        visitorLeadsTable: {
          index: {
            company: 'Company',
            totalVisitors: 'Total Visitors',
            returningVisitors: 'Returning Visitors',
            newLeads: 'New Leads',
            reserveStarts: 'Reserve Starts',
            reserveCompletes: 'Reserve Completes',
            verifiedStarts: 'Verified Starts',
            verifiedCompletes: 'Verified Completes'
          },
          listItem: {
            index: {
              website: 'Website',
              ownly: 'Ownly',
              previous: 'Previous: ',
              noPreviousData: 'No previous data'
            }
          }
        }
      },
      sales: {
        components: {
          dealList: {
            searchBar: {
              index: {
                title: 'Search'
              }
            },
            assignedToFilter: {
              index: {
                select: 'All sales people',
              }
            },
            filtersModal: {
              index: {
                title: 'Filters',
                description: 'Apply filters'
              },
              completedDealStatusFilter: {
                index: {
                  title: 'Completed Deal Status'
                }
              },
              communityProjectFilter: {
                index: {
                  title: 'Community/Project'
                }
              },
              dealPriceFilter: {
                index: {
                  title: 'Deal Price'
                }
              },
              realtorFilter: {
                index: {
                  title: 'Realtor'
                }
              },
            },
            list: {
              listHeader: {
                index: {
                  customer: 'Customer',
                  dealPrice: 'Deal Price',
                  dealState: 'Deal State',
                  modelUnit: 'Model/Unit',
                  communityProject: 'Community/Project',
                  homeSales: {
                    financialAmount: 'Buying Power'
                  },
                  homeRental: {
                    financialAmount: 'Renting Power'
                  },
                  realtor: 'Realtor',
                  lastActive: 'Last Active',
                }
              },
              listItem: {
                index: {
                  preApproval: 'Pre Approval'
                }
              }
            }
          }
        },
        contracts: {
          list: {
            index: {
              title: 'Contracts'
            }
          }
        },
        deals: {
          index: {
            title: 'Deals'
          },
          show: {
            index: {
              title: 'Deal',
            },
            components: {
              backLink: {
                index: {
                  deals: 'Deals'
                }
              }
            },
            customerCard: {
              index: {
                title: 'Customer',
                email: 'Email',
                phone: 'Phone',
                preApproval: 'Pre-approval',
                maxAffordability: 'Max Affordability',
                coBuyer: '+1 co-coyer',
              }
            },
            dealPropertiesCard: {
              index: {
                title: 'Deal Properties',
                dealStatus: 'Deal Status',
                requiredDepositAmount: 'Required Deposit Amount',
                realtor: 'Realtor',
                assignedTo: 'Assigned To',
                created: 'Created'
              },
              acceptOfferSection: {
                index: {
                  title: 'Accept Offer',
                  customerOffered: 'Customer offered',
                  confirmCustomerOffered: 'Confirm customer offer',
                  requiredDepositAmount: 'Required deposit amount',
                  buttons: {
                    accept: 'Accept'
                  },
                  confirmAlert: {
                    message: 'Please confirm you want to accept this offer.'
                  }
                }
              },
              counterOfferSection: {
                index: {
                  title: 'Counter Offer',
                  counterOfferPrice: 'Counter offer',
                  confirmCounterOfferPrice: 'Confirm counter offer',
                  buttons: {
                    counter: 'Counter'
                  }
                }
              },
              declineOfferSection: {
                index: {
                  title: 'Decline',
                  description: 'Decline the customer offer.',
                  buttons: {
                    decline: 'Decline'
                  },
                  confirmAlert: {
                    message: 'Please confirm you want to decline this offer.'
                  }
                }
              },
            },
            homeCard: {
              index: {
                title: 'Home',
                quickPossession: 'Listing',
                unit: 'Unit',
                lot: 'Lot'
              }
            },
            activityCard: {
              index: {
                title: 'Activity',
              }
            },
            signCard: {
              index: {
                title: 'Sign',
                signStatus: 'Sign Status'
              },
              components: {
                downloadSignedDocumentButton: {
                  index: {
                    downloadSignedDocument: 'Download signed document',
                    noSignedDocument: 'There was a problem getting the signed document.',
                  }
                }
              },
              notStartedSection: {
                index: {
                  title: 'Not Started',
                  description: 'Signing has not been initiated.',
                }
              },
              pendingSection: {
                index: {
                  title: 'Awaiting Signing',
                  description: 'Signing has not been completed.'
                }
              },
              submittedSection: {
                confirmSignSection: {
                  index: {
                    title: 'Confirm Signature',
                    description: 'The customer has signed the deal document. Confirm that you have received the deal document signed from the customer.',
                    signConfirmed: 'Signature Confirmed',
                    buttons: {
                      confirm: 'Confirm',
                    },
                    confirmAlert: {
                      message: 'Please confirm you want to accept this signature.'
                    }
                  }
                },
                rejectSignSection: {
                  index: {
                    title: 'Signature Problem',
                    description: 'There was a problem with the signature. Add a note that will be sent to the user.',
                    signNote: 'Note',
                    placeholders: {
                      signNote: 'Describe the signature issue...',
                    },
                    buttons: {
                      reject: 'Report Signature Problem'
                    }
                  }
                },
              },
              declinedSection: {
                index: {
                  title: 'Signature Declined',
                  description: 'The customer has declined to sign the document.'
                }
              },
              rejectedSection: {
                index: {
                  title: 'Signature Problem',
                }
              },
            },
            depositCard: {
              components: {
                requiredDepositAmountSection: {
                  index: {
                    requiredDepositAmount: 'Required deposit amount',
                  }
                },
                paymentDetailsSection: {
                  index: {
                    date: 'Date',
                    amount: 'Amount',
                    paymentMethod: 'Payment Method',
                  }
                }
              },
              index: {
                title: 'Deposit',
                status: 'Status',
              },
              notStartedSection: {
                index: {
                  title: 'Not Started',
                  description: 'Deposit has not been initiated.'
                }
              },
              pendingSection: {
                index: {
                  title: 'Awaiting Deposit',
                  description: 'Deposit has not been completed.'
                }
              },
              submittedSection: {
                confirmDepositSection: {
                  index: {
                    title: 'Confirm Deposit',
                    description: 'The customer has supplied to you a deposit. Confirm that you have received the credit card deposit from the customer.',
                    amount: 'Deposit',
                    confirmAmount: 'Confirm Deposit',
                    buttons: {
                      confirm: 'Confirm Deposit'
                    },
                    confirmAlert: {
                      message: 'Please confirm you want to accept this deposit.'
                    }
                  }
                },
                rejectDepositSection: {
                  index: {
                    title: 'Deposit Problem',
                    description: 'There was a problem with the deposit. Add a note that will be sent to the user.',
                    note: 'Note',
                    buttons: {
                      reject: 'Deposit Problem'
                    }
                  }
                }
              },
              rejectedSection: {
                index: {
                  title: 'Deposit Problem',
                }
              },
              refundDepositSection: {
                index: {
                  refundedAmount: 'Refunded Amount',
                  buttons: {
                    refundDeposit: 'Refund Deposit'
                  }
                }
              },
            }
          },
          filters: {
            index: {
              searchBar: {
                title: 'Search'
              },
            }
          },
          list: {
            index: {
              title: 'Deals'
            },
            listView: {
              index: {
                customer: 'Customer',
                dealPrice: 'Deal Price',
                dealState: 'Deal State',
                modelUnit: 'Model/Unit',
                communityProject: 'Community/Project',
                homeSales: {
                  financialAmount: 'Buying Power'
                },
                homeRental: {
                  financialAmount: 'Renting Power'
                },
                realtor: 'Realtor',
                lastActive: 'Last Active',
              },
            }
          }
        },
      },
      propertyTaxRates: {
        list: {
          index: {
            title: 'Property Tax Rates',
            search: 'Country, State or City',
            country: 'Country',
            state: 'State',
            city: 'City',
            taxRate: 'Tax Rate',
            isDefault: 'Default',
            buttons: {
              add: 'Property Tax Rate'
            }
          }
        },
        form: {
          index: {
            newTitle: 'New Property Tax Rate',
            editTitle: 'Edit Property Tax Rate',
            country: 'Country',
            state: 'State',
            city: 'City',
            isDefault: 'Default City',
            taxRate: 'Tax Rate'
          }
        }
      },
      mortgageProviders: {
        components: {
          formModal: {
            index: {
              newTitle: 'Create a Mortgage Provider',
              editTitle: 'Edit Mortgage Provider',
              form: {
                name: 'Mortgage Provider Name',
                url: 'Mortgage Provider Link',
                image: 'Image'
              },
              placeholders: {
                name: 'Mortgage Provider Name',
                url: 'https://'
              }
            }
          },
        },
        list: {
          index: {
            title: 'Mortgage Providers',
            buttons: {
              add: 'Add Mortgage Provider'
            }
          }
        }
      },
      divisions: {
        components: {
          formModal: {
            index: {
              newTitle: 'Create a Division',
              editTitle: 'Edit Division',
              form: {
                name: 'Division Name',
                url: 'URL',
                streetAddress: 'Street Address',
                city: 'City',
                country: 'Country',
                state: 'State',
                postalCode: 'Postal Code',
                salesCenterPhone: 'Sales Center Phone',
                primaryContact: {
                  title: 'Primary Contact',
                  name: 'Primary Contact Name',
                  email: 'Primary Contact\'s Email Address',
                  phone: 'Primary Contact\'s Phone'
                },
                supportContact: {
                  title: 'Support Contact',
                  name: 'Support Contact Name',
                  email: 'Support Contact\'s Email Address',
                  phone: 'Support Contact\'s Phone'
                }
              },
              placeholders: {
                url: 'https://'
              }
            }
          }
        },
        list: {
          index: {
            title: 'Divisions',
            buttons: {
              add: 'Create Division'
            }
          },
          listHeader: {
            index: {
              name: 'Name',
              createdAt: 'Created At'
            }
          }
        },
        show: {
          index: {
            divisions: 'Divisions'
          },
          navTabs: {
            index: {
              overview: 'Overview',
              communitiesProjects: 'Communities / Projects',
              divisionOverrides: 'Division Overrides'
            }
          },
          overview: {
            index: {
              name: 'Division Name',
              url: 'URL',
              streetAddress: 'Street Address',
              city: 'City',
              country: 'Country',
              state: 'State',
              postalCode: 'Postal Code',
              salesCenterPhone: 'Sales Center Phone',
              primaryContactName: 'Primary Contact Name',
              primaryContactEmail: 'Primary Contact\'s Email Address',
              primaryContactPhone: 'Primary Contact\'s Phone',
              supportContactName: 'Support Contact Name',
              supportContactEmail: 'Support Contact\'s Email Address',
              supportContactPhone: 'Support Contact\'s Phone'
            }
          },
          communitiesProjects: {
            index: {
              communities: 'Communities',
              projects: 'Projects',
            },
            communityProjectDropdown: {
              index: {
                communities: 'Communities',
                projects: 'Projects',
                buttons: {
                  add: 'Add Community / Project'
                }
              }
            }
          },
          divisionOverrides: {
            index: {
              messages: {
                saved: 'Division override settings saved.'
              },
              buttons: {
                save: 'Save Overrides'
              }
            },
            components: {
              divisionOverrideBadge: {
                index: {
                  title: 'Division Override'
                }
              }
            },
            stripeSettingsSection: {
              index: {
                title: 'Stripe Settings'
              }
            },
            docuSignSettingsSection: {
              index: {
                title: 'Document Sign for Reservation',
              }
            },
            reserveNowWorkflowSettingsSection: {
              index: {
                title: 'ReserveNow Workflow'
              }
            }
          }
        }
      },
      oauthApplications: {
        components: {
          formModal: {
            index: {
              newTitle: 'Create an App',
              editTitle: 'Edit App',
              form: {
                name: 'App Name',
                clientId: 'Client ID',
                accessTokenExpiresIn: 'Access Token Expiration Time (hours)',
                refreshTokenExpiresIn: 'Refresh Token Expiration Time (days)',
                reservationSourceSlug: 'Reservation Source Slug',
              },
              buttons: {
                regenerateClientSecret: 'Regenerate Client Secret'
              },
              regenerateClientSecretCard: {
                title: 'Regenerate Client Secret',
                description: 'Are you sure you want to regenerate this secret?'
              }
            }
          },
          secretModal: {
            index: {
              title: 'Here\'s the secret, keep it safe',
              clientSecret: 'Client Secret',
              messageCard: {
                title: 'We\'ll show you this secret just once',
                description: 'This secret will disappear when you click "Got it". Don’t worry, you can generate a new secret if you lose this one.'
              }
            }
          }
        },
        list: {
          index: {
            title: 'Developer Apps',
            buttons: {
              add: 'Create App'
            }
          },
          listHeader: {
            index: {
              name: 'Name',
              clientId: 'Client ID',
              reservationSourceSlug: 'Reservation Source Slug',
              createdAt: 'Created At'
            }
          }
        },
      },
      salesLeaderboard: {
        list: {
          components: {
            exportModal: {
              index: {
                title: 'Export Sales Leaderboard',
                messages: {
                  exporting: 'Exporting the sales leaderboard, please wait...',
                  exported: 'The sales leaderboard has been exported successfully!'
                }
              }
            }
          },
          index: {
            title: 'Sales Leaderboard',
            description: 'Track profile views, inventory visits, direct invitations, leads, and reservations — with full attribution breakdown per community/project.',
            searchBar: {
              namePlaceholder: 'Name',
              communityProjectPlaceholder: 'Community / Project'
            }
          },
          communityProjectFilterChips: {
            index: {
              title: 'Community / Project',
              all: 'All',
              showMore: '+%{hiddenCount} more',
              showLess: 'Show less'
            }
          },
          divisionFilterChips: {
            index: {
              title: 'Division',
              all: 'All',
            }
          },
          navTabs: {
            index: {
              salesPeople: 'Sales People',
              communitiesProject: 'Communities / Projects'
            }
          },
          listHeader: {
            index: {
              salesRep: 'Sales Person',
              communityProject: 'Community / Project',
              profileVisitors: 'Profile Visits',
              inventoryVisitors: 'Inv. Visits',
              directInvites: 'Direct Invites',
              leads: 'Leads',
              reservations: 'Reservations'
            }
          },
          listItem: {
            index: {
              attributions: {
                profileLink: 'Profile Link ×%{count}',
                invite: 'Invite ×%{count}',
                assigned: 'Assigned ×%{count}'
              }
            },
            userItem: {
              index: {
                showMore: '+%{hiddenCount} more',
                showLess: 'Show less'
              }
            }
          },
          stats: {
            index: {
              profileVisits: 'Profile Visits',
              inventoryVisits: 'Inv. Visits',
              directInvites: 'Direct Invites',
              leads: 'Leads',
              reservations: 'Reservations'
            }
          },
        }
      },
      attributionReport: {
        index: {
          title: 'Attribution Report',
          dailyVisitorTrends: 'Daily Visitor Trends'
        },
        trackingParamsMetricsChart: {
          index: {
            visitors: 'Visitors',
            returningVisitors: 'Returning Visitors',
            leads: 'Leads',
            showingDataFor: 'Showing data for: '
          }
        },
        trackingParamsMetricsTable: {
          components: {
            typeFilter: {
              index: {
                select: 'All Types'
              }
            },
            sourceFilter: {
              index: {
                select: 'All Sources'
              }
            }
          },
          listHeader: {
            index: {
              source: 'Source',
              type: 'Type',
              visitors: 'Visitors',
              returningVisitors: 'Returning Visitors',
              leads: 'Leads',
              conv: 'Conv. %'
            }
          }
        }
      }
    }
  },
  views: {
    sales: {
      main: {
        main: {
          index: {
            title: 'Main',
          },
          profileCard: {
            profileMetrics: {
              index: {
                profileVisitors: 'Profile Visitors',
                leads: 'Leads',
                inventory: 'Inventory'
              }
            }
          },
          shareCard: {
            index: {
              title: 'Share Profile',
              qrCode: 'QR Code',
              preview: 'Preview',
              copyLink: 'Copy Link',
              shareLink: 'Share Link',
              messages: {
                copied: 'Link has been copied to clipboard.'
              },
              profileLink: 'Profile Link',
            }
          },
          dashboardMetrics: {
            index: {
              totalViews: 'Total Views',
              deals: 'Deals',
              thisWeek: 'this week',
              thisMonth: 'this month'
            }
          }
        }
      },
      customers: {
        list: {
          index: {
            title: 'Customers',
            searchBar: {
              placeholder: 'Search for customers'
            }
          }
        },
        show: {
          index: {
            backText: 'Customers',
            errors: {
              notFound: 'Customer not found',
            }
          },
          overview: {
            index: {
              title: 'Details'
            }
          }
        }
      },
      inventory: {
        list: {
          index: {
            title: 'Inventory',
            searchBar: {
              placeholder: 'Search for inventory'
            }
          },
          components: {
            inviteToReserveButton: {
              index: {
                title: 'Invite to Reserve',
              }
            },
            shareButton: {
              index: {
                property: 'Property',
                shareProperty: 'Share Property',
              }
            }
          },
          inventoryTypeFilter: {
            index: {
              singleFamily: 'Single Family',
              multiFamily: 'Multi-Family',
            }
          }
        },
        show: {
          index: {
            backText: 'Inventory'
          },
          components: {
            shareButton: {
              index: {
                property: 'Property',
                shareProperty: 'Share Property',
              }
            }
          }
        }
      },
      deals: {
        list: {
          index: {
            title: 'Deals',
            searchBar: {
              placeholder: 'Search deals...'
            }
          },
          listView: {
            listItem: {
              index: {
                preApproval: 'Pre Approval',
                backText: 'Deals'
              }
            }
          }
        },
        show: {
          index: {
            title: 'Deal',
            backText: 'Deals'
          }
        }
      },
      messages: {
        list: {
          index: {
            title: 'Messages',
            searchBar: {
              placeholder: 'Search messages...'
            }
          },
        },
        show: {
          index: {
            title: 'Message',
            backText: 'Messages',
            buttons: {
              sendMessage: 'Send Message'
            }
          }
        }
      }
    },
    myProfile: {
      show: {
        index: {
          title: 'My Profile'
        }
      },
      edit: {
        index: {
          title: 'Edit My Profile',
          backText: 'My Profile',
          messages: {
            updated: 'Your info has been successfully updated!',
          }
        }
      }
    }
  },
  layout: {
    admin: {
      topBar: {
        viewSite: 'View Site',
        previewNewUi: 'Preview New UI',
      },
      userMenuDropdown: {
        index: {
          logout: 'Log Out',
          myProfile: 'My Profile',
        }
      },
      familyScenarioSelect: {
        singleFamily: 'Single Family Homes',
        multiFamily: 'Multi Family Homes'
      },
      sidebar: {
        index: {
          menus: {
            overview: 'Overview',
            attributionReport: 'Attribution Report',
            salesLeaderboard: 'Sales Leaderboard',
            settings: {
              title: 'Settings',
              subMenus: {
                companies: 'Companies',
                myCompany: 'Company',
                users: 'Users',
                teams: 'Teams',
                divisions: 'Divisions',
                mortgageRate: 'Mortgage',
                taxRates: 'Tax Rates',
                cities: 'Cities',
                propertyTaxRates: 'Property Tax Rates',
                developerApps: 'Developer Apps'
              }
            },
            dashboard: 'Ownly Dashboard',
            customers: 'Customers',
            applicants: 'Applicants',
            integrations: 'Integrations',
            documents: 'Documents',
            messages: 'Messages',
            homes: 'Homes'
          }
        },
        singleFamilyMenu: {
          index: {
            title: 'Single Family'
          }
        },
        multiFamilyMenu: {
          index: {
            title: 'Multi-Family'
          }
        },
        singleFamilySideBar: {
          menus: {
            communities: 'Communities',
            productTypes: 'Product Types',
            models: 'Models',
            palettes: 'Palettes',
            packages: 'Packages',
            inventory: 'Inventory'
          }
        },
        multiFamilySideBar: {
          menus: {
            projects: 'Projects',
            buildings: 'Buildings',
            buildingModels: 'Models',
            options: 'Options',
            optionTypes: 'Option Types',
            palettes: 'Palettes',
            packages: 'Packages',
            units: 'Inventory'
          }
        },
        salesMenu: {
          index: {
            title: 'Sales',
            menus: {
              deals: 'Deals',
              contracts: 'Contracts',
              deposits: 'Deposits'
            }
          }
        },
        insightsMenu: {
          index: {
            title: 'Insights',
            menus: {
              marketingReport: 'Marketing Report',
              verifiedReport: 'Verified Report',
              reservationsReport: 'Reservations Report',
              salesLeaderboard: 'Sales Leaderboard',
              attributionReport: 'Attribution Report',
              inventoryInsights: 'Inventory Insights',
            },
          },
        }
      }
    },
    sales: {
      bottomBar: {
        index: {
          main: 'Main',
          customers: 'Customers',
          inventory: 'Inventory',
          deals: 'Deals',
          messages: 'Messages',
        }
      }
    }
  },
  utils: {
    userAgentUtils: {
      pc: 'PC'
    },
    customerUtils: {
      noBuilds: 'No Builds',
      builds: '%{buildsCount} builds',
      notVerified: 'Not Verified'
    },
    dateUtils: {
      hours: '%{hours}h',
      minutes: '%{minutes}m',
      seconds: '%{seconds}s',
    },
    auditUtils: {
      ownlySupport: 'Ownly Support'
    },
    companyUtils: {
      buyerReserveSteps: {
        offer: 'Deal',
        sign: 'Sign',
        deposit: 'Deposit',
        realtorQuestion: 'Realtor Question',
        multipleReservations: 'Multiple Reservations'
      },
      rentalReserveSteps: {
        offer: 'Deal',
        sign: 'Sign',
        deposit: 'Pay',
        multipleReservations: 'Multiple Reservations'
      }
    },
    homeUtils: {
      lotName: 'Lot %{name}'
    },
    reserveNowUtils: {
      offerJourneyLabels: {
        pending: 'Deal',
        submitted: 'Deal Submitted',
        accepted: 'Deal Accepted',
        countered: 'Deal Countered',
        recountered: 'Recounter Pending',
        rejected: 'Deal Rejected',
        declined: 'Deal Declined',
      },
      depositJourneyLabels: {
        pending: 'Deposit',
        submitted: 'Deposit Submitted',
        accepted: 'Deposit Confirmed',
        rejected: 'Deposit Problem',
        partialRefund: 'Deposit Partially Refunded',
        refunded: 'Deposit Refunded'
      },
      signJourneyLabels: {
        pending: 'Sign',
        submitted: 'Document Signed',
        accepted: 'Document Confirmed',
        rejected: 'Signature Problem',
      }
    }
  },
  labels: {
    required: 'Required',
    optional: 'Optional',
    on: 'On'
  },
  messages: {
    publish: 'Are you sure you want to publish %{itemName}?',
    unpublish: 'Are you sure you want to un-publish %{itemName}?',
    linkCopied: 'Link has been copied to clipboard.',
    copied: 'Copied to clipboard.',
    noDomainAvailable: 'No Domain Available',
  },
  common: {
    hours: 'Hours',
    days: 'Days',
    emptyCommunities: 'There\'s no communities',
    emptyProjects: 'There\'s no projects',
    emptyCommunitiesProjects: 'There are no communities or projects',
    emptyModels: 'There\'s no models',
    previous: 'Previous: ',
    noPreviousData: 'No previous data',
    sqft: 'sqft',
    preApproval: 'Pre Approval'
  },
  identityManualChecks: {
    nameMatches: 'Name matches the profile',
    dobMatches: 'Date of birth matches',
    idClearAndUnexpired: 'ID is clear and unexpired',
    faceMatches: 'Face matches selfie/document photo',
  }
};
